import classnames from 'classnames';
import type { JSX } from 'react';

import styles from './Iconography.module.scss';

export interface IconFunction {
  (color: string, size: number | string, testId: string): JSX.Element;
}

export interface IconCategory {
  [key: string]: IconFunction;
}

export interface Icons {
  [categoryName: string]: IconCategory;
}

export const icons: Icons = {
  global: {
    user: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="user"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44 22C44 28.6274 38.6274 34 32 34C25.3726 34 20 28.6274 20 22C20 15.3726 25.3726 10 32 10C38.6274 10 44 15.3726 44 22ZM42 22C42 27.5228 37.5228 32 32 32C26.4772 32 22 27.5228 22 22C22 16.4772 26.4772 12 32 12C37.5228 12 42 16.4772 42 22Z"
          fill="none"
        />
        <path
          className={color}
          d="M31.0437 38C27.8276 38 15.3458 38.9814 9.1045 51.5554C8.85895 52.0501 9.06092 52.6502 9.55562 52.8957C10.0503 53.1413 10.6504 52.9393 10.8959 52.4446C16.6112 40.9304 28.0424 40 31.0437 40H32.9567C35.2463 40 45.788 40.7466 51.9612 50.4344L51.9956 50.4884L52.0366 50.5375C52.2218 50.7596 52.3679 50.9893 52.5364 51.2812C52.5804 51.3575 52.6278 51.4414 52.6785 51.5312C52.8125 51.7686 52.9703 52.0479 53.1524 52.3391C53.4452 52.8073 54.0622 52.9495 54.5305 52.6567C54.9987 52.3638 55.1409 51.7468 54.8481 51.2786C54.691 51.0274 54.5689 50.8111 54.4429 50.5879C54.3867 50.4883 54.3296 50.3873 54.2684 50.2813C54.0875 49.9679 53.8863 49.6415 53.6149 49.308C46.8707 38.7802 35.4458 38 32.9567 38H31.0437Z"
          fill="none"
        />
      </svg>
    ),
    users: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="users"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25 32C31.6274 32 37 26.6274 37 20C37 13.3726 31.6274 8 25 8C18.3726 8 13 13.3726 13 20C13 26.6274 18.3726 32 25 32ZM25 30C30.5228 30 35 25.5228 35 20C35 14.4772 30.5228 10 25 10C19.4772 10 15 14.4772 15 20C15 25.5228 19.4772 30 25 30Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.99317 39.2313C11.9622 36.5317 15.592 35.8359 18.0648 36.0306C18.2015 36.0414 18.3345 36.0801 18.4556 36.1445C24.4488 39.3298 30.3201 37.4582 32.4363 36.1728C32.6034 36.0713 32.7967 36.021 32.9921 36.0282C39.1702 36.2546 42.844 39.3592 44.8537 43.1491C46.8281 46.8722 47.1862 51.2172 46.9246 54.0906C46.8777 54.6056 46.4459 54.9999 45.9287 54.9999H5.01299C4.47147 54.9999 4.02835 54.5689 4.01337 54.0276C3.80782 46.599 5.99522 41.9572 8.99317 39.2313ZM6.00002 52.9999H44.9892C45.078 50.4421 44.6373 47.01 43.0868 44.0861C41.4096 40.9232 38.4252 38.3187 33.2042 38.0397C30.5134 39.5448 24.1946 41.357 17.7095 38.0114C15.6934 37.9045 12.753 38.5158 10.3386 40.711C7.98938 42.8471 6.01402 46.5982 6.00002 52.9999Z"
          fill="none"
        />
        <path
          className={color}
          d="M50.1146 55C50.1146 55 50.7534 50.1216 49.4389 45.2202C48.0184 39.9271 42.8005 35.9578 42.8005 35.9578H44.9592C53.2653 35.9578 60 42.4009 60 50.3458V53.4645C60 54.3121 59.2809 55 58.395 55H50.1146Z"
          fill="none"
        />
        <path
          className={color}
          d="M37.6467 33.0094C44.6543 32.7775 50.2751 27.268 50.2751 20.5085C50.2751 13.6001 44.4232 8 37.2021 8C35.8057 8 35 8.41153 35 8.41153C35 8.41153 40.6144 13.0304 40.6144 20.1554C40.6144 28.0312 35.2969 32.3353 35.2969 32.3353C35.2969 32.3353 35.9084 32.4766 36.5103 32.6486C37.0962 32.8159 37.6467 33.0094 37.6467 33.0094Z"
          fill="none"
        />
      </svg>
    ),
    key: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="key"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.747 15.3556C27.9153 15.2521 28.0922 15.1631 28.2757 15.0897L30.2173 14.3131C31.3616 13.8553 32.6383 13.8553 33.7826 14.3131L35.6756 15.0703C35.8913 15.1565 36.0979 15.264 36.2923 15.3912C39.2309 17.3125 37.8353 21.881 34.3246 21.8323L29.5133 21.7655C26.0481 21.7173 24.7956 17.1719 27.747 15.3556ZM34.3468 20.2324L29.5355 20.1656C27.6719 20.1397 26.9982 17.6951 28.5856 16.7183C28.6761 16.6626 28.7712 16.6147 28.8699 16.5753L30.8115 15.7986C31.5744 15.4935 32.4255 15.4935 33.1884 15.7986L35.0814 16.5558C35.1987 16.6027 35.311 16.6612 35.4167 16.7303C37.0144 17.775 36.2556 20.259 34.3468 20.2324Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.92 39.0968L36.8 36V31.8696C41.4909 29.9707 44.8 25.3718 44.8 20C44.8 12.9308 39.0692 8 32 8C24.9307 8 19.2 12.9308 19.2 20C19.2 25.3718 22.509 29.9708 27.2 31.8696V51.8452L32 56.8L36.8 52V48.8L33.92 45.6L36.8 42.4L33.92 39.0968ZM36.1997 30.3865L35.2 30.7911V35.371L31.7671 39.0622L34.6626 42.3832L31.7674 45.6L35.2 49.414V51.3373L32.0181 54.5192L28.8 51.1972V30.7911L27.8003 30.3865C23.6928 28.7238 20.8 24.6978 20.8 20C20.8 13.9473 25.6753 9.6 32 9.6C38.3246 9.6 43.2 13.9473 43.2 20C43.2 24.6978 40.3071 28.7238 36.1997 30.3865Z"
          fill="none"
        />
      </svg>
    ),
    hide: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="hide"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7977 13.2881C12.1909 12.9002 12.824 12.9045 13.2119 13.2977L49.7119 50.2977C50.0998 50.6909 50.0955 51.324 49.7023 51.7119C49.3091 52.0998 48.676 52.0955 48.2881 51.7023L41.617 44.9398C36.7774 46.9842 31.2244 47.7733 25.3293 46.0704C19.423 44.3642 13.2797 40.1875 7.21445 32.4879C6.93468 32.1328 6.92801 31.6341 7.19818 31.2716C9.7236 27.883 13.5426 24.0704 18.2362 21.2387L11.7881 14.7023C11.4002 14.3091 11.4045 13.676 11.7977 13.2881ZM19.6833 22.7056C15.3387 25.24 11.7364 28.6995 9.2685 31.8556C14.9829 38.9241 20.6277 42.6305 25.8844 44.1489C30.9706 45.6182 35.7878 45.0666 40.0961 43.398L35.7989 39.042C34.6681 39.6532 33.3734 40 32 40C27.5817 40 24 36.4183 24 32C24 30.5881 24.3666 29.2591 25.0104 28.1057L19.6833 22.7056ZM26.4945 29.6102C26.1765 30.3417 26 31.1493 26 32C26 35.3137 28.6863 38 32 38C32.8215 38 33.6031 37.8354 34.3147 37.5375L26.4945 29.6102Z"
          fill="none"
        />
        <path
          className={color}
          d="M25.299 20.1638L26.2798 19.8672C30.541 18.6727 35.2099 18.59 40.0705 20.394C44.7941 22.1472 49.7661 25.7077 54.7433 31.8945C52.4462 34.9665 49.1164 38.3242 45.0763 40.8719C44.6092 41.1664 44.4693 41.784 44.7639 42.2511C45.0585 42.7183 45.676 42.8582 46.1431 42.5636C50.7012 39.6893 54.3839 35.8596 56.8143 32.4495C57.0716 32.0886 57.0605 31.6013 56.7872 31.2524C51.4829 24.4823 46.063 20.4848 40.7665 18.519C35.4621 16.5503 30.3534 16.6463 25.7297 17.9443C25.3808 18.0422 25.0348 18.147 24.6917 18.2582C24.343 18.3712 23.9974 18.4908 23.655 18.6167C23.1366 18.8072 22.8709 19.3819 23.0614 19.9003C23.252 20.4187 23.8266 20.6844 24.345 20.4939C24.6606 20.3779 24.9786 20.2677 25.299 20.1638Z"
          fill="none"
        />
        <path
          className={color}
          d="M29.8572 26.3936C30.5214 26.1396 31.2432 26 32 26C35.3137 26 38 28.6863 38 32C38 32.8202 37.836 33.5995 37.5399 34.3089C37.3272 34.8186 37.5679 35.4042 38.0776 35.6169C38.5873 35.8296 39.1729 35.5889 39.3856 35.0792C39.7817 34.1301 40 33.0893 40 32C40 27.5817 36.4183 24 32 24C30.9952 24 30.0314 24.1857 29.1428 24.5256C28.6269 24.7229 28.3687 25.301 28.566 25.8169C28.7633 26.3327 29.3414 26.5909 29.8572 26.3936Z"
          fill="none"
        />
      </svg>
    ),
    show: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="show"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39 32C39 35.866 35.866 39 32 39C28.134 39 25 35.866 25 32C25 28.134 28.134 25 32 25C35.866 25 39 28.134 39 32ZM37 32C37 34.7614 34.7614 37 32 37C29.2386 37 27 34.7614 27 32C27 29.2386 29.2386 27 32 27C34.7614 27 37 29.2386 37 32Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.7872 31.2524C51.787 24.8704 46.6841 20.9521 41.6773 18.8767C36.6625 16.7981 31.8009 16.5923 27.3359 17.5471C18.4515 19.4469 11.1834 25.9243 7.19818 31.2715C6.92801 31.6341 6.93468 32.1328 7.21445 32.4879C17.4781 45.5172 27.942 48.4069 36.9237 46.4419C45.7821 44.504 52.9311 37.8981 56.8143 32.4495C57.0716 32.0885 57.0605 31.6013 56.7872 31.2524ZM36.4963 44.4882C28.5494 46.2267 18.9983 43.8918 9.26848 31.8555C13.1636 26.874 19.8344 21.1964 27.7541 19.5029C31.8541 18.6261 36.3 18.8128 40.9115 20.7243C45.3816 22.5772 50.0601 26.0732 54.7433 31.8945C50.946 36.9733 44.3825 42.7629 36.4963 44.4882Z"
          fill="none"
        />
      </svg>
    ),
    globe: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="globe"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.035 57.4759C45.826 57.457 57 46.2714 57 32.476C57 18.6688 45.8071 7.47595 32 7.47595C18.1929 7.47595 7 18.6688 7 32.476C7 46.2715 18.1741 57.4571 31.9652 57.4759C31.9768 57.476 31.9884 57.476 32.0001 57.476C32.0117 57.476 32.0234 57.476 32.035 57.4759ZM26.7733 54.8795C24.6702 52.6595 22.924 49.1417 21.7669 44.819C18.9734 45.4244 16.4785 46.2676 14.4018 47.2857C17.5467 51.0188 21.8576 53.7372 26.7733 54.8795ZM13.1592 45.6711C15.4586 44.4973 18.2207 43.5444 21.2981 42.8742C20.7065 40.1292 20.3419 37.1173 20.2554 33.9467H9.04627C9.32056 38.2931 10.802 42.3117 13.1592 45.6711ZM9.00597 31.9467H20.2379C20.2723 28.4308 20.6482 25.0932 21.2981 22.0779C18.2207 21.4076 15.4585 20.4548 13.1591 19.2809C10.6327 22.8816 9.11224 27.2396 9.00597 31.9467ZM14.4017 17.6663C16.4784 18.6844 18.9734 19.5277 21.7669 20.133C22.924 15.8103 24.6703 12.2923 26.7735 10.0724C21.8577 11.2146 17.5466 13.9331 14.4017 17.6663ZM49.598 47.2859C46.4532 51.0189 42.1423 53.7372 37.2268 54.8794C39.3299 52.6595 41.0761 49.1418 42.2332 44.8192C45.0266 45.4246 47.5214 46.2678 49.598 47.2859ZM50.8407 45.6714C48.5413 44.4975 45.7793 43.5446 42.702 42.8744C43.2936 40.1294 43.6582 37.1173 43.7447 33.9467H54.9537C54.6794 38.2932 53.1979 42.3119 50.8407 45.6714ZM54.994 31.9467H43.7622C43.7278 28.4307 43.3519 25.0931 42.702 22.0777C45.7793 21.4074 48.5414 20.4545 50.8407 19.2806C53.3673 22.8814 54.8878 27.2395 54.994 31.9467ZM49.5981 17.6661C47.5215 18.6842 45.0266 19.5275 42.2332 20.1329C41.076 15.8102 39.3298 12.2923 37.2266 10.0724C42.1423 11.2147 46.4532 13.933 49.5981 17.6661ZM38.5093 49.3021C39.183 47.8706 39.7754 46.2368 40.2638 44.4407C37.8481 44.0335 35.2474 43.7986 32.5293 43.7716V55.4354C34.4353 55.1455 36.634 53.2871 38.5093 49.3021ZM25.4908 49.3021C24.8171 47.8706 24.2247 46.2367 23.7363 44.4405C25.8717 44.0807 28.1516 43.8554 30.5293 43.7893V55.1708C28.8647 54.4914 27.0639 52.6451 25.4908 49.3021ZM30.5293 41.7886C27.9968 41.8564 25.5563 42.0987 23.2618 42.4926C22.6975 39.887 22.3428 37.0042 22.2561 33.9467H30.5293V41.7886ZM32.5293 33.9467V41.7715C35.3988 41.799 38.1607 42.0502 40.7383 42.4927C41.3026 39.8871 41.6573 37.0043 41.744 33.9467H32.5293ZM40.2638 20.5114C39.7754 18.7153 39.183 17.0815 38.5093 15.65C36.634 11.6649 34.4353 9.80662 32.5293 9.51669V21.1805C35.2474 21.1534 37.8481 20.9186 40.2638 20.5114ZM32.5293 23.1806C35.3988 23.153 38.1607 22.9019 40.7383 22.4594C41.3602 25.3309 41.7275 28.5391 41.7621 31.9467H32.5293V23.1806ZM30.5293 21.1628V9.78132C28.8647 10.4607 27.0639 12.307 25.4908 15.65C24.8171 17.0815 24.2247 18.7154 23.7363 20.5115C25.8717 20.8714 28.1516 21.0967 30.5293 21.1628ZM23.2618 22.4595C25.5563 22.8534 27.9969 23.0956 30.5293 23.1635V31.9467H22.238C22.2726 28.5391 22.6399 25.331 23.2618 22.4595Z"
          fill="white"
        />
      </svg>
    ),
    email: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="email"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 18.7401V46.4145L9.00061 46.4154C9.01061 46.4295 9.02361 46.4452 9.03921 46.4608C9.05482 46.4764 9.07048 46.4894 9.08459 46.4994L9.08545 46.5H54.9146L54.9154 46.4994C54.9295 46.4894 54.9452 46.4764 54.9608 46.4608C54.9764 46.4452 54.9894 46.4295 54.9994 46.4154L55 46.4145V18.7219L33.2492 33.9937C32.1962 34.7331 30.7889 34.7186 29.7513 33.9577L9 18.7401ZM53.2598 17.5L32.1 32.3569C31.749 32.6033 31.2799 32.5985 30.934 32.3449L10.691 17.5H53.2598ZM9 48.5C8 48.5 7 47.5 7 46.5V17.5C7 16.5 8 15.5 9 15.5H55C56 15.5 57 16.5 57 17.5V46.5C57 47.5 56 48.5 55 48.5H9Z"
          fill="white"
        />
      </svg>
    ),
    settings: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="settings"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 19.963C25.3947 19.963 20.04 25.3521 20.04 32C20.04 38.6479 25.3947 44.037 32 44.037C38.6053 44.037 43.96 38.6479 43.96 32C43.96 25.3521 38.6053 19.963 32 19.963ZM21.88 32C21.88 26.3749 26.4109 21.8148 32 21.8148C37.5891 21.8148 42.12 26.3749 42.12 32C42.12 37.6251 37.5891 42.1852 32 42.1852C26.4109 42.1852 21.88 37.6251 21.88 32Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.9668 7.32974C33.2969 6.89036 30.6217 6.88955 28.0284 7.33054C27.7152 7.3838 27.4515 7.59587 27.3307 7.89154L25.6706 11.9568C25.667 11.9655 25.6636 11.9743 25.6603 11.9831C24.4842 15.133 21.3318 16.9995 18.032 16.4758L18.0155 16.4733L13.7821 15.8805C13.4651 15.8361 13.1479 15.9607 12.9446 16.2096C12.0733 17.2765 11.3798 18.3397 10.6957 19.5612C10.0059 20.7929 9.48208 21.9491 9.04604 23.2838C8.94966 23.5788 9.00665 23.9028 9.1978 24.1466L11.854 27.5343C13.9149 30.1627 13.917 33.9295 11.9286 36.5612L11.9271 36.5632L9.27403 40.0315C9.08014 40.285 9.02997 40.6212 9.14136 40.9208C10.0888 43.4694 11.384 45.7611 13.1107 47.8751C13.318 48.1289 13.6434 48.2532 13.9658 48.2016L18.1992 47.524L18.2012 47.5237C21.4046 47.0037 24.571 48.857 25.8319 52.0314L25.8331 52.0345L27.4077 56.0932C27.5259 56.3981 27.7953 56.6175 28.1162 56.6703C30.7861 57.1096 33.4613 57.1105 36.0546 56.6695C36.3735 56.6152 36.6407 56.3965 36.7583 56.0932L38.3356 52.028L38.3397 52.0169C39.5158 48.867 42.6682 47.0005 45.968 47.5242L45.9845 47.5267L50.2179 48.1195C50.5349 48.1639 50.8521 48.0393 51.0554 47.7904C51.9267 46.7235 52.6202 45.6603 53.3043 44.4388C54.001 43.1948 54.5198 41.9573 54.9477 40.7346C55.0525 40.4352 54.9976 40.1026 54.8022 39.8534L52.146 36.4657C50.0855 33.8377 50.0855 30.0776 52.146 27.4497L54.809 23.9685C55.0029 23.715 55.053 23.3788 54.9417 23.0792C53.9942 20.5306 52.699 18.2389 50.9724 16.1249C50.765 15.8711 50.4396 15.7468 50.1172 15.7984L45.8838 16.476L45.8818 16.4763C42.6784 16.9963 39.512 15.143 38.2512 11.9686L38.2499 11.9655L36.6753 7.90676C36.5571 7.60191 36.2877 7.38254 35.9668 7.32974ZM27.3776 12.6481L28.8358 9.07746C30.9006 8.77668 33.0236 8.7763 35.1546 9.07839L36.5385 12.6456L36.5411 12.6521C38.1032 16.5898 42.0739 18.9697 46.1738 18.3047L46.1748 18.3045L49.8788 17.7117C51.2057 19.4144 52.2403 21.2417 53.0354 23.2513L50.6981 26.3068C48.1136 29.6072 48.1148 34.3137 50.7015 37.6128L53.0406 40.596C52.6749 41.5822 52.2453 42.5582 51.7014 43.5294C51.1465 44.5202 50.5986 45.3769 49.9531 46.2128L46.246 45.6936C42.0803 45.0366 38.1003 47.4016 36.6194 51.3598L35.2366 54.9241C33.1752 55.2233 31.0558 55.2232 28.9284 54.9216L27.5445 51.3544L27.5419 51.3479C25.9798 47.4101 22.0082 45.0302 17.9083 45.6955L14.2042 46.2883C12.8773 44.5856 11.8427 42.7583 11.0476 40.7487L13.3882 37.6888L13.3914 37.6846C15.8839 34.388 15.8855 29.6867 13.2985 26.3872L10.9531 23.3959C11.3146 22.3805 11.7439 21.461 12.2986 20.4706C12.8535 19.4798 13.4014 18.6231 14.0469 17.7872L17.7539 18.3064C21.9169 18.963 25.8944 16.6016 27.3776 12.6481Z"
          fill="none"
        />
      </svg>
    ),
    home: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="home"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.2929 8.29289C31.6834 7.90237 32.3166 7.90237 32.7071 8.29289L51.7071 27.2929C51.8946 27.4804 52 27.7348 52 28V55C52 55.5523 51.5523 56 51 56H38.366C37.8137 56 37.366 55.5523 37.366 55V38.2519C37.366 35.116 34.9401 32.6541 32 32.6541C29.0599 32.6541 26.634 35.116 26.634 38.2519V55C26.634 55.5523 26.1863 56 25.634 56H13C12.4477 56 12 55.5523 12 55V28C12 27.7348 12.1054 27.4804 12.2929 27.2929L31.2929 8.29289ZM14 28.4142V54H24.634V38.2519C24.634 34.0795 27.8885 30.6541 32 30.6541C36.1115 30.6541 39.366 34.0795 39.366 38.2519V54H50V28.4142L32 10.4142L14 28.4142Z"
          fill="none"
        />
      </svg>
    ),
    work: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="work"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.1359 13.682C25.7788 13.23 26.6119 13 27.4889 13H36.5111C37.3881 13 38.2212 13.23 38.8641 13.682C39.5156 14.1401 40 14.8582 40 15.75V19H56V45.05C56 48.2617 53.4357 51 50.2562 51H13.7438C10.5643 51 8 48.2617 8 45.05V19H24V15.75C24 14.8582 24.4844 14.1401 25.1359 13.682ZM38 15.75V19H26V15.75C26 15.6418 26.0489 15.4849 26.2863 15.318C26.5323 15.145 26.9437 15 27.4889 15H36.5111C37.0563 15 37.4677 15.145 37.7137 15.318C37.9511 15.4849 38 15.6418 38 15.75ZM10 31V45.05C10 47.2383 11.7482 49 13.7438 49H50.2562C52.2518 49 54 47.2383 54 45.05V31H38.9592C38.87 35.2889 35.9198 39 32 39C28.0802 39 25.13 35.2889 25.0408 31H10ZM10 29H27.0387V30.8C27.0387 34.4272 29.4516 37 32 37C34.5484 37 36.9613 34.4272 36.9613 30.8V29H54V21H10V29Z"
          fill="none"
        />
      </svg>
    ),
    messages: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="messages"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 11C12.7909 11 11 12.7909 11 15V51.6242L18.5942 44.2015C19.7879 43.003 21.5343 42 23.3607 42H48.9963C51.2066 42 52.9979 40.2073 52.9963 37.997L52.9793 14.997C52.9777 12.7891 51.1873 11 48.9794 11H15ZM9 15C9 11.6863 11.6863 9 15 9H48.9794C52.2913 9 54.9769 11.6836 54.9793 14.9956L54.9963 37.9956C54.9988 41.311 52.3117 44 48.9963 44H23.3607C22.2327 44 20.9642 44.6544 20.0074 45.6168L19.9972 45.6269L10.699 54.7151C10.4112 54.9964 9.98292 55.0778 9.61205 54.9217C9.24118 54.7656 9 54.4024 9 54V15Z"
          fill="none"
        />
      </svg>
    ),
    'group-messages': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="group-messages"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M26 18C25.4477 18 25 18.4477 25 19C25 19.5523 25.4477 20 26 20H39C39.5523 20 40 19.5523 40 19C40 18.4477 39.5523 18 39 18H26Z"
          fill="none"
        />
        <path
          className={color}
          d="M26 24C25.4477 24 25 24.4477 25 25C25 25.5523 25.4477 26 26 26H46C46.5523 26 47 25.5523 47 25C47 24.4477 46.5523 24 46 24H26Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50 11C53.3137 11 56 13.6863 56 17V46C56 46.401 55.7604 46.7633 55.3914 46.9202C55.0223 47.0772 54.5952 46.9985 54.3063 46.7203L47.0057 39.6894L47.0004 39.6843C46.309 39.0085 45.3724 38.6049 44.4785 38.6049H25C21.6863 38.6049 19 35.9186 19 32.6049V17C19 13.6863 21.6863 11 25 11H50ZM54 17C54 14.7909 52.2091 13 50 13H25C22.7909 13 21 14.7909 21 17V32.6049C21 34.8141 22.7909 36.6049 25 36.6049H44.4785C45.9453 36.6049 47.3694 37.2496 48.3956 38.2513L48.3984 38.254L54 43.6486V17Z"
          fill="none"
        />
        <path
          className={color}
          d="M14 19C11.7909 19 10 20.7909 10 23V49.6938L15.8203 44.2442L15.8233 44.2414C16.8762 43.2423 18.3308 42.6049 19.8221 42.6049H38.411C38.9633 42.6049 39.411 43.0527 39.411 43.6049C39.411 44.1572 38.9633 44.6049 38.411 44.6049H19.8221C18.8853 44.6049 17.9118 45.0157 17.1981 45.694L17.1927 45.6991L9.68347 52.73C9.39259 53.0023 8.96777 53.076 8.60218 52.9175C8.23658 52.7589 8 52.3985 8 52V23C8 19.6863 10.6863 17 14 17H15C15.5523 17 16 17.4477 16 18C16 18.5523 15.5523 19 15 19H14Z"
          fill="none"
        />
      </svg>
    ),
    keypad: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="keypad"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
          fill="none"
        />
        <path
          className={color}
          d="M36 12C36 14.2091 34.2091 16 32 16C29.7909 16 28 14.2091 28 12C28 9.79086 29.7909 8 32 8C34.2091 8 36 9.79086 36 12Z"
          fill="none"
        />
        <path
          className={color}
          d="M56 12C56 14.2091 54.2091 16 52 16C49.7909 16 48 14.2091 48 12C48 9.79086 49.7909 8 52 8C54.2091 8 56 9.79086 56 12Z"
          fill="none"
        />
        <path
          className={color}
          d="M16 32C16 34.2091 14.2091 36 12 36C9.79086 36 8 34.2091 8 32C8 29.7909 9.79086 28 12 28C14.2091 28 16 29.7909 16 32Z"
          fill="none"
        />
        <path
          className={color}
          d="M36 32C36 34.2091 34.2091 36 32 36C29.7909 36 28 34.2091 28 32C28 29.7909 29.7909 28 32 28C34.2091 28 36 29.7909 36 32Z"
          fill="none"
        />
        <path
          className={color}
          d="M56 32C56 34.2091 54.2091 36 52 36C49.7909 36 48 34.2091 48 32C48 29.7909 49.7909 28 52 28C54.2091 28 56 29.7909 56 32Z"
          fill="none"
        />
        <path
          className={color}
          d="M16 52C16 54.2091 14.2091 56 12 56C9.79086 56 8 54.2091 8 52C8 49.7909 9.79086 48 12 48C14.2091 48 16 49.7909 16 52Z"
          fill="none"
        />
        <path
          className={color}
          d="M36 52C36 54.2091 34.2091 56 32 56C29.7909 56 28 54.2091 28 52C28 49.7909 29.7909 48 32 48C34.2091 48 36 49.7909 36 52Z"
          fill="none"
        />
        <path
          className={color}
          d="M56 52C56 54.2091 54.2091 56 52 56C49.7909 56 48 54.2091 48 52C48 49.7909 49.7909 48 52 48C54.2091 48 56 49.7909 56 52Z"
          fill="none"
        />
      </svg>
    ),
    grid: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="grid"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2 11H27.8C28.52 11 29 11.48 29 12.2V27.8C29 28.52 28.52 29 27.8 29H12.2C11.48 29 11 28.52 11 27.8V12.2C11 11.48 11.48 11 12.2 11ZM26.6 26.6V13.4H13.4V26.6H26.6Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2 35H27.8C28.52 35 29 35.48 29 36.2V51.8C29 52.52 28.52 53 27.8 53H12.2C11.48 53 11 52.52 11 51.8V36.2C11 35.48 11.48 35 12.2 35ZM26.6 50.6V37.4H13.4V50.6H26.6Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.8 35H36.2C35.48 35 35 35.48 35 36.2V51.8C35 52.52 35.48 53 36.2 53H51.8C52.52 53 53 52.52 53 51.8V36.2C53 35.48 52.52 35 51.8 35ZM50.6 37.4V50.6H37.4V37.4H50.6Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.2 11H51.8C52.52 11 53 11.48 53 12.2V27.8C53 28.52 52.52 29 51.8 29H36.2C35.48 29 35 28.52 35 27.8V12.2C35 11.48 35.48 11 36.2 11ZM50.6 26.6V13.4H37.4V26.6H50.6Z"
          fill="none"
        />
      </svg>
    ),
    calendar: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="calendar"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M19 33C19 32.4477 19.4477 32 20 32H22C22.5523 32 23 32.4477 23 33V35C23 35.5523 22.5523 36 22 36H20C19.4477 36 19 35.5523 19 35V33Z"
          fill="none"
        />
        <path
          className={color}
          d="M20 42C19.4477 42 19 42.4477 19 43V45C19 45.5523 19.4477 46 20 46H22C22.5523 46 23 45.5523 23 45V43C23 42.4477 22.5523 42 22 42H20Z"
          fill="none"
        />
        <path
          className={color}
          d="M30 33C30 32.4477 30.4477 32 31 32H33C33.5523 32 34 32.4477 34 33V35C34 35.5523 33.5523 36 33 36H31C30.4477 36 30 35.5523 30 35V33Z"
          fill="none"
        />
        <path
          className={color}
          d="M31 42C30.4477 42 30 42.4477 30 43V45C30 45.5523 30.4477 46 31 46H33C33.5523 46 34 45.5523 34 45V43C34 42.4477 33.5523 42 33 42H31Z"
          fill="none"
        />
        <path
          className={color}
          d="M41 33C41 32.4477 41.4477 32 42 32H44C44.5523 32 45 32.4477 45 33V35C45 35.5523 44.5523 36 44 36H42C41.4477 36 41 35.5523 41 35V33Z"
          fill="none"
        />
        <path
          className={color}
          d="M42 42C41.4477 42 41 42.4477 41 43V45C41 45.5523 41.4477 46 42 46H44C44.5523 46 45 45.5523 45 45V43C45 42.4477 44.5523 42 44 42H42Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 8C20.4477 8 20 8.44772 20 9V11H13C11.3431 11 10 12.3431 10 14V52C10 53.6569 11.3431 55 13 55H51C52.6569 55 54 53.6569 54 52V14C54 12.3431 52.6569 11 51 11H44V9C44 8.44772 43.5523 8 43 8C42.4477 8 42 8.44772 42 9V11H22V9C22 8.44772 21.5523 8 21 8ZM52 24V14C52 13.4477 51.5523 13 51 13H44V16C44 16.5523 43.5523 17 43 17C42.4477 17 42 16.5523 42 16V13H22V16C22 16.5523 21.5523 17 21 17C20.4477 17 20 16.5523 20 16V13H13C12.4477 13 12 13.4477 12 14V24H52ZM12 26H52V52C52 52.5523 51.5523 53 51 53H13C12.4477 53 12 52.5523 12 52V26Z"
          fill="none"
        />
      </svg>
    ),
    phone: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="phone"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6254 3.37851C17.8794 3.3585 18.1676 3.42153 18.3781 3.6315L18.5978 3.85069C18.8782 4.11133 19.3388 4.61068 19.7413 5.14605C19.9444 5.41612 20.1383 5.7028 20.288 5.97875C20.4333 6.24646 20.5556 6.53729 20.5818 6.80875C20.7799 8.74735 20.4425 12.2552 16.3587 16.3671L16.3575 16.3683C12.2722 20.4436 8.75489 20.7798 6.84895 20.5818C6.84501 20.5814 6.84108 20.5809 6.83716 20.5804C6.56552 20.5434 6.28029 20.4233 6.01331 20.278C5.74123 20.13 5.46232 19.9414 5.19863 19.7435C4.67135 19.3478 4.18095 18.8968 3.89133 18.6079L3.6294 18.3466C3.41831 18.1361 3.35344 17.8456 3.38099 17.5845C3.40887 17.3203 3.53206 17.0542 3.74165 16.8452C3.76147 16.8254 3.78343 16.8079 3.80713 16.793L7.09277 14.7307C7.35731 14.458 7.83561 14.3538 8.16284 14.6802L10.1539 16.6664C10.4742 16.6003 11.0749 16.3703 11.8034 15.9506C12.5308 15.5314 13.3633 14.9358 14.1409 14.1607C14.9028 13.3639 15.5112 12.5122 15.9464 11.766C16.3876 11.0096 16.6341 10.3903 16.6972 10.0602C16.6985 10.0532 16.7 10.0463 16.7018 10.0394C16.702 10.0385 16.7022 10.0376 16.7024 10.0367L14.7052 8.04446C14.5488 7.88845 14.5054 7.67266 14.5218 7.49298C14.5379 7.31652 14.6125 7.1361 14.7488 6.9863L16.8252 3.76833C16.8443 3.73886 16.8673 3.7122 16.8937 3.68913C17.1046 3.50504 17.3681 3.39878 17.6254 3.37851ZM17.4228 4.22557L15.36 7.42239C15.3455 7.44485 15.3287 7.46569 15.3098 7.48456C15.2854 7.50884 15.2748 7.53254 15.2707 7.54922L17.2555 9.52913C17.4312 9.70437 17.4934 9.95151 17.432 10.2105C17.343 10.6647 17.0479 11.366 16.5943 12.1438C16.132 12.9364 15.488 13.8377 14.6797 14.6824L14.6736 14.6886C13.8431 15.5171 12.9556 16.1523 12.1779 16.6004C11.4188 17.0378 10.7422 17.3097 10.3107 17.3998C10.0546 17.474 9.80925 17.382 9.65376 17.2268L7.65517 15.2331C7.64774 15.237 7.63836 15.2436 7.62927 15.255C7.60307 15.2876 7.57157 15.3157 7.53609 15.338L4.24624 17.4029C4.17307 17.4865 4.13545 17.5817 4.12685 17.6632C4.11698 17.7568 4.14565 17.8023 4.15908 17.8157L4.42101 18.0769C4.69266 18.3479 5.15643 18.7741 5.6488 19.1436C5.89494 19.3284 6.14222 19.4944 6.37178 19.6193C6.60348 19.7453 6.79344 19.8163 6.93292 19.8364C8.621 20.0103 11.9102 19.745 15.8272 15.8379C19.7495 11.8883 20.0115 8.60351 19.8356 6.88397L19.8353 6.88145C19.8239 6.76137 19.7592 6.57684 19.6288 6.33644C19.5026 6.10382 19.3317 5.84925 19.1418 5.59675C18.7611 5.0903 18.3269 4.62204 18.0829 4.39606C18.0795 4.39292 18.0762 4.38971 18.0729 4.38644L17.8484 4.16248C17.8344 4.14849 17.7857 4.11821 17.6843 4.1262C17.599 4.13291 17.5042 4.16629 17.4228 4.22557Z"
          fill="#0F0F0F"
        />
      </svg>
    ),
    unlink: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="unlink"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M40.9662 24.4189C41.3719 24.0132 41.3719 23.3554 40.9662 22.9497C40.5605 22.544 39.9027 22.544 39.497 22.9497L24.0704 38.3764C23.6647 38.7821 23.6647 39.4399 24.0704 39.8456C24.4761 40.2513 25.1339 40.2513 25.5396 39.8456L40.9662 24.4189Z"
          fill="none"
        />
        <path
          className={color}
          d="M48.6185 37.5789C51.0799 40.0403 51.0018 44.3312 48.2249 47.1081C45.4487 49.8844 41.1617 49.9598 38.6997 47.4977L31.2217 40.0198C30.816 39.6141 30.1582 39.6141 29.7525 40.0198C29.3468 40.4255 29.3468 41.0833 29.7525 41.489L37.2305 48.9669C40.6 52.3364 46.2059 52.0655 49.6941 48.5773C53.1816 45.0899 53.4578 39.4799 50.0877 36.1097L42.6097 28.6318C42.204 28.2261 41.5462 28.2261 41.1405 28.6318C40.7348 29.0375 40.7348 29.6953 41.1405 30.101L48.6185 37.5789Z"
          fill="none"
        />
        <path
          className={color}
          d="M26.2394 15.1999C23.778 12.7385 19.4871 12.8165 16.7102 15.5935C13.934 18.3697 13.8586 22.6566 16.3206 25.1187L23.7986 32.5967C24.2043 33.0024 24.2043 33.6601 23.7986 34.0659C23.3929 34.4716 22.7351 34.4716 22.3294 34.0659L14.8514 26.5879C11.4819 23.2184 11.7528 17.6124 15.241 14.1243C18.7285 10.6368 24.3385 10.3605 27.7086 13.7307L35.1866 21.2086C35.5923 21.6143 35.5923 22.2721 35.1866 22.6778C34.7809 23.0835 34.1231 23.0835 33.7174 22.6778L26.2394 15.1999Z"
          fill="none"
        />
      </svg>
    ),
    link: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="link"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M27.7966 15.8708C25.2413 13.3155 20.7867 13.3965 17.9039 16.2793C15.0217 19.1614 14.9434 23.6119 17.4994 26.1678L25.2626 33.931C25.6838 34.3521 25.6838 35.035 25.2626 35.4562C24.8414 35.8774 24.1586 35.8774 23.7374 35.4562L15.9742 27.6931C12.4761 24.1951 12.7574 18.3753 16.3786 14.7541C19.9992 11.1336 25.8232 10.8469 29.3219 14.3455L37.0851 22.1086C37.5063 22.5298 37.5063 23.2127 37.0851 23.6339C36.6639 24.0551 35.981 24.0551 35.5598 23.6339L27.7966 15.8708Z"
          fill="none"
        />
        <path
          className={color}
          d="M49.5035 37.5778C52.0588 40.1331 51.9777 44.5876 49.0949 47.4704C46.2127 50.3525 41.7622 50.4308 39.2063 47.8749L31.443 40.1118C31.0219 39.6906 30.339 39.6906 29.9178 40.1118C29.4966 40.533 29.4966 41.2158 29.9178 41.637L37.681 49.4001C41.179 52.8981 46.9989 52.6169 50.6201 48.9957C54.2407 45.3752 54.5274 39.5512 51.0287 36.0526L43.2655 28.2895C42.8443 27.8683 42.1614 27.8683 41.7402 28.2895C41.3191 28.7107 41.3191 29.3935 41.7402 29.8147L49.5035 37.5778Z"
          fill="none"
        />
        <path
          className={color}
          d="M40.6718 40.5683C41.1621 41.0587 41.9011 41.1148 42.3223 40.6936C42.7435 40.2724 42.6874 39.5335 42.197 39.0431L26.4325 23.2787C25.9421 22.7884 25.2031 22.7323 24.7819 23.1535C24.3607 23.5746 24.4168 24.3136 24.9072 24.804L40.6718 40.5683Z"
          fill="none"
        />
      </svg>
    ),
    'link-external': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="link-external"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16.94 13.4998C13.6594 13.4998 11 16.1861 11 19.4998V47.4998C11 50.8135 13.6594 53.4998 16.94 53.4998H44.66C47.9406 53.4998 50.6 50.8135 50.6 47.4998V30.9998C50.6 30.4475 50.1568 29.9998 49.61 29.9998C49.0633 29.9998 48.62 30.4475 48.62 30.9998V47.4998C48.62 49.7089 46.8471 51.4998 44.66 51.4998H16.94C14.7529 51.4998 12.98 49.7089 12.98 47.4998V19.4998C12.98 17.2906 14.7529 15.4998 16.94 15.4998H34C34.5467 15.4998 34.99 15.052 34.99 14.4998C34.99 13.9475 34.5467 13.4998 34 13.4998H16.94Z"
          fill="white"
        />
        <path
          className={color}
          d="M54.6 7.5C55.1523 7.5 55.6523 7.72386 56.0143 8.08579C56.3762 8.44772 56.6 8.94772 56.6 9.5V25.4706C56.6 26.0228 56.1523 26.4706 55.6 26.4706C55.0477 26.4706 54.6 26.0228 54.6 25.4706V10.9142L33.1087 32.4056C32.7181 32.7961 32.085 32.7961 31.6945 32.4056C31.3039 32.0151 31.3039 31.3819 31.6945 30.9914L53.1858 9.5L38.6295 9.5C38.0772 9.5 37.6295 9.05228 37.6295 8.5C37.6295 7.94772 38.0772 7.5 38.6295 7.5L54.6 7.5Z"
          fill="white"
        />
      </svg>
    ),
    logout: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="logout"
        className={color}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M40 44V50.7C40 53.6 37.6 56 34.7 56H16C13 56 10.7 53.6 10.7 50.7V13.3C10.7 10.4 13 8 16 8H34.7C37.6 8 40 10.4 40 13.3V21.5M29.3 32H56M56 32L49.3 25.3M56 32L49.3 38.7" />
      </svg>
    ),
    search: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="search"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 12C19.7157 12 13 18.7157 13 27C13 35.2843 19.7157 42 28 42C31.5271 42 34.7698 40.7827 37.331 38.7452L50.2929 51.7071C50.6834 52.0976 51.3166 52.0976 51.7071 51.7071C52.0976 51.3166 52.0976 50.6834 51.7071 50.2929L38.8117 37.3975C41.4054 34.7011 43 31.0368 43 27C43 18.7157 36.2843 12 28 12ZM15 27C15 19.8203 20.8203 14 28 14C35.1797 14 41 19.8203 41 27C41 34.1797 35.1797 40 28 40C20.8203 40 15 34.1797 15 27Z"
          fill="none"
        />
      </svg>
    ),
    unlock: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="unlock"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M33.7875 40.3441C34.7004 39.9855 35.2482 39.1786 35.2482 38.1924C35.2482 36.9372 34.1527 35.8613 32.8746 35.8613C31.5965 35.8613 30.5011 36.9372 30.5011 38.1924C30.5011 39.1786 31.1401 39.9855 31.9617 40.3441L30.6836 45.2753C30.5924 45.6339 30.8662 45.9029 31.2314 45.9029H34.4265C34.7917 45.9029 35.0656 45.5442 34.9743 45.2753L33.7875 40.3441Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.1146 8.53518C41.4514 3.85553 34.1503 3.84287 29.637 8.37214L25.9893 12.0326C25.5988 12.4245 25.5988 13.0599 25.9893 13.4518C26.3798 13.8437 27.013 13.8437 27.4035 13.4518L31.0512 9.79134C34.7644 6.06501 40.799 6.03926 44.7004 9.95438C48.5822 13.8498 48.4371 19.7466 44.7043 23.4926L41.3076 26.9013H15.9674C15.4332 26.9013 15.0001 27.3473 15.0001 27.8974V51.6202C15.0001 53.563 16.5655 55 18.282 55H46.7182C48.6047 55 50.0001 53.3879 50.0001 51.6202V27.8974C50.0001 27.3473 49.567 26.9013 49.0328 26.9013H44.136L46.1185 24.9118C50.6122 20.4022 50.7974 13.2345 46.1146 8.53518ZM16.9348 28.8936V51.6202C16.9348 52.4016 17.5737 53.0077 18.282 53.0077H46.7182C47.477 53.0077 48.0655 52.3496 48.0655 51.6202V28.8936H16.9348Z"
          fill="none"
        />
      </svg>
    ),
    lock: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="lock"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M33.7875 40.3384C34.7004 39.9796 35.2482 39.1724 35.2482 38.1858C35.2482 36.9301 34.1527 35.8538 32.8746 35.8538C31.5965 35.8538 30.5011 36.9301 30.5011 38.1858C30.5011 39.1724 31.1401 39.9796 31.9617 40.3384L30.6836 45.2715C30.5924 45.6302 30.8662 45.8993 31.2314 45.8993H34.4265C34.7917 45.8993 35.0656 45.5405 34.9743 45.2715L33.7875 40.3384Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.7665 10C26.1717 10 21.0001 15.1739 21.0001 21.5818L21.0001 26.7606C21.0001 26.8045 21.0029 26.8478 21.0084 26.8902H15.9674C15.4332 26.8902 15.0001 27.3364 15.0001 27.8868V51.6189C15.0001 53.5624 16.5655 55 18.282 55H46.7182C48.6047 55 50.0001 53.3873 50.0001 51.6189V27.8868C50.0001 27.3364 49.567 26.8902 49.0328 26.8902H44.2798C44.2986 26.8134 44.3085 26.733 44.3085 26.6504V21.5818C44.3085 15.2018 39.389 10 32.7665 10ZM42.3373 26.8902C42.3185 26.8134 42.3085 26.733 42.3085 26.6504V21.5818C42.3085 16.2821 38.2561 12.0078 32.7665 12.0078C27.2491 12.0078 23.0001 16.3099 23.0001 21.5818L23.0001 26.7606C23.0001 26.8045 22.9973 26.8478 22.9919 26.8902H42.3373ZM16.9348 28.8834V51.6189C16.9348 52.4005 17.5737 53.0069 18.282 53.0069H46.7182C47.477 53.0069 48.0655 52.3486 48.0655 51.6189V28.8834H16.9348Z"
          fill="none"
        />
      </svg>
    ),
    'owners-manual': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="owners-manual"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M22 43C21.4477 43 21 43.4477 21 44C21 44.5523 21.4477 45 22 45H42C42.5523 45 43 44.5523 43 44C43 43.4477 42.5523 43 42 43H22Z"
          fill="none"
        />
        <path
          className={color}
          d="M21 50C21 49.4477 21.4477 49 22 49H42C42.5523 49 43 49.4477 43 50C43 50.5523 42.5523 51 42 51H22C21.4477 51 21 50.5523 21 50Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 8C13.8954 8 13 8.85961 13 9.92V54.08C13 55.1404 13.8954 56 15 56H49C50.1046 56 51 55.1404 51 54.08V9.92C51 8.85961 50.1046 8 49 8H15ZM44.9968 9.92H49V54.08H15V9.92L31.0032 9.92C31.0011 9.94639 31 9.97307 31 10V25.5054C31 26.2758 31.8344 26.7568 32.5011 26.3708L37.4989 23.4768C37.8089 23.2973 38.1911 23.2973 38.5011 23.4768L43.4989 26.3708C44.1656 26.7568 45 26.2758 45 25.5054V10C45 9.97307 44.9989 9.94639 44.9968 9.92Z"
          fill="none"
        />
      </svg>
    ),
    image: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="image"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 16.1C18.9477 16.1 16.5 18.5477 16.5 21.6C16.5 24.6523 18.9477 27.1 22 27.1C25.0523 27.1 27.5 24.6523 27.5 21.6C27.5 18.5477 25.0523 16.1 22 16.1ZM18.5 21.6C18.5 19.6523 20.0523 18.1 22 18.1C23.9477 18.1 25.5 19.6523 25.5 21.6C25.5 23.5477 23.9477 25.1 22 25.1C20.0523 25.1 18.5 23.5477 18.5 21.6Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 9C8 8.44772 8.44772 8 9 8H55C55.5523 8 56 8.44772 56 9V55C56 55.5523 55.5523 56 55 56H9C8.44772 56 8 55.5523 8 55V9ZM10 10V41.9H23.8999C25.9688 41.9 27.389 41.4496 28.4557 40.8201C29.536 40.1825 30.3229 39.3221 31.082 38.3747C31.2377 38.1804 31.3939 37.9785 31.5529 37.7728C32.8726 36.0661 34.393 34.1 37.4999 34.1C40.8272 34.1 42.4889 36.326 43.8601 38.1629C43.9197 38.2427 43.9788 38.3218 44.0374 38.4C45.499 40.3488 46.7825 41.9 49.4999 41.9H54V10H10ZM10 54V43.9H23.8999C26.281 43.9 28.0608 43.3754 29.4722 42.5425C30.8701 41.7175 31.8395 40.6279 32.6428 39.6253C32.8152 39.4102 32.9789 39.2021 33.1365 39.0018C34.5129 37.2524 35.4195 36.1 37.4999 36.1C39.8126 36.1 40.9051 37.5567 42.4074 39.5599L42.4374 39.6C43.9008 41.5512 45.7173 43.9 49.4999 43.9H54V54H10Z"
          fill="none"
        />
      </svg>
    ),
    'compose-message': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="compose-message"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M52.5931 15.745L28.403 40.1779C28.2576 40.3263 28.0855 40.4421 27.912 40.5142L25.4192 41.5302L24.8117 41.777C24.0026 42.1057 23.1984 41.2936 23.5237 40.4762L24.7701 37.3419C24.8414 37.1653 24.9575 36.9929 25.1044 36.8431L49.293 12.413C49.7057 11.9962 50.2527 11.8746 50.5157 12.1417L52.8603 14.5085C53.1233 14.7756 53.0044 15.3295 52.5931 15.745Z"
          fill="none"
        />
        <path
          className={color}
          d="M16.94 13C13.6594 13 11 15.6863 11 19V47C11 50.3137 13.6594 53 16.94 53H44.66C47.9406 53 50.6 50.3137 50.6 47V34.5C50.6 33.9477 50.1568 33.5 49.61 33.5C49.0633 33.5 48.62 33.9477 48.62 34.5V47C48.62 49.2091 46.8471 51 44.66 51H16.94C14.753 51 12.98 49.2091 12.98 47V19C12.98 16.7909 14.753 15 16.94 15H36.74C37.2868 15 37.73 14.5523 37.73 14C37.73 13.4477 37.2868 13 36.74 13H16.94Z"
          fill="none"
        />
      </svg>
    ),
    edit: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="edit"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.7137 16.0276L51.263 22.5768L52.3984 21.4414C53.0979 20.7419 53.0772 19.584 52.3524 18.8592L48.4313 14.9383C47.7065 14.2134 46.5485 14.1928 45.849 14.8923L44.7137 16.0276ZM50.5524 24.8169L42.4738 16.7385C42.0517 16.3165 42.0397 15.6433 42.447 15.2361L44.3203 13.3629C45.8334 11.8498 48.3396 11.8944 49.9076 13.4624L53.8286 17.3833C55.3966 18.9513 55.4413 21.4574 53.9281 22.9705L52.0549 24.8437C51.6476 25.2509 50.9755 25.24 50.5524 24.8169ZM20.1631 41.3611L17.6964 49.5943L25.9298 47.1277L20.1631 41.3611ZM21.2475 39.4941L27.7969 46.0433L47.2877 26.553L40.7383 20.0038L21.2475 39.4941ZM15.3588 51.9318C15.0734 51.6463 14.9658 51.2319 15.0783 50.8564L18.5339 39.3225C18.5821 39.1602 18.6696 39.0135 18.7876 38.8955L39.947 17.7367C40.3543 17.3294 41.0274 17.3414 41.4495 17.7634L49.5281 25.8418C49.9512 26.2649 49.9622 26.937 49.5549 27.3443L28.3955 48.5031C28.2774 48.6211 28.1308 48.7087 27.9694 48.7578L16.4343 52.2123C16.0598 52.3258 15.6443 52.2173 15.3588 51.9318Z"
          fill="none"
        />
      </svg>
    ),
    reward: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="reward"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.0051 17.2659C28.39 15.4868 26.1635 15.772 24.8713 16.958C24.2106 17.5643 23.9713 18.1553 24.0028 18.7048C24.0355 19.2758 24.3708 19.994 25.263 20.8129C25.6185 21.1392 26.229 21.4337 27.0388 21.6748C27.8307 21.9106 28.7323 22.0722 29.596 22.1816C30.4564 22.2906 31.2605 22.3454 31.8504 22.3728L31.9096 22.3755C31.8565 21.9832 31.7752 21.4886 31.653 20.9501C31.3548 19.6354 30.8409 18.1864 30.0051 17.2659ZM32.8 19.1178C33.1501 18.0862 33.6609 17.0158 34.4103 16.1904C36.7122 13.6548 39.9687 14.0888 41.8106 15.7792C42.717 16.611 43.2611 17.6381 43.1946 18.7965C43.1294 19.9335 42.4853 21.013 41.4189 21.9917C40.8016 22.5582 39.9246 22.9359 39.0454 23.2H44.8C46.5673 23.2 48 24.6327 48 26.4V28C48 29.1845 47.3565 30.2186 46.4 30.7719V31.2V47.2C46.4 48.9673 44.9673 50.4 43.2 50.4H33.6H32H22.4C20.6327 50.4 19.2 48.9673 19.2 47.2V31.2V30.7719C18.2435 30.2186 17.6 29.1845 17.6 28V26.4C17.6 24.6327 19.0327 23.2 20.8 23.2H26.5546C25.6754 22.9359 24.7984 22.5582 24.1811 21.9917C23.1148 21.013 22.4706 19.9335 22.4054 18.7965C22.339 17.6381 22.883 16.611 23.7894 15.7792C25.6313 14.0888 28.8878 13.6548 31.1898 16.1904C31.9391 17.0158 32.4499 18.0862 32.8 19.1178ZM32 24.8H20.8C19.9164 24.8 19.2 25.5164 19.2 26.4V28C19.2 28.8837 19.9163 29.6 20.8 29.6H32V24.8ZM33.6 48.8H43.2C44.0837 48.8 44.8 48.0837 44.8 47.2L44.8 31.2H33.6V48.8ZM32 31.2L32 48.8H22.4C21.5164 48.8 20.8 48.0837 20.8 47.2L20.8 31.2H32ZM33.6 29.6H44.8C45.6837 29.6 46.4 28.8837 46.4 28V26.4C46.4 25.5164 45.6837 24.8 44.8 24.8H33.6V29.6ZM40.7287 16.958C39.4365 15.772 37.2101 15.4868 35.5949 17.2659C34.7592 18.1864 34.2452 19.6354 33.947 20.9501C33.8249 21.4886 33.7435 21.9832 33.6904 22.3755L33.7496 22.3728C34.3396 22.3454 35.1436 22.2906 36.004 22.1816C36.8677 22.0722 37.7694 21.9106 38.5613 21.6748C39.3711 21.4337 39.9815 21.1392 40.337 20.8129C41.2292 19.994 41.5645 19.2758 41.5972 18.7048C41.6288 18.1553 41.3894 17.5643 40.7287 16.958Z"
          fill="none"
        />
      </svg>
    ),
    inbox: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="inbox"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M17.4884 14V13.1442C17.1642 13.1442 16.8679 13.3273 16.7229 13.6173L17.4884 14ZM47.4419 14L48.1849 13.5754C48.0325 13.3087 47.749 13.1442 47.4419 13.1442V14ZM56 28.9767H56.8558V28.7495L56.7431 28.5521L56 28.9767ZM10 28.9767L9.23454 28.594L9.14419 28.7747V28.9767H10ZM10 48.2326H9.14419C9.14419 48.7052 9.52735 49.0884 10 49.0884V48.2326ZM56 48.2326V49.0884C56.4727 49.0884 56.8558 48.7052 56.8558 48.2326H56ZM23.907 28.9767L24.7299 28.7416C24.6249 28.3742 24.2891 28.1209 23.907 28.1209V28.9767ZM43.1628 28.9767V28.1209C42.7277 28.1209 42.3619 28.4473 42.3125 28.8796L43.1628 28.9767ZM17.4884 14.8558H47.4419V13.1442H17.4884V14.8558ZM46.6988 14.4246L55.2569 29.4013L56.7431 28.5521L48.1849 13.5754L46.6988 14.4246ZM10.7655 29.3595L18.2538 14.3827L16.7229 13.6173L9.23454 28.594L10.7655 29.3595ZM9.14419 28.9767V48.2326H10.8558V28.9767H9.14419ZM10 49.0884H56V47.3767H10V49.0884ZM56.8558 48.2326V28.9767H55.1442V48.2326H56.8558ZM23.907 28.1209H10V29.8326H23.907V28.1209ZM56 28.1209H43.1628V29.8326H56V28.1209ZM23.907 28.9767C23.0841 29.2119 23.0842 29.2123 23.0843 29.2127C23.0844 29.2129 23.0845 29.2133 23.0846 29.2137C23.0848 29.2144 23.0851 29.2153 23.0853 29.2162C23.0859 29.2181 23.0866 29.2205 23.0874 29.2233C23.0891 29.2289 23.0913 29.2364 23.094 29.2455C23.0996 29.2639 23.1074 29.2892 23.1175 29.321C23.1378 29.3846 23.1676 29.4743 23.2076 29.5864C23.2876 29.8104 23.409 30.1248 23.5785 30.4995C23.9167 31.247 24.4515 32.2463 25.2398 33.2497C26.8248 35.2669 29.4588 37.3209 33.5349 37.3209V35.6093C30.1226 35.6093 27.9426 33.9191 26.5857 32.1922C25.9032 31.3235 25.4351 30.4507 25.138 29.7941C24.99 29.4668 24.8857 29.1962 24.8195 29.0107C24.7864 28.918 24.7629 28.8468 24.7482 28.8007C24.7408 28.7777 24.7357 28.7609 24.7326 28.7509C24.7311 28.7459 24.7302 28.7426 24.7297 28.741C24.7295 28.7403 24.7294 28.7399 24.7294 28.74C24.7294 28.7401 24.7295 28.7402 24.7295 28.7405C24.7296 28.7406 24.7297 28.7409 24.7297 28.741C24.7298 28.7413 24.7299 28.7416 23.907 28.9767ZM33.5349 37.3209C38.2138 37.3209 40.8769 35.3012 42.3395 33.2117C43.0578 32.1856 43.4731 31.1637 43.7096 30.3999C43.8281 30.0168 43.9028 29.6949 43.9484 29.4647C43.9712 29.3495 43.9868 29.2568 43.997 29.1906C44.0021 29.1574 44.0058 29.1308 44.0084 29.1112C44.0097 29.1014 44.0107 29.0934 44.0115 29.0871C44.0119 29.084 44.0122 29.0814 44.0125 29.0792C44.0126 29.078 44.0127 29.0771 44.0128 29.0762C44.0129 29.0758 44.0129 29.0752 44.013 29.075C44.013 29.0744 44.0131 29.0739 43.1628 28.9767C42.3125 28.8796 42.3126 28.8791 42.3126 28.8787C42.3126 28.8786 42.3127 28.8782 42.3127 28.878C42.3127 28.8776 42.3128 28.8773 42.3128 28.8771C42.3129 28.8767 42.3128 28.8767 42.3128 28.8772C42.3127 28.8782 42.3123 28.8809 42.3117 28.8852C42.3106 28.894 42.3084 28.9094 42.3051 28.9311C42.2985 28.9745 42.2871 29.0428 42.2694 29.1323C42.2339 29.3116 42.1732 29.5748 42.0745 29.8938C41.8763 30.534 41.5294 31.3842 40.9373 32.2302C39.779 33.8849 37.628 35.6093 33.5349 35.6093V37.3209Z"
          fill="none"
        />
      </svg>
    ),
    favorite: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="favorite"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M21.6065 14C23.6065 14 25.5065 14.7 27.3065 16.2C27.7065 16.6 28.2065 17 28.6065 17.5C28.8065 17.7 29.0065 17.9 29.2065 18.2C29.5065 18.5 29.7065 18.8 30.0065 19.1L30.4065 19.5L32.0065 20.9L33.4065 19.4C33.7065 19.1 34.0065 18.7 34.3065 18.4C34.9065 17.8 35.5065 17.1 36.1065 16.6C37.9065 14.9 40.1065 14 42.4065 14C44.3065 14 46.1065 14.6 47.7065 15.7C49.9065 17.2 51.2065 19.3 51.7065 22.1C52.3065 25.3 51.5065 28.1 49.4065 30.5C47.7065 32.5 38.0065 42.5 32.9065 48L31.9065 49.1C28.5065 45.4 19.5065 35.9 15.0065 31.2C13.4065 29.6 12.5065 27.8 12.2065 25.8C11.3065 20.8 14.0065 16 18.6065 14.5C19.6065 14.2 20.6065 14 21.6065 14ZM21.6065 12C20.4065 12 19.2065 12.2 17.9065 12.6C12.5065 14.4 9.10648 20 10.2065 26.2C10.6065 28.7 11.8065 30.8 13.6065 32.6C19.2065 38.5 31.9065 52 31.9065 52C35.5065 48.2 48.9065 34.3 51.0065 31.9C53.5065 29 54.4065 25.6 53.8065 21.9C53.2065 18.7 51.7065 16 49.0065 14.1C47.0065 12.7 44.7065 12 42.5065 12C39.7065 12 37.0065 13.1 34.8065 15.1C33.9065 16.1 33.0065 17 32.0065 18.1C31.6065 17.6 31.1065 17.2 30.7065 16.8C30.0065 16 29.4065 15.3 28.6065 14.7C26.5065 12.9 24.1065 12 21.6065 12Z"
          fill="none"
        />
      </svg>
    ),
    download: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="download"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M32.902 51.5L47.7295 35.6839C48.1073 35.281 48.0869 34.6482 47.6839 34.2705C47.281 33.8927 46.6482 33.9131 46.2705 34.3161L33 48.4712V11C33 10.4477 32.5523 10 32 10C31.4477 10 31 10.4477 31 11V48.4712L17.7295 34.3161C17.3518 33.9131 16.719 33.8927 16.3161 34.2705C15.9131 34.6482 15.8927 35.281 16.2705 35.6839L31.098 51.5H13C12.4477 51.5 12 51.9477 12 52.5C12 53.0523 12.4477 53.5 13 53.5H51C51.5523 53.5 52 53.0523 52 52.5C52 51.9477 51.5523 51.5 51 51.5H32.902Z"
          fill="none"
        />
      </svg>
    ),
    file: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="file"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 16"
        fill="none"
      >
        <path
          className={color}
          d="M12 14V4.5L7.5 0H2C0.895431 0 0 0.89543 0 2V14C0 15.1046 0.895431 16 2 16H10C11.1046 16 12 15.1046 12 14ZM7.5 3C7.5 3.82843 8.17157 4.5 9 4.5H11V14C11 14.5523 10.5523 15 10 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H7.5V3Z"
          fill="none"
        />
        <path
          className={color}
          d="M2.60308 14.0867C2.39492 14.0107 2.25502 13.8484 2.16469 13.6678C1.97023 13.2789 2.03479 12.8911 2.24538 12.5646C2.4432 12.2579 2.77107 11.9972 3.14157 11.7784C3.55866 11.532 4.0723 11.3142 4.62412 11.1333C4.83122 10.7616 5.03391 10.3665 5.22354 9.96491C5.39178 9.60862 5.54761 9.25179 5.68581 8.90631C5.49421 8.45887 5.34401 8.01665 5.25638 7.61141C5.16979 7.21094 5.13709 6.81475 5.20953 6.47496C5.28496 6.12116 5.48355 5.80276 5.86079 5.65187C6.05235 5.57525 6.25998 5.53151 6.46215 5.57474C6.68338 5.62205 6.84316 5.76145 6.93893 5.93994C7.02715 6.10438 7.05908 6.29557 7.06587 6.47828C7.07284 6.66551 7.05431 6.87351 7.01863 7.09178C6.93529 7.60167 6.74812 8.22639 6.49839 8.88638C6.64647 9.20416 6.81663 9.5258 7.00129 9.83738C7.15468 10.0962 7.31534 10.3435 7.47821 10.5722C7.97315 10.5409 8.43294 10.5537 8.81309 10.6221C9.17696 10.6875 9.54707 10.8173 9.77299 11.0868C9.8939 11.2311 9.96588 11.4071 9.9731 11.6054C9.98008 11.7972 9.92593 11.9868 9.83546 12.1677C9.751 12.3366 9.63563 12.4829 9.48087 12.5842C9.32289 12.6875 9.14711 12.7286 8.97133 12.7216C8.64002 12.7083 8.31729 12.5258 8.03774 12.305C7.73718 12.0677 7.42668 11.7377 7.12697 11.3553C6.8067 11.3901 6.46939 11.4429 6.12731 11.5124C5.78883 11.5812 5.45236 11.665 5.13014 11.7609C4.79218 12.3441 4.44175 12.8697 4.10906 13.2707C3.81838 13.6211 3.50132 13.9266 3.18301 14.0577C3.01465 14.1271 2.8099 14.1622 2.60308 14.0867ZM3.98158 12.1859C3.81603 12.2623 3.66217 12.3419 3.52298 12.4241C3.19504 12.6178 2.98181 12.8065 2.87564 12.9711C2.78226 13.1159 2.77995 13.2212 2.83551 13.3323C2.84627 13.3539 2.85527 13.3678 2.86178 13.3764C2.87007 13.3743 2.88173 13.3707 2.89731 13.3643C3.03409 13.3079 3.25219 13.129 3.53183 12.7919C3.67695 12.6169 3.82805 12.4126 3.98158 12.1859ZM5.62199 10.8551C5.74064 10.8274 5.85945 10.8015 5.97793 10.7774C6.19565 10.7332 6.41477 10.6946 6.63205 10.6627C6.53723 10.5179 6.44498 10.3697 6.35609 10.2198C6.27548 10.0837 6.19695 9.94507 6.12119 9.80476C6.05032 9.96531 5.97698 10.1258 5.90172 10.2852C5.81154 10.4761 5.71802 10.6667 5.62199 10.8551ZM8.0682 11.3068C8.21771 11.4685 8.36385 11.6069 8.50257 11.7164C8.74309 11.9064 8.9103 11.9685 9.00142 11.9722C9.03685 11.9736 9.05541 11.9663 9.07021 11.9566C9.08823 11.9448 9.12409 11.9134 9.16464 11.8323C9.21669 11.7282 9.22475 11.6644 9.22359 11.6327C9.22268 11.6076 9.21617 11.59 9.19823 11.5686C9.14643 11.5069 8.99735 11.4172 8.68028 11.3602C8.50231 11.3282 8.29585 11.3106 8.0682 11.3068ZM6.07842 7.79874C6.17027 7.49408 6.23868 7.21415 6.27845 6.9708C6.30918 6.78282 6.32091 6.62754 6.31639 6.50617C6.31244 6.3999 6.29664 6.33865 6.28437 6.30827C6.26023 6.3102 6.21402 6.31835 6.13933 6.34823C6.05234 6.38302 5.98088 6.4539 5.94305 6.63134C5.90224 6.82278 5.91309 7.0998 5.98944 7.45289C6.01349 7.56409 6.04332 7.67969 6.07842 7.79874Z"
          fill="none"
        />
      </svg>
    ),
    copy: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="copy"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 21.5V51.5H39C39 41.5 39 31.5 39 21.5C30.3333 21.5 21.6667 21.5 13 21.5ZM25 19.5V13.5H51V43.5H41V20.5C41 19.9477 40.605 19.5 40.1176 19.5H25ZM41 52.5C41 53.0523 40.605 53.5 40.1176 53.5H11.8824C11.395 53.5 11 53.0523 11 52.5V20.5C11 19.9477 11.395 19.5 11.8824 19.5H23V12.5C23 11.9477 23.395 11.5 23.8824 11.5H52.1176C52.605 11.5 53 11.9477 53 12.5V44.5C53 45.0523 52.605 45.5 52.1176 45.5H41V52.5Z"
          fill="none"
        />
      </svg>
    ),
    like: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="like"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 52.5H43.2759C44.2116 52.5 45.1178 52.172 45.8366 51.5729L50.6567 47.5562C51.4566 46.8897 51.965 45.9375 52.074 44.9021L53.7564 28.9188C54.0051 26.557 52.1532 24.5 49.7784 24.5L39.7257 24.5L40.8595 13.9181C41.0182 12.4368 40.3406 10.9901 39.1011 10.1637L38.9945 10.0927C36.9926 8.75805 34.2739 9.48002 33.198 11.632L27.3563 23.3153L22.1716 28.5C22.0038 28.6678 21.5 29 21.5 29.5C21.5 29 21 28.5 20 28.5L12 28.5C11 28.5 10 29.5 10 30.5V50.5C10 51.5 11 52.5 12 52.5H20C21 52.5 22 52.5 22 51.5C22 52.5 22.9535 52.5 24 52.5ZM23 50.5V31.3285C23 30.798 23.2107 30.2893 23.5858 29.9143L28.7705 24.7295C28.9225 24.5775 29.049 24.402 29.1451 24.2098L34.9868 12.5264C35.5248 11.4504 36.8841 11.0895 37.8851 11.7568L37.9917 11.8278C38.6114 12.241 38.9503 12.9644 38.8709 13.705L37.7371 24.287C37.6105 25.4691 38.5368 26.5 39.7257 26.5H49.7784C50.9658 26.5 51.8917 27.5285 51.7674 28.7094L50.085 44.6927C50.0305 45.2104 49.7763 45.6865 49.3763 46.0198L44.5563 50.0365C44.1968 50.336 43.7438 50.5 43.2759 50.5H25C23.8954 50.5 23 50.5 23 50.5ZM21 30.5H12C12 37.1667 12 43.8334 12 50.5H21C21 43.8334 21 37.1667 21 30.5Z"
          fill="#F0F0F0"
        />
      </svg>
    ),
    'credit-card': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="credit-card"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 46.5C7 47.5 8 48.5 9 48.5H55C56 48.5 57 47.5 57 46.5V17.5C57 16.5 56 15.5 55 15.5H9C8 15.5 7 16.5 7 17.5V46.5ZM9 46.5H55V27.5H9V46.5ZM9 25.5V17.5H55V25.5H9Z"
          fill="none"
        />
        <path className={color} d="M12 36.5H23V38.5H12V36.5Z" fill="none" />
        <path className={color} d="M12 40.5H18V42.5H12V40.5Z" fill="none" />
      </svg>
    ),
    checkmark: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="checkmark"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.5928 13.1946C53.0376 13.522 53.1327 14.148 52.8053 14.5928L26.3053 50.5928C26.1331 50.8268 25.8675 50.9743 25.5777 50.9969C25.288 51.0195 25.0028 50.9149 24.7963 50.7104L11.2963 37.339C10.9039 36.9503 10.9009 36.3172 11.2895 35.9248C11.6782 35.5324 12.3113 35.5294 12.7037 35.918L25.3811 48.4747L51.1947 13.4071C51.5221 12.9624 52.148 12.8672 52.5928 13.1946Z"
          fill="none"
        />
      </svg>
    ),
    close: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="close"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={classnames([color, styles.strokeColor])}
          d="M32.3532 33.5608C32.2595 33.467 32.1323 33.4143 31.9997 33.4143C31.8671 33.4143 31.7399 33.467 31.6461 33.5608L14.5605 50.6464C14.3653 50.8417 14.0487 50.8417 13.8534 50.6464C13.6582 50.4512 13.6582 50.1346 13.8534 49.9393L30.939 32.8536C31.1343 32.6584 31.1343 32.3418 30.939 32.1465L13.8532 15.0608C13.658 14.8655 13.658 14.5489 13.8532 14.3536C14.0485 14.1584 14.3651 14.1584 14.5603 14.3536L31.6461 31.4394C31.7399 31.5332 31.8671 31.5859 31.9997 31.5859C32.1323 31.5859 32.2595 31.5332 32.3532 31.4394L49.439 14.3536C49.6343 14.1583 49.9509 14.1583 50.1461 14.3536C50.3414 14.5489 50.3414 14.8654 50.1461 15.0607L33.0603 32.1465C32.9666 32.2403 32.9139 32.3675 32.9139 32.5001C32.9139 32.6327 32.9666 32.7599 33.0603 32.8536L50.1461 49.9393C50.3414 50.1346 50.3414 50.4512 50.1461 50.6464C49.9509 50.8417 49.6343 50.8417 49.439 50.6465L32.3532 33.5608Z"
          fill="white"
          stroke="white"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    plus: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="plus"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M33 13.1765C33 12.5267 32.5523 12 32 12C31.4477 12 31 12.5267 31 13.1765V31H13.1765C12.5267 31 12 31.4477 12 32C12 32.5523 12.5267 33 13.1765 33H31V50.8235C31 51.4733 31.4477 52 32 52C32.5523 52 33 51.4733 33 50.8235V33H50.8235C51.4733 33 52 32.5523 52 32C52 31.4477 51.4733 31 50.8235 31H33V13.1765Z"
          fill="none"
        />
      </svg>
    ),
    minus: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="minus"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 32C12 31.4477 12.5267 31 13.1765 31H50.8235C51.4733 31 52 31.4477 52 32C52 32.5523 51.4733 33 50.8235 33H13.1765C12.5267 33 12 32.5523 12 32Z"
          fill="none"
        />
      </svg>
    ),
    share: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="share"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M30.5858 12.5858C30.9763 12.1953 31.4882 12 32 12C32.5118 12 33.0237 12.1953 33.4142 12.5858L44.7071 23.8787C45.0976 24.2692 45.0976 24.9024 44.7071 25.2929C44.3166 25.6834 43.6834 25.6834 43.2929 25.2929L33 15V39C33 39.5523 32.5523 40 32 40C31.4477 40 31 39.5523 31 39V15L20.7071 25.2929C20.3166 25.6834 19.6834 25.6834 19.2929 25.2929C18.9024 24.9024 18.9024 24.2692 19.2929 23.8787L30.5858 12.5858Z"
          fill="none"
        />
        <path
          className={color}
          d="M16 34C16 33.4477 15.5523 33 15 33C14.4477 33 14 33.4477 14 34V49C14 50.1046 14.8954 51 16 51H48C49.1046 51 50 50.1046 50 49V34C50 33.4477 49.5523 33 49 33C48.4477 33 48 33.4477 48 34V49H16V34Z"
          fill="none"
        />
      </svg>
    ),
    preferences: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="preferences"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.901 16.9952C36.4396 19.2798 34.4207 21 32 21C29.5793 21 27.5604 19.2798 27.099 16.9952C27.0665 16.9984 27.0334 17 27 17H9C8.44772 17 8 16.5523 8 16C8 15.4477 8.44772 15 9 15H27C27.0334 15 27.0665 15.0016 27.099 15.0048C27.5604 12.7202 29.5793 11 32 11C34.4207 11 36.4396 12.7202 36.901 15.0048C36.9335 15.0016 36.9666 15 37 15H55C55.5523 15 56 15.4477 56 16C56 16.5523 55.5523 17 55 17H37C36.9666 17 36.9335 16.9984 36.901 16.9952ZM35 16C35 17.6569 33.6569 19 32 19C30.3431 19 29 17.6569 29 16C29 14.3431 30.3431 13 32 13C33.6569 13 35 14.3431 35 16Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.901 48.9952C36.4396 51.2798 34.4207 53 32 53C29.5793 53 27.5604 51.2798 27.099 48.9952C27.0665 48.9984 27.0334 49 27 49H9C8.44772 49 8 48.5523 8 48C8 47.4477 8.44772 47 9 47H27C27.0334 47 27.0665 47.0016 27.099 47.0048C27.5604 44.7202 29.5793 43 32 43C34.4207 43 36.4396 44.7202 36.901 47.0048C36.9335 47.0016 36.9666 47 37 47H55C55.5523 47 56 47.4477 56 48C56 48.5523 55.5523 49 55 49H37C36.9666 49 36.9335 48.9984 36.901 48.9952ZM35 48C35 49.6569 33.6569 51 32 51C30.3431 51 29 49.6569 29 48C29 46.3431 30.3431 45 32 45C33.6569 45 35 46.3431 35 48Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 37C42.4207 37 44.4396 35.2798 44.901 32.9952C44.9335 32.9984 44.9666 33 45 33H55C55.5523 33 56 32.5523 56 32C56 31.4477 55.5523 31 55 31H45C44.9666 31 44.9335 31.0016 44.901 31.0048C44.4396 28.7202 42.4207 27 40 27C37.5793 27 35.5604 28.7202 35.099 31.0048C35.0665 31.0016 35.0334 31 35 31H9C8.44772 31 8 31.4477 8 32C8 32.5523 8.44772 33 9 33H35C35.0334 33 35.0665 32.9984 35.099 32.9952C35.5604 35.2798 37.5793 37 40 37ZM40 35C41.6569 35 43 33.6569 43 32C43 30.3431 41.6569 29 40 29C38.3431 29 37 30.3431 37 32C37 33.6569 38.3431 35 40 35Z"
          fill="none"
        />
      </svg>
    ),
    filters: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="filters"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 10C14.4477 10 14 10.4477 14 11V17.126C12.2748 17.5701 11 19.1362 11 21C11 22.8638 12.2748 24.4299 14 24.874V53C14 53.5523 14.4477 54 15 54C15.5523 54 16 53.5523 16 53V24.874C17.7252 24.4299 19 22.8638 19 21C19 19.1362 17.7252 17.5701 16 17.126V11C16 10.4477 15.5523 10 15 10ZM16 19.2676C15.7058 19.0974 15.3643 19 15 19C14.6357 19 14.2942 19.0974 14 19.2676C13.4022 19.6134 13 20.2597 13 21C13 21.7403 13.4022 22.3866 14 22.7324C14.2942 22.9026 14.6357 23 15 23C15.3643 23 15.7058 22.9026 16 22.7324C16.5978 22.3866 17 21.7403 17 21C17 20.2597 16.5978 19.6134 16 19.2676ZM31 11C31 10.4477 31.4477 10 32 10C32.5523 10 33 10.4477 33 11V37.126C34.7252 37.5701 36 39.1362 36 41C36 42.8638 34.7252 44.4299 33 44.874V53C33 53.5523 32.5523 54 32 54C31.4477 54 31 53.5523 31 53V44.874C29.2748 44.4299 28 42.8638 28 41C28 39.1362 29.2748 37.5701 31 37.126V11ZM31 39.2676C30.4022 39.6134 30 40.2597 30 41C30 41.7403 30.4022 42.3866 31 42.7324C31.2942 42.9026 31.6357 43 32 43C32.3643 43 32.7058 42.9026 33 42.7324C33.5978 42.3866 34 41.7403 34 41C34 40.2597 33.5978 39.6134 33 39.2676C32.7058 39.0974 32.3643 39 32 39C31.6357 39 31.2942 39.0974 31 39.2676ZM48 11C48 10.4477 48.4477 10 49 10C49.5523 10 50 10.4477 50 11V27.126C51.7252 27.5701 53 29.1362 53 31C53 32.8638 51.7252 34.4299 50 34.874V53C50 53.5523 49.5523 54 49 54C48.4477 54 48 53.5523 48 53V34.874C46.2748 34.4299 45 32.8638 45 31C45 29.1362 46.2748 27.5701 48 27.126V11ZM48 29.2676C47.4022 29.6134 47 30.2597 47 31C47 31.7403 47.4022 32.3866 48 32.7324C48.2942 32.9026 48.6357 33 49 33C49.3643 33 49.7058 32.9026 50 32.7324C50.5978 32.3866 51 31.7403 51 31C51 30.2597 50.5978 29.6134 50 29.2676C49.7058 29.0974 49.3643 29 49 29C48.6357 29 48.2942 29.0974 48 29.2676Z"
          fill="none"
        />
      </svg>
    ),
    'list-view': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="list-view"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M11 18C12.1046 18 13 17.1046 13 16C13 14.8954 12.1046 14 11 14C9.89543 14 9 14.8954 9 16C9 17.1046 9.89543 18 11 18Z"
          fill="none"
        />
        <path
          className={color}
          d="M11 34C12.1046 34 13 33.1046 13 32C13 30.8954 12.1046 30 11 30C9.89543 30 9 30.8954 9 32C9 33.1046 9.89543 34 11 34Z"
          fill="none"
        />
        <path
          className={color}
          d="M13 48C13 49.1046 12.1046 50 11 50C9.89543 50 9 49.1046 9 48C9 46.8954 9.89543 46 11 46C12.1046 46 13 46.8954 13 48Z"
          fill="none"
        />
        <path
          className={color}
          d="M21 15C20.4477 15 20 15.4477 20 16C20 16.5523 20.4477 17 21 17H53C53.5523 17 54 16.5523 54 16C54 15.4477 53.5523 15 53 15H21Z"
          fill="none"
        />
        <path
          className={color}
          d="M20 32C20 31.4477 20.4477 31 21 31H53C53.5523 31 54 31.4477 54 32C54 32.5523 53.5523 33 53 33H21C20.4477 33 20 32.5523 20 32Z"
          fill="none"
        />
        <path
          className={color}
          d="M21 47C20.4477 47 20 47.4477 20 48C20 48.5523 20.4477 49 21 49H53C53.5523 49 54 48.5523 54 48C54 47.4477 53.5523 47 53 47H21Z"
          fill="none"
        />
      </svg>
    ),
    queue: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="queue"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M21.9193 19.2944C22.6001 18.9055 22.6001 17.9079 21.9193 17.5189L12.4893 12.1317C11.8227 11.7509 10.9999 12.2413 10.9999 13.0195V23.7939C10.9999 24.5721 11.8227 25.0625 12.4893 24.6817L21.9193 19.2944Z"
          fill="none"
        />
        <path
          className={color}
          d="M29 17.3887C28.4477 17.3887 28 17.8445 28 18.4067C28 18.9689 28.4477 19.4247 29 19.4247H52C52.5523 19.4247 53 18.9689 53 18.4067C53 17.8445 52.5523 17.3887 52 17.3887H29Z"
          fill="none"
        />
        <path
          className={color}
          d="M12 49.964C11.4477 49.964 11 50.4198 11 50.982C11 51.5442 11.4477 52 12 52H52C52.5523 52 53 51.5442 53 50.982C53 50.4198 52.5523 49.964 52 49.964H12Z"
          fill="none"
        />
        <path
          className={color}
          d="M11 34.6944C11 34.1322 11.4477 33.6764 12 33.6764H52C52.5523 33.6764 53 34.1322 53 34.6944C53 35.2566 52.5523 35.7124 52 35.7124H12C11.4477 35.7124 11 35.2566 11 34.6944Z"
          fill="none"
        />
      </svg>
    ),
    drag: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="drag"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16 22C16 21.4477 16.4214 21 16.9412 21H47.0588C47.5786 21 48 21.4477 48 22C48 22.5523 47.5786 23 47.0588 23H16.9412C16.4214 23 16 22.5523 16 22Z"
          fill="none"
        />
        <path
          className={color}
          d="M16 32C16 31.4477 16.4214 31 16.9412 31H47.0588C47.5786 31 48 31.4477 48 32C48 32.5523 47.5786 33 47.0588 33H16.9412C16.4214 33 16 32.5523 16 32Z"
          fill="none"
        />
        <path
          className={color}
          d="M16.9412 41C16.4214 41 16 41.4477 16 42C16 42.5523 16.4214 43 16.9412 43H47.0588C47.5786 43 48 42.5523 48 42C48 41.4477 47.5786 41 47.0588 41H16.9412Z"
          fill="none"
        />
      </svg>
    ),
    hamburger: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="hamburger"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={color}
          d="M12 19C12 18.4477 12.4214 18 12.9412 18H51.0588C51.5786 18 52 18.4477 52 19C52 19.5523 51.5786 20 51.0588 20H12.9412C12.4214 20 12 19.5523 12 19Z"
          fill="white"
        />
        <path
          className={color}
          d="M12 33C12 32.4477 12.4214 32 12.9412 32H51.0588C51.5786 32 52 32.4477 52 33C52 33.5523 51.5786 34 51.0588 34H12.9412C12.4214 34 12 33.5523 12 33Z"
          fill="white"
        />
        <path
          className={color}
          d="M12.9412 46C12.4214 46 12 46.4477 12 47C12 47.5523 12.4214 48 12.9412 48H51.0588C51.5786 48 52 47.5523 52 47C52 46.4477 51.5786 46 51.0588 46H12.9412Z"
          fill="white"
        />
      </svg>
    ),
    'more-horizontal': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="more-horizontal"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16 28C13.7909 28 12 29.7909 12 32C12 34.2091 13.7909 36 16 36C18.2091 36 20 34.2091 20 32C20 29.7909 18.2091 28 16 28Z"
          fill="none"
        />
        <path
          className={color}
          d="M32 28C29.7909 28 28 29.7909 28 32C28 34.2091 29.7909 36 32 36C34.2091 36 36 34.2091 36 32C36 29.7909 34.2091 28 32 28Z"
          fill="none"
        />
        <path
          className={color}
          d="M44 32C44 29.7909 45.7909 28 48 28C50.2091 28 52 29.7909 52 32C52 34.2091 50.2091 36 48 36C45.7909 36 44 34.2091 44 32Z"
          fill="none"
        />
      </svg>
    ),
    'more-vertical': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="more-vertical"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M28 48C28 50.2091 29.7909 52 32 52C34.2091 52 36 50.2091 36 48C36 45.7909 34.2091 44 32 44C29.7909 44 28 45.7909 28 48Z"
          fill="none"
        />
        <path
          className={color}
          d="M28 32C28 34.2091 29.7909 36 32 36C34.2091 36 36 34.2091 36 32C36 29.7909 34.2091 28 32 28C29.7909 28 28 29.7909 28 32Z"
          fill="none"
        />
        <path
          className={color}
          d="M32 20C29.7909 20 28 18.2091 28 16C28 13.7909 29.7909 12 32 12C34.2091 12 36 13.7909 36 16C36 18.2091 34.2091 20 32 20Z"
          fill="none"
        />
      </svg>
    ),
    refresh: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="refresh"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M41.5324 8.16149C41.9956 7.86066 42.6149 7.99225 42.9158 8.45542L46.9657 14.6908C47.2665 15.1539 47.1349 15.7733 46.6717 16.0741L40.5573 20.178C40.0987 20.4858 39.4775 20.3636 39.1697 19.905C38.8619 19.4464 38.9841 18.8252 39.4427 18.5174L43.7752 15.6095C40.4171 13.331 36.3651 12.0001 31.9999 12.0001C20.4019 12.0001 10.9999 21.4021 10.9999 33.0001C10.9999 44.5981 20.4019 54.0001 31.9999 54.0001C43.5979 54.0001 52.9999 44.5981 52.9999 33.0001C52.9999 32.4478 53.4476 32.0001 53.9999 32.0001C54.5522 32.0001 54.9999 32.4478 54.9999 33.0001C54.9999 45.7027 44.7024 56.0001 31.9999 56.0001C19.2973 56.0001 8.99988 45.7027 8.99988 33.0001C8.99988 20.2976 19.2973 10.0001 31.9999 10.0001C36.21 10.0001 40.1576 11.1321 43.5529 13.1081L41.2385 9.54482C40.9377 9.08165 41.0693 8.46232 41.5324 8.16149Z"
          fill="none"
        />
      </svg>
    ),
    power: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="power"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M33 9C33 8.44772 32.5523 8 32 8C31.4477 8 31 8.44772 31 9V31C31 31.5523 31.4477 32 32 32C32.5523 32 33 31.5523 33 31V9Z"
          fill="none"
        />
        <path
          className={color}
          d="M45.3589 16.1986C44.9162 15.8683 44.2897 15.9593 43.9593 16.4019C43.629 16.8445 43.72 17.4711 44.1627 17.8014C48.9454 21.3707 52 26.9993 52 33.3787C52 44.1591 43.1173 53 32 53C20.8795 53 12 44.2546 12 33.3787C12 27.0989 15.0542 21.4661 19.7446 17.8942C20.184 17.5596 20.2689 16.9322 19.9343 16.4928C19.5997 16.0534 18.9723 15.9685 18.5329 16.3031C13.3764 20.2299 10 26.437 10 33.3787C10 45.3934 19.8094 55 32 55C44.1937 55 54 45.2916 54 33.3787C54 26.3394 50.624 20.1279 45.3589 16.1986Z"
          fill="none"
        />
      </svg>
    ),
    information: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="information"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M30.5 27C30.5 26.4477 30.9477 26 31.5 26H32.5C33.0523 26 33.5 26.4477 33.5 27V45C33.5 45.5523 33.0523 46 32.5 46H31.5C30.9477 46 30.5 45.5523 30.5 45V27Z"
          fill="none"
        />
        <path
          className={color}
          d="M30 21C30 22.1049 30.8951 23 32 23C33.1049 23 34 22.1049 34 21C34 19.8951 33.1049 19 32 19C30.8951 19 30 19.8951 30 21Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 57C45.8071 57 57 45.8071 57 32C57 18.1929 45.8071 7 32 7C18.1929 7 7 18.1929 7 32C7 45.8071 18.1929 57 32 57ZM32 55C44.7025 55 55 44.7025 55 32C55 19.2975 44.7025 9 32 9C19.2975 9 9 19.2975 9 32C9 44.7025 19.2975 55 32 55Z"
          fill="none"
        />
      </svg>
    ),
    warning: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="warning"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2999 9.96982C31.07 8.67672 32.93 8.67673 33.7001 9.96982L58.7144 51.9747C59.5073 53.3061 58.5554 55 57.0143 55H6.98567C5.4446 55 4.49272 53.3061 5.2856 51.9747L30.2999 9.96982ZM32 10.9976L6.98567 53.0024H57.0143L32 10.9976Z"
          fill="none"
        />
        <path
          className={color}
          d="M30 25C30 24.4477 30.4477 24 31 24H33C33.5523 24 34 24.4477 34 25V39C34 39.5523 33.5523 40 33 40H31C30.4477 40 30 39.5523 30 39V25Z"
          fill="none"
        />
        <path
          className={color}
          d="M31 44C30.4477 44 30 44.4477 30 45V47C30 47.5523 30.4477 48 31 48H33C33.5523 48 34 47.5523 34 47V45C34 44.4477 33.5523 44 33 44H31Z"
          fill="none"
        />
      </svg>
    ),
    failure: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="failure"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M30 17C30 16.4477 30.4477 16 31 16H33C33.5523 16 34 16.4477 34 17V39C34 39.5523 33.5523 40 33 40H31C30.4477 40 30 39.5523 30 39V17Z"
          fill="none"
        />
        <path
          className={color}
          d="M31 44C30.4477 44 30 44.4477 30 45V47C30 47.5523 30.4477 48 31 48H33C33.5523 48 34 47.5523 34 47V45C34 44.4477 33.5523 44 33 44H31Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 57C45.8071 57 57 45.8071 57 32C57 18.1929 45.8071 7 32 7C18.1929 7 7 18.1929 7 32C7 45.8071 18.1929 57 32 57ZM32 55C44.7025 55 55 44.7025 55 32C55 19.2975 44.7025 9 32 9C19.2975 9 9 19.2975 9 32C9 44.7025 19.2975 55 32 55Z"
          fill="none"
        />
      </svg>
    ),
    help: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="help"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 57C45.8071 57 57 45.8071 57 32C57 18.1929 45.8071 7 32 7C18.1929 7 7 18.1929 7 32C7 45.8071 18.1929 57 32 57ZM32 55C44.7025 55 55 44.7025 55 32C55 19.2975 44.7025 9 32 9C19.2975 9 9 19.2975 9 32C9 44.7025 19.2975 55 32 55Z"
          fill="none"
        />
        <path
          className={color}
          d="M30.12 35.892C30.12 35.004 30.288 34.26 30.624 33.66C30.96 33.036 31.368 32.544 31.848 32.184C32.328 31.8 32.988 31.368 33.828 30.888C34.644 30.408 35.304 29.976 35.808 29.592C36.312 29.208 36.732 28.704 37.068 28.08C37.428 27.432 37.608 26.616 37.608 25.632C37.608 24.264 37.116 23.172 36.132 22.356C35.148 21.54 33.828 21.132 32.172 21.132C30.564 21.132 29.256 21.528 28.248 22.32C27.24 23.112 26.652 24.216 26.484 25.632H24C24.096 24.288 24.504 23.124 25.224 22.14C25.968 21.132 26.928 20.364 28.104 19.836C29.304 19.308 30.636 19.044 32.1 19.044C33.732 19.044 35.148 19.32 36.348 19.872C37.548 20.424 38.46 21.192 39.084 22.176C39.732 23.16 40.056 24.324 40.056 25.668C40.056 26.844 39.852 27.84 39.444 28.656C39.036 29.448 38.532 30.072 37.932 30.528C37.332 30.984 36.576 31.464 35.664 31.968C34.896 32.4 34.296 32.784 33.864 33.12C33.432 33.432 33.072 33.828 32.784 34.308C32.496 34.788 32.352 35.364 32.352 36.036V36.972H30.12V35.892ZM29.976 40.104H32.532V45H29.976V40.104Z"
          fill="none"
        />
      </svg>
    ),
    'side-nav-notification-left': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="side-nav-notification-left"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <rect className={color} x="12" y="30" width="40" height="3" rx="1.5" fill="none" />
        <rect className={color} x="12" y="16" width="40" height="3" rx="1.5" fill="none" />
        <rect className={color} x="12" y="44" width="40" height="3" rx="1.5" fill="none" />
        <circle className={color} cx="12" cy="12" r="12" fill="none" />
      </svg>
    ),
    'side-nav': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="side-nav"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <rect className={color} x="12" y="30" width="40" height="3" rx="1.5" fill="none" />
        <rect className={color} x="12" y="16" width="40" height="3" rx="1.5" fill="none" />
        <rect className={color} x="12" y="44" width="40" height="3" rx="1.5" fill="none" />
      </svg>
    ),
    'side-nav-notification-left-right': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="side-nav-notification-left-right"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <rect className={color} x="12" y="30" width="40" height="3" rx="1.5" fill="none" />
        <rect className={color} x="12" y="16" width="40" height="3" rx="1.5" fill="none" />
        <rect className={color} x="12" y="44" width="40" height="3" rx="1.5" fill="none" />
        <circle className={color} cx="52" cy="12" r="12" fill="none" />
      </svg>
    ),
    star: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="star"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.6037 38.7063C39.1709 37.3521 39.6148 35.7927 40.8708 34.93L51.2377 27.3272H38.4005C36.9467 27.3272 35.6391 26.3718 35.1919 24.9754L35.1913 24.9734L31.9775 14.9864L28.7862 24.9551C28.3365 26.3832 27.03 27.3136 25.5755 27.3136H12.7748L23.1669 34.9142C24.337 35.7766 24.8329 37.2805 24.386 38.679L24.3851 38.6817L20.5853 50.5136L29.8963 43.012C31.1342 42.0162 32.883 42.0162 34.1209 43.012L34.1237 43.0143L43.3987 50.5031L39.6037 38.7063ZM46.6619 54.1101C46.8681 54.7511 46.0983 55.2693 45.5759 54.8466L32.8746 44.5913C32.366 44.1821 31.6512 44.1821 31.1426 44.5913L18.4138 54.8466C17.8777 55.2693 17.1216 54.7511 17.3278 54.1101L22.4826 38.0589C22.6613 37.4998 22.4688 36.8998 21.9877 36.5452L8.28294 26.5217C7.74684 26.1262 8.02176 25.2943 8.69532 25.2943H25.5755C26.1803 25.2943 26.7026 24.9125 26.8813 24.3397L31.3213 10.4705C31.5275 9.84317 32.421 9.84317 32.6272 10.4705L37.0946 24.3534C37.2733 24.9125 37.8094 25.308 38.4005 25.308H55.3081C55.9679 25.308 56.2566 26.1535 55.7205 26.5353L42.0157 36.5861C41.5209 36.9134 41.3284 37.5271 41.5071 38.0862L46.6619 54.1101Z"
          fill="none"
        />
      </svg>
    ),
    'star-filled': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="star-filled"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M41.5071 38.0862L46.6619 54.1101C46.8681 54.7511 46.0983 55.2693 45.5759 54.8466L32.8746 44.5913C32.366 44.1821 31.6512 44.1821 31.1426 44.5913L18.4138 54.8466C17.8777 55.2693 17.1216 54.7511 17.3278 54.1101L22.4826 38.0589C22.6613 37.4998 22.4688 36.8998 21.9877 36.5452L8.28294 26.5217C7.74684 26.1262 8.02176 25.2943 8.69532 25.2943H25.5755C26.1803 25.2943 26.7026 24.9125 26.8813 24.3397L31.3213 10.4705C31.5275 9.84317 32.421 9.84317 32.6272 10.4705L37.0946 24.3534C37.2733 24.9125 37.8094 25.308 38.4005 25.308H55.3081C55.9679 25.308 56.2566 26.1535 55.7205 26.5353L42.0157 36.5861C41.5209 36.9134 41.3284 37.5271 41.5071 38.0862Z"
          fill="none"
        />
      </svg>
    ),
    circle: (color, size, testId) => {
      const numSize = typeof size === 'number' ? size : 32;
      return (
        <svg
          role="img"
          data-testid={testId}
          aria-label="circle"
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox={`0 0 ${numSize * 2} ${numSize * 2}`}
          fill="none"
        >
          <circle className={color} cx={numSize} cy={numSize} r={numSize} />
        </svg>
      );
    },
    'circle-plus': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-plus"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M32 21C32.5523 21 33 21.4477 33 22V31H42C42.5523 31 43 31.4477 43 32C43 32.5523 42.5523 33 42 33H33V42C33 42.5523 32.5523 43 32 43C31.4477 43 31 42.5523 31 42V33H22C21.4477 33 21 32.5523 21 32C21 31.4477 21.4477 31 22 31H31V22C31 21.4477 31.4477 21 32 21Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 32C57 45.8071 45.8071 57 32 57C18.1929 57 7 45.8071 7 32C7 18.1929 18.1929 7 32 7C45.8071 7 57 18.1929 57 32ZM55 32C55 44.7025 44.7025 55 32 55C19.2975 55 9 44.7025 9 32C9 19.2975 19.2975 9 32 9C44.7025 9 55 19.2975 55 32Z"
          fill="none"
        />
      </svg>
    ),
    'circle-plus-filled': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-plus-filled"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 57C45.8071 57 57 45.8071 57 32C57 18.1929 45.8071 7 32 7C18.1929 7 7 18.1929 7 32C7 45.8071 18.1929 57 32 57ZM32 21C33.1046 21 34 21.8954 34 23V30H41C42.1046 30 43 30.8954 43 32C43 33.1046 42.1046 34 41 34H34V41C34 42.1046 33.1046 43 32 43C30.8954 43 30 42.1046 30 41V34H23C21.8954 34 21 33.1046 21 32C21 30.8954 21.8954 30 23 30H30V23C30 21.8954 30.8954 21 32 21Z"
          fill="none"
        />
      </svg>
    ),
    'circle-minus': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-minus"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M42 31C42.5523 31 43 31.4477 43 32C43 32.5523 42.5523 33 42 33C29.0679 33 34.2742 33 22 33C21.4477 33 21 32.5523 21 32C21 31.4477 21.4477 31 22 31C34.9772 31 29.6868 31 42 31Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 32C57 45.8071 45.8071 57 32 57C18.1929 57 7 45.8071 7 32C7 18.1929 18.1929 7 32 7C45.8071 7 57 18.1929 57 32ZM55 32C55 44.7025 44.7025 55 32 55C19.2975 55 9 44.7025 9 32C9 19.2975 19.2975 9 32 9C44.7025 9 55 19.2975 55 32Z"
          fill="none"
        />
      </svg>
    ),
    'circle-minus-filled': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-minus-filled"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 57C45.8071 57 57 45.8071 57 32C57 18.1929 45.8071 7 32 7C18.1929 7 7 18.1929 7 32C7 45.8071 18.1929 57 32 57ZM41 30C42.1046 30 43 30.8954 43 32C43 33.1046 42.1046 34 41 34C29.5293 34 33.2577 34 23 34C21.8954 34 21 33.1046 21 32C21 30.8954 21.8954 30 23 30C34.4349 30 30.7477 30 41 30Z"
          fill="none"
        />
      </svg>
    ),
    'circle-checkmark': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-checkmark"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M43.8192 22.5735C44.136 22.1211 44.0259 21.4976 43.5735 21.1809C43.121 20.8641 42.4975 20.9742 42.1808 21.4266L28.8249 40.5065L20.6644 33.2527C20.2516 32.8858 19.6195 32.9229 19.2526 33.3357C18.8857 33.7485 18.9229 34.3806 19.3356 34.7475L28.3356 42.7475C28.5489 42.9371 28.833 43.0265 29.1165 42.9933C29.3999 42.9601 29.6556 42.8073 29.8192 42.5735L43.8192 22.5735Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 32C57 45.8071 45.8071 57 32 57C18.1929 57 7 45.8071 7 32C7 18.1929 18.1929 7 32 7C45.8071 7 57 18.1929 57 32ZM55 32C55 44.7025 44.7025 55 32 55C19.2975 55 9 44.7025 9 32C9 19.2975 19.2975 9 32 9C44.7025 9 55 19.2975 55 32Z"
          fill="none"
        />
      </svg>
    ),
    'circle-checkmark-filled': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-checkmark-filled"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 57C45.8071 57 57 45.8071 57 32C57 18.1929 45.8071 7 32 7C18.1929 7 7 18.1929 7 32C7 45.8071 18.1929 57 32 57ZM44.6385 23.1471C45.2719 22.2422 45.0519 20.9951 44.1469 20.3617C43.2421 19.7283 41.995 19.9484 41.3616 20.8532L28.6498 39.0129L21.3287 32.5054C20.5032 31.7715 19.239 31.8459 18.5052 32.6714C17.7714 33.497 17.8457 34.7612 18.6713 35.495L27.6713 43.495C28.0979 43.8742 28.6661 44.053 29.2329 43.9866C29.7998 43.9201 30.3112 43.6146 30.6385 43.1471L44.6385 23.1471Z"
          fill="none"
        />
      </svg>
    ),
    'circle-close': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-close"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 55C44.7025 55 55 44.7025 55 32C55 19.2975 44.7025 9 32 9C19.2975 9 9 19.2975 9 32C9 44.7025 19.2975 55 32 55ZM57 32C57 45.8071 45.8071 57 32 57C18.1929 57 7 45.8071 7 32C7 18.1929 18.1929 7 32 7C45.8071 7 57 18.1929 57 32Z"
          fill="none"
        />
        <path
          className={color}
          d="M24.2218 24.2218C24.6123 23.8313 25.2455 23.8313 25.636 24.2218L32 30.5858L38.3639 24.2218C38.7544 23.8313 39.3876 23.8313 39.7781 24.2218C40.1686 24.6123 40.1686 25.2455 39.7781 25.636L33.4142 32L39.7781 38.364C40.1686 38.7545 40.1686 39.3876 39.7781 39.7782C39.3876 40.1687 38.7544 40.1687 38.3639 39.7782L32 33.4142L25.636 39.7782C25.2455 40.1687 24.6123 40.1687 24.2218 39.7782C23.8313 39.3876 23.8313 38.7545 24.2218 38.364L30.5857 32L24.2218 25.636C23.8313 25.2455 23.8313 24.6123 24.2218 24.2218Z"
          fill="none"
        />
      </svg>
    ),
    'circle-close-filled': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="circle-close-filled"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 32C57 45.8071 45.8071 57 32 57C18.1929 57 7 45.8071 7 32C7 18.1929 18.1929 7 32 7C45.8071 7 57 18.1929 57 32ZM23.7782 24.2218C24.5592 23.4408 25.8256 23.4408 26.6066 24.2218L31.5563 29.1716L36.5061 24.2218C37.2871 23.4408 38.5535 23.4408 39.3345 24.2218C40.1156 25.0029 40.1156 26.2692 39.3345 27.0503L34.3848 32L39.3345 36.9497C40.1156 37.7308 40.1156 38.9971 39.3345 39.7782C38.5535 40.5592 37.2871 40.5592 36.5061 39.7782L31.5563 34.8284L26.6066 39.7782C25.8256 40.5592 24.5592 40.5592 23.7782 39.7782C22.9971 38.9971 22.9971 37.7308 23.7782 36.9497L28.7279 32L23.7782 27.0503C22.9971 26.2692 22.9971 25.0029 23.7782 24.2218Z"
          fill="none"
        />
      </svg>
    ),
    'notification-icon': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="notification-icon"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.1574 9.78363C29.5582 8.00205 30.6794 5 31.9999 5C33.3203 5 34.4415 8.00197 34.8424 9.78356C45.9404 13.045 50 35.1588 50 45.4755V48H14V45.4755C14 35.1589 18.0595 13.0454 29.1574 9.78363ZM32 11.9028C43.598 11.9028 47 35.7159 47 45.4755H17C17 35.7159 20.402 11.9028 32 11.9028Z"
          fill="none"
        />
        <path
          className={color}
          d="M38 53C38 56.4856 36.1421 59 32 59C27.8579 59 26 56.4856 26 53H38Z"
          fill="none"
        />
      </svg>
    ),
    'notification-icon-aware': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="notification-icon-aware"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M31.9999 5C30.6794 5 29.5582 8.00205 29.1574 9.78363C18.0595 13.0454 14 35.1589 14 45.4755V48H50V45.4755C50 40.4427 49.0339 32.6023 46.7558 25.5127C45.8967 25.8279 44.9684 26 44 26C39.5817 26 36 22.4183 36 18C36 15.569 37.0844 13.3912 38.7958 11.9239C37.5911 10.9401 36.2754 10.2047 34.8424 9.78356C34.4415 8.00197 33.3203 5 31.9999 5Z"
          fill="none"
        />
        <path
          className={color}
          d="M32 59C36.1421 59 38 56.4856 38 53H26C26 56.4856 27.8579 59 32 59Z"
          fill="none"
        />
        <path
          className={color}
          d="M48 18C48 20.2091 46.2091 22 44 22C41.7909 22 40 20.2091 40 18C40 15.7909 41.7909 14 44 14C46.2091 14 48 15.7909 48 18Z"
          fill="#00A8F1"
        />
      </svg>
    ),
    'notification-icon-sucess': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="notification-icon-sucess"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M31.9999 5C30.6794 5 29.5582 8.00205 29.1574 9.78363C18.0595 13.0454 14 35.1589 14 45.4755V48H50V45.4755C50 40.4427 49.0339 32.6023 46.7558 25.5127C45.8967 25.8279 44.9684 26 44 26C39.5817 26 36 22.4183 36 18C36 15.569 37.0844 13.3912 38.7958 11.9239C37.5911 10.9401 36.2754 10.2047 34.8424 9.78356C34.4415 8.00197 33.3203 5 31.9999 5Z"
          fill="none"
        />
        <path
          className={color}
          d="M32 59C36.1421 59 38 56.4856 38 53H26C26 56.4856 27.8579 59 32 59Z"
          fill="none"
        />
        <path
          className={color}
          d="M48 18C48 20.2091 46.2091 22 44 22C41.7909 22 40 20.2091 40 18C40 15.7909 41.7909 14 44 14C46.2091 14 48 15.7909 48 18Z"
          fill="#00E270"
        />
      </svg>
    ),
    'notification-icon-warning': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="notification-icon-warning"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M31.9999 5C30.6794 5 29.5582 8.00205 29.1574 9.78363C18.0595 13.0454 14 35.1589 14 45.4755V48H50V45.4755C50 40.4427 49.0339 32.6023 46.7558 25.5127C45.8967 25.8279 44.9684 26 44 26C39.5817 26 36 22.4183 36 18C36 15.569 37.0844 13.3912 38.7958 11.9239C37.5911 10.9401 36.2754 10.2047 34.8424 9.78356C34.4415 8.00197 33.3203 5 31.9999 5Z"
          fill="none"
        />
        <path
          className={color}
          d="M32 59C36.1421 59 38 56.4856 38 53H26C26 56.4856 27.8579 59 32 59Z"
          fill="none"
        />
        <path
          className={color}
          d="M48 18C48 20.2091 46.2091 22 44 22C41.7909 22 40 20.2091 40 18C40 15.7909 41.7909 14 44 14C46.2091 14 48 15.7909 48 18Z"
          fill="#FF9600"
        />
      </svg>
    ),
    'notification-icon-error': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="notification-icon-error"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M31.9999 5C30.6794 5 29.5582 8.00205 29.1574 9.78363C18.0595 13.0454 14 35.1589 14 45.4755V48H50V45.4755C50 40.4427 49.0339 32.6023 46.7558 25.5127C45.8967 25.8279 44.9684 26 44 26C39.5817 26 36 22.4183 36 18C36 15.569 37.0844 13.3912 38.7958 11.9239C37.5911 10.9401 36.2754 10.2047 34.8424 9.78356C34.4415 8.00197 33.3203 5 31.9999 5Z"
          fill="none"
        />
        <path
          className={color}
          d="M32 59C36.1421 59 38 56.4856 38 53H26C26 56.4856 27.8579 59 32 59Z"
          fill="none"
        />
        <path
          className={color}
          d="M48 18C48 20.2091 46.2091 22 44 22C41.7909 22 40 20.2091 40 18C40 15.7909 41.7909 14 44 14C46.2091 14 48 15.7909 48 18Z"
          fill="#FF202B"
        />
      </svg>
    ),
    rotate: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="rotate"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 65"
        fill="none"
      >
        <path
          className={color}
          d="M9 32.4761C9 31.8092 9.40452 31.0148 10.505 30.1475C11.5942 29.2891 13.2323 28.4723 15.3457 27.7679C19.5619 26.3625 25.4502 25.4761 32 25.4761C38.5498 25.4761 44.4381 26.3625 48.6543 27.7679C50.7677 28.4723 52.4058 29.2891 53.495 30.1475C54.5955 31.0148 55 31.8092 55 32.4761C55 33.2072 54.5097 34.093 53.1718 35.0466C51.8572 35.9837 49.8972 36.8534 47.4083 37.5704C46.8776 37.7233 46.5714 38.2774 46.7242 38.8081C46.8771 39.3388 47.4313 39.6451 47.962 39.4923C50.5654 38.7423 52.763 37.7941 54.3327 36.6752C55.8791 35.5729 57 34.1645 57 32.4761C57 30.9338 56.0614 29.6236 54.7329 28.5767C53.3932 27.5209 51.5166 26.6138 49.2868 25.8705C44.8167 24.3805 38.705 23.4761 32 23.4761C25.295 23.4761 19.1833 24.3805 14.7132 25.8705C12.4834 26.6138 10.6068 27.5209 9.26707 28.5767C7.93863 29.6236 7 30.9338 7 32.4761C7 34.0184 7.93863 35.3285 9.26707 36.3754C10.6068 37.4313 12.4834 38.3383 14.7132 39.0816C19.1833 40.5716 25.295 41.4761 32 41.4761C34.004 41.4761 35.9528 41.3953 37.8192 41.2427L34.2929 44.769C33.9024 45.1595 33.9024 45.7927 34.2929 46.1832C34.6834 46.5737 35.3166 46.5737 35.7071 46.1832L41.2071 40.6832C41.5976 40.2927 41.5976 39.6595 41.2071 39.269L35.7071 33.769C35.3166 33.3784 34.6834 33.3784 34.2929 33.769C33.9024 34.1595 33.9024 34.7927 34.2929 35.1832L38.3029 39.1932C36.2985 39.3774 34.1847 39.4761 32 39.4761C25.4502 39.4761 19.5619 38.5897 15.3457 37.1842C13.2323 36.4798 11.5942 35.663 10.505 34.8046C9.40452 33.9373 9 33.1429 9 32.4761Z"
          fill="none"
        />
      </svg>
    ),
    trash: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="trash"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M24 14C24 12.8954 24.8954 12 26 12H38C39.1046 12 40 12.8954 40 14V16H50C50.5523 16 51 16.4477 51 17C51 17.5523 50.5523 18 50 18H48V50C48 51.1046 47.1046 52 46 52H18C16.8954 52 16 51.1046 16 50V18H14C13.4477 18 13 17.5523 13 17C13 16.4477 13.4477 16 14 16H24V14ZM26 16H38V14H26V16ZM18 18V50H46V18H18ZM28 24C28.5523 24 29 24.4477 29 25V43C29 43.5523 28.5523 44 28 44C27.4477 44 27 43.5523 27 43V25C27 24.4477 27.4477 24 28 24ZM36 24C36.5523 24 37 24.4477 37 25V43C37 43.5523 36.5523 44 36 44C35.4477 44 35 43.5523 35 43V25C35 24.4477 35.4477 24 36 24Z"
          fill="none"
        />
      </svg>
    ),
    cart: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="cart"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
      >
        <polyline
          className={classnames([color, styles.strokeColor])}
          fill="none"
          points="4,4.66667 13.3333,4.66667 12,9.66667 5.33333,9.66667 4,4.66667"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          className={classnames([color, styles.strokeColor])}
          fill="none"
          points="4,4.66666 3.66667,3.33333 2,3.33333"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          className={classnames([color, styles.strokeColor])}
          fill="none"
          cx="5.66663"
          cy="12.3333"
          r="1"
          strokeWidth="1"
        />
        <circle
          className={classnames([color, styles.strokeColor])}
          fill="none"
          cx="11.6666"
          cy="12.3333"
          r="1"
          strokeWidth="1"
        />
      </svg>
    ),
    facebook: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="facebook"
        width={size}
        height={size}
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="social/facebook">
          <path
            className={color}
            id="Vector"
            d="M31.9999 12.4912C20.9545 12.4912 12.0003 21.4454 12.0003 32.4908C12.0003 41.8698 18.4578 49.74 27.1688 51.9016V38.6027H23.0449V32.4908H27.1688V29.8572C27.1688 23.0502 30.2495 19.8951 36.9326 19.8951C38.1998 19.8951 40.3861 20.1438 41.2805 20.3918V25.9317C40.8085 25.8821 39.9885 25.8573 38.9702 25.8573C35.691 25.8573 34.4239 27.0997 34.4239 30.3292V32.4908H40.9565L39.8341 38.6027H34.4239V52.344C44.3269 51.148 52.0003 42.7162 52.0003 32.4908C51.9995 21.4454 43.0453 12.4912 31.9999 12.4912Z"
            fill="white"
          />
        </g>
      </svg>
    ),
    twitter: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="twitter"
        width={size}
        height={size}
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="social/x">
          <path
            className={color}
            id="Vector"
            d="M43.5022 14.1938H49.6358L36.2357 29.5093L51.9999 50.3503H39.6567L29.989 37.7104L18.9271 50.3503H12.7898L27.1225 33.9686L11.9999 14.1938H24.6564L33.3951 25.7472L43.5022 14.1938ZM41.3495 46.679H44.7482L22.8097 17.6723H19.1625L41.3495 46.679Z"
            fill="white"
          />
        </g>
      </svg>
    ),
    linkedin: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="linkedin"
        width={size}
        height={size}
        viewBox="0 0 64 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="social/linkedIn">
          <path
            className={color}
            id="Vector"
            d="M49.0391 12.4761H14.9531C13.3203 12.4761 12 13.7651 12 15.3589V49.5854C12 51.1792 13.3203 52.4761 14.9531 52.4761H49.0391C50.6719 52.4761 52 51.1792 52 49.5933V15.3589C52 13.7651 50.6719 12.4761 49.0391 12.4761ZM23.8672 46.562H17.9297V27.4683H23.8672V46.562ZM20.8984 24.8667C18.9922 24.8667 17.4531 23.3276 17.4531 21.4292C17.4531 19.5308 18.9922 17.9917 20.8984 17.9917C22.7969 17.9917 24.3359 19.5308 24.3359 21.4292C24.3359 23.3198 22.7969 24.8667 20.8984 24.8667ZM46.0859 46.562H40.1562V37.2808C40.1562 35.0698 40.1172 32.2183 37.0703 32.2183C33.9844 32.2183 33.5156 34.6323 33.5156 37.1245V46.562H27.5938V27.4683H33.2812V30.0776H33.3594C34.1484 28.5776 36.0859 26.9917 38.9688 26.9917C44.9766 26.9917 46.0859 30.9448 46.0859 36.0854V46.562Z"
            fill="white"
          />
        </g>
      </svg>
    ),
  },
  arrows: {
    'chevron-down': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-down"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.2931 40.0001C31.6836 40.3906 32.3167 40.3906 32.7073 40.0001L46.9142 25.7072C47.3047 25.3167 47.3047 24.6835 46.9142 24.293C46.5237 23.9024 45.8905 23.9024 45.5 24.293L32.0002 37.8788L17.5001 24.293C17.1096 23.9024 16.4764 23.9024 16.0859 24.293C15.6953 24.6835 15.6953 25.3167 16.0859 25.7072L31.2931 40.0001Z"
        />
      </svg>
    ),
    'chevron-up': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-up"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.2931 23.2929C31.6836 22.9024 32.3167 22.9024 32.7073 23.2929L46.9142 37.5858C47.3047 37.9763 47.3047 38.6095 46.9142 39C46.5237 39.3905 45.8905 39.3905 45.5 39L32.0002 25.4142L17.5001 39C17.1096 39.3905 16.4764 39.3905 16.0859 39C15.6953 38.6095 15.6953 37.9763 16.0859 37.5858L31.2931 23.2929Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-left': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-left"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6464 32.4999C21.2559 32.1094 21.2559 31.4762 21.6464 31.0857L35.9393 16.8788C36.3298 16.4882 36.963 16.4882 37.3535 16.8788C37.744 17.2693 37.744 17.9024 37.3535 18.293L23.7677 31.7928L37.3535 46.2929C37.744 46.6834 37.744 47.3166 37.3535 47.7071C36.963 48.0976 36.3298 48.0976 35.9393 47.7071L21.6464 32.4999Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-right': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-right"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.3536 32.4999C41.7441 32.1094 41.7441 31.4762 41.3536 31.0857L27.0607 16.8788C26.6702 16.4882 26.037 16.4882 25.6465 16.8788C25.256 17.2693 25.256 17.9024 25.6465 18.293L39.2323 31.7928L25.6465 46.2929C25.256 46.6834 25.256 47.3166 25.6465 47.7071C26.037 48.0976 26.6702 48.0976 27.0607 47.7071L41.3536 32.4999Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-big-down': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-big-down"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 65"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.2929 46.2071C31.6834 46.5976 32.3166 46.5976 32.7071 46.2071L54.7071 24.2071C55.0976 23.8166 55.0976 23.1834 54.7071 22.7929C54.3166 22.4024 53.6834 22.4024 53.2929 22.7929L32 44.0858L10.7071 22.7929C10.3166 22.4024 9.68342 22.4024 9.29289 22.7929C8.90237 23.1834 8.90237 23.8166 9.29289 24.2071L31.2929 46.2071Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-big-up': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-big-up"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.2929 18.2929C31.6834 17.9024 32.3166 17.9024 32.7071 18.2929L54.7071 40.2929C55.0976 40.6834 55.0976 41.3166 54.7071 41.7071C54.3166 42.0976 53.6834 42.0976 53.2929 41.7071L32 20.4142L10.7071 41.7071C10.3166 42.0976 9.68342 42.0976 9.29289 41.7071C8.90237 41.3166 8.90237 40.6834 9.29289 40.2929L31.2929 18.2929Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-big-left': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-big-left"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2929 32.7071C17.9024 32.3166 17.9024 31.6834 18.2929 31.2929L40.2929 9.29289C40.6834 8.90237 41.3166 8.90237 41.7071 9.29289C42.0976 9.68342 42.0976 10.3166 41.7071 10.7071L20.4142 32L41.7071 53.2929C42.0976 53.6834 42.0976 54.3166 41.7071 54.7071C41.3166 55.0976 40.6834 55.0976 40.2929 54.7071L18.2929 32.7071Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-big-right': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-big-right"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.7071 32.7071C46.0976 32.3166 46.0976 31.6834 45.7071 31.2929L23.7071 9.29289C23.3166 8.90237 22.6834 8.90237 22.2929 9.29289C21.9024 9.68342 21.9024 10.3166 22.2929 10.7071L43.5858 32L22.2929 53.2929C21.9024 53.6834 21.9024 54.3166 22.2929 54.7071C22.6834 55.0976 23.3166 55.0976 23.7071 54.7071L45.7071 32.7071Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-bar-left': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-bar-left"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12V52C18 52.5523 17.5523 53 17 53C16.4477 53 16 52.5523 16 52V12Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6464 32.4999C26.2559 32.1094 26.2559 31.4762 26.6464 31.0857L40.9393 16.8788C41.3298 16.4882 41.963 16.4882 42.3535 16.8788C42.744 17.2693 42.744 17.9024 42.3535 18.293L28.7677 31.7928L42.3535 46.2929C42.744 46.6834 42.744 47.3166 42.3535 47.7071C41.963 48.0976 41.3298 48.0976 40.9393 47.7071L26.6464 32.4999Z"
          fill="none"
        />
      </svg>
    ),
    'chevron-bar-right': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="chevron-bar-right"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 12C48 11.4477 47.5523 11 47 11C46.4477 11 46 11.4477 46 12V52C46 52.5523 46.4477 53 47 53C47.5523 53 48 52.5523 48 52V12Z"
          fill="none"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.3536 32.4999C37.7441 32.1094 37.7441 31.4762 37.3536 31.0857L23.0607 16.8788C22.6702 16.4882 22.037 16.4882 21.6465 16.8788C21.256 17.2693 21.256 17.9024 21.6465 18.293L35.2323 31.7928L21.6465 46.2929C21.256 46.6834 21.256 47.3166 21.6465 47.7071C22.037 48.0976 22.6702 48.0976 23.0607 47.7071L37.3536 32.4999Z"
          fill="none"
        />
      </svg>
    ),
    'arrow-down': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="arrow-down"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M32 57C32.2884 57 32.5482 56.878 32.7307 56.6827L47.7295 40.6839C48.1073 40.281 48.0869 39.6482 47.6839 39.2705C47.281 38.8927 46.6482 38.9131 46.2705 39.3161L33 53.4712V9C33 8.44772 32.5523 8 32 8C31.4477 8 31 8.44772 31 9V53.4712L17.7295 39.3161C17.3518 38.9131 16.719 38.8927 16.3161 39.2705C15.9131 39.6482 15.8927 40.281 16.2705 40.6839L31.268 56.6813C31.4506 56.8774 31.711 57 32 57Z"
          fill="none"
        />
      </svg>
    ),
    'arrow-up': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="arrow-up"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M32 8C32.2884 8 32.5482 8.12204 32.7307 8.31729L47.7295 24.3161C48.1073 24.719 48.0869 25.3518 47.6839 25.7295C47.281 26.1073 46.6482 26.0869 46.2705 25.6839L33 11.5288V56C33 56.5523 32.5523 57 32 57C31.4477 57 31 56.5523 31 56V11.5288L17.7295 25.6839C17.3518 26.0869 16.719 26.1073 16.3161 25.7295C15.9131 25.3518 15.8927 24.719 16.2705 24.3161L31.268 8.31866C31.4506 8.12261 31.711 8 32 8Z"
          fill="none"
        />
      </svg>
    ),
    'arrow-left': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="arrow-left"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M8 32C8 31.7117 8.12204 31.4518 8.31729 31.2693L24.3161 16.2705C24.719 15.8927 25.3518 15.9131 25.7295 16.3161C26.1073 16.719 26.0869 17.3518 25.6839 17.7295L11.5288 31L56 31C56.5523 31 57 31.4477 57 32C57 32.5523 56.5523 33 56 33L11.5288 33L25.6839 46.2705C26.0869 46.6482 26.1073 47.281 25.7295 47.6839C25.3518 48.0869 24.719 48.1073 24.3161 47.7295L8.31866 32.732C8.12261 32.5494 8 32.289 8 32Z"
          fill="none"
        />
      </svg>
    ),
    'arrow-right': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="arrow-right"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M57 32C57 31.7117 56.878 31.4518 56.6827 31.2693L40.6839 16.2705C40.281 15.8927 39.6482 15.9131 39.2705 16.3161C38.8927 16.719 38.9131 17.3518 39.3161 17.7295L53.4712 31L9 31C8.44772 31 8 31.4477 8 32C8 32.5523 8.44772 33 9 33L53.4712 33L39.3161 46.2705C38.9131 46.6482 38.8927 47.281 39.2705 47.6839C39.6482 48.0869 40.281 48.1073 40.6839 47.7295L56.6813 32.732C56.8774 32.5494 57 32.289 57 32Z"
          fill="none"
        />
      </svg>
    ),
    'curved-arrow-left-down': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="curved-arrow-left-down"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M6.72954 34.3161C6.35181 33.9131 5.71898 33.8927 5.31606 34.2705C4.91315 34.6482 4.89274 35.281 5.27047 35.6839L20.2705 51.6839C20.4595 51.8856 20.7236 52 21 52C21.2764 52 21.5405 51.8856 21.7295 51.6839L36.7295 35.6839C37.1073 35.281 37.0869 34.6482 36.6839 34.2705C36.281 33.8927 35.6482 33.9131 35.2705 34.3161L22 48.4712L22 21.4057C22 17.8117 24.7661 15 28.1602 15L57 15C57.5523 15 58 14.5523 58 14C58 13.4477 57.5523 13 57 13L28.1602 13C23.5985 13 20 16.7712 20 21.4057L20 48.4712L6.72954 34.3161Z"
          fill="none"
        />
      </svg>
    ),
    'curved-arrow-right-down': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="curved-arrow-right-down"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M57.2705 34.3161C57.6482 33.9131 58.281 33.8927 58.6839 34.2705C59.0868 34.6482 59.1073 35.281 58.7295 35.6839L43.7295 51.6839C43.5405 51.8856 43.2764 52 43 52C42.7236 52 42.4595 51.8856 42.2705 51.6839L27.2705 35.6839C26.8927 35.281 26.9131 34.6482 27.3161 34.2705C27.719 33.8927 28.3518 33.9131 28.7295 34.3161L42 48.4712L42 21.4057C42 17.8117 39.2339 15 35.8398 15L7 15C6.44771 15 6 14.5523 6 14C6 13.4477 6.44771 13 7 13L35.8398 13C40.4015 13 44 16.7712 44 21.4057L44 48.4712L57.2705 34.3161Z"
          fill="none"
        />
      </svg>
    ),
    'curved-arrow-left-up': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="curved-arrow-left-up"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M6.72954 29.6839C6.35181 30.0869 5.71898 30.1073 5.31606 29.7295C4.91315 29.3518 4.89274 28.719 5.27047 28.3161L20.2705 12.3161C20.4595 12.1144 20.7236 12 21 12C21.2764 12 21.5405 12.1144 21.7295 12.3161L36.7295 28.3161C37.1073 28.719 37.0869 29.3518 36.6839 29.7295C36.281 30.1073 35.6482 30.0869 35.2705 29.6839L22 15.5288L22 42.5943C22 46.1883 24.7661 49 28.1602 49L57 49C57.5523 49 58 49.4477 58 50C58 50.5523 57.5523 51 57 51L28.1602 51C23.5985 51 20 47.2288 20 42.5943L20 15.5288L6.72954 29.6839Z"
          fill="none"
        />
      </svg>
    ),
    'curved-arrow-right-up': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="curved-arrow-right-up"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M57.2705 29.6839C57.6482 30.0869 58.281 30.1073 58.6839 29.7295C59.0868 29.3518 59.1073 28.719 58.7295 28.3161L43.7295 12.3161C43.5405 12.1144 43.2764 12 43 12C42.7236 12 42.4595 12.1144 42.2705 12.3161L27.2705 28.3161C26.8927 28.719 26.9131 29.3518 27.3161 29.7295C27.719 30.1073 28.3518 30.0869 28.7295 29.6839L42 15.5288L42 42.5943C42 46.1883 39.2339 49 35.8398 49L7 49C6.44771 49 6 49.4477 6 50C6 50.5523 6.44771 51 7 51L35.8398 51C40.4015 51 44 47.2288 44 42.5943L44 15.5288L57.2705 29.6839Z"
          fill="none"
        />
      </svg>
    ),
    'curved-arrow-up-left': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="curved-arrow-up-left"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M29.6839 7.72954C30.0869 7.35181 30.1073 6.71897 29.7295 6.31606C29.3518 5.91315 28.719 5.89274 28.3161 6.27047L12.3161 21.2705C12.1144 21.4595 12 21.7236 12 22C12 22.2764 12.1144 22.5405 12.3161 22.7295L28.3161 37.7295C28.719 38.1073 29.3518 38.0869 29.7295 37.6839C30.1073 37.281 30.0869 36.6482 29.6839 36.2705L15.5288 23H42.5943C46.1883 23 49 25.7661 49 29.1602V58C49 58.5523 49.4477 59 50 59C50.5523 59 51 58.5523 51 58V29.1602C51 24.5985 47.2288 21 42.5943 21H15.5288L29.6839 7.72954Z"
          fill="none"
        />
      </svg>
    ),
    'curved-arrow-up-right': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="curved-arrow-up-right"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M33.3161 7.72954C32.9132 7.35181 32.8927 6.71897 33.2705 6.31606C33.6482 5.91315 34.281 5.89274 34.6839 6.27047L50.6839 21.2705C50.8856 21.4595 51 21.7236 51 22C51 22.2764 50.8856 22.5405 50.6839 22.7295L34.6839 37.7295C34.281 38.1073 33.6482 38.0869 33.2705 37.6839C32.8927 37.281 32.9132 36.6482 33.3161 36.2705L47.4712 23H20.4057C16.8117 23 14 25.7661 14 29.1602V58C14 58.5523 13.5523 59 13 59C12.4477 59 12 58.5523 12 58V29.1602C12 24.5985 15.7712 21 20.4057 21H47.4712L33.3161 7.72954Z"
          fill="none"
        />
      </svg>
    ),
    'curved-arrow-down-left': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="curved-arrow-down-left"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M30.6839 56.2705C31.0868 56.6482 31.1073 57.281 30.7295 57.6839C30.3518 58.0868 29.719 58.1073 29.3161 57.7295L13.3161 42.7295C13.1144 42.5405 13 42.2764 13 42C13 41.7236 13.1144 41.4595 13.3161 41.2705L29.3161 26.2705C29.719 25.8927 30.3518 25.9131 30.7295 26.3161C31.1073 26.719 31.0869 27.3518 30.6839 27.7295L16.5288 41L43.5943 41C47.1883 41 50 38.2339 50 34.8398L50 6C50 5.44772 50.4477 5 51 5C51.5523 5 52 5.44772 52 6L52 34.8398C52 39.4015 48.2288 43 43.5943 43L16.5288 43L30.6839 56.2705Z"
          fill="none"
        />
      </svg>
    ),
  },
  hardware: {
    calculator: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="calculator"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M21 40.5C21 39.9477 21.4477 39.5 22 39.5H23C23.5523 39.5 24 39.9477 24 40.5V41.5C24 42.0523 23.5523 42.5 23 42.5H22C21.4477 42.5 21 42.0523 21 41.5V40.5Z"
          fill="white"
        />
        <path
          className={color}
          d="M31 47.5C30.4477 47.5 30 47.9477 30 48.5V49.5C30 50.0523 30.4477 50.5 31 50.5H32C32.5523 50.5 33 50.0523 33 49.5V48.5C33 47.9477 32.5523 47.5 32 47.5H31Z"
          fill="white"
        />
        <path
          className={color}
          d="M21 48.5C21 47.9477 21.4477 47.5 22 47.5H23C23.5523 47.5 24 47.9477 24 48.5V49.5C24 50.0523 23.5523 50.5 23 50.5H22C21.4477 50.5 21 50.0523 21 49.5V48.5Z"
          fill="white"
        />
        <path
          className={color}
          d="M22 31.5C21.4477 31.5 21 31.9477 21 32.5V33.5C21 34.0523 21.4477 34.5 22 34.5H23C23.5523 34.5 24 34.0523 24 33.5V32.5C24 31.9477 23.5523 31.5 23 31.5H22Z"
          fill="white"
        />
        <path
          className={color}
          d="M30 40.5C30 39.9477 30.4477 39.5 31 39.5H32C32.5523 39.5 33 39.9477 33 40.5V41.5C33 42.0523 32.5523 42.5 32 42.5H31C30.4477 42.5 30 42.0523 30 41.5V40.5Z"
          fill="white"
        />
        <path
          className={color}
          d="M31 31.5C30.4477 31.5 30 31.9477 30 32.5V33.5C30 34.0523 30.4477 34.5 31 34.5H32C32.5523 34.5 33 34.0523 33 33.5V32.5C33 31.9477 32.5523 31.5 32 31.5H31Z"
          fill="white"
        />
        <path
          className={color}
          d="M39 32.5C39 31.9477 39.4477 31.5 40 31.5H41C41.5523 31.5 42 31.9477 42 32.5V33.5C42 34.0523 41.5523 34.5 41 34.5H40C39.4477 34.5 39 34.0523 39 33.5V32.5Z"
          fill="white"
        />
        <path
          className={color}
          d="M40 39.5C39.4477 39.5 39 39.9477 39 40.5V49.5C39 50.0523 39.4477 50.5 40 50.5H41C41.5523 50.5 42 50.0523 42 49.5V40.5C42 39.9477 41.5523 39.5 41 39.5H40Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 9.5C13 7.84314 14.3431 6.5 16 6.5H47C48.6569 6.5 50 7.84315 50 9.5V55.5C50 57.1569 48.6569 58.5 47 58.5H16C14.3431 58.5 13 57.1569 13 55.5V9.5ZM16 8.5H47C47.5523 8.5 48 8.94772 48 9.5V24.5H15V9.5C15 8.94772 15.4477 8.5 16 8.5ZM48 26.5V55.5C48 56.0523 47.5523 56.5 47 56.5H16C15.4477 56.5 15 56.0523 15 55.5V26.5H48Z"
          fill="white"
        />
      </svg>
    ),
  },
  media: {
    play: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="play"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M49.9998 32.0009L19.0002 51.0003L19.0002 13.0016L49.9998 32.0009Z"
          stroke="none"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    pause: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="pause"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M20 13.1765C20 12.5267 19.5523 12 19 12C18.4477 12 18 12.5267 18 13.1765V50.8235C18 51.4733 18.4477 52 19 52C19.5523 52 20 51.4733 20 50.8235L20 13.1765Z"
          fill="none"
        />
        <path
          className={color}
          d="M46 13.1765C46 12.5267 45.5523 12 45 12C44.4477 12 44 12.5267 44 13.1765L44 50.8235C44 51.4733 44.4477 52 45 52C45.5523 52 46 51.4733 46 50.8235L46 13.1765Z"
          fill="none"
        />
      </svg>
    ),
    stop: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="stop"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16 16H48V48H16V16V16Z"
          stroke="none"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    rewind: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="rewind"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16 16H48V48H16V16V16Z"
          stroke="none"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    'fast-forward': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="fast-forward"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <mask id="path-1-inside-1_8057_3414" fill="none">
          <path
            className={color}
            d="M53.577 32.8161C54.1384 32.4174 54.1384 31.584 53.577 31.1854L32.454 16.1864C31.7918 15.7162 30.875 16.1897 30.875 17.0018V29.178L12.579 16.1864C11.9168 15.7162 11 16.1897 11 17.0018V46.9997C11 47.8118 11.9168 48.2852 12.579 47.815L30.875 34.8235V46.9997C30.875 47.8118 31.7918 48.2852 32.454 47.815L53.577 32.8161Z"
          />
        </mask>
        <path
          className={color}
          d="M53.577 32.8161L54.7349 34.4468L53.577 32.8161ZM53.577 31.1854L54.7349 29.5546L53.577 31.1854ZM32.454 16.1864L33.6119 14.5557V14.5557L32.454 16.1864ZM30.875 29.178L29.7171 30.8087C30.3271 31.2418 31.1279 31.2983 31.7926 30.955C32.4574 30.6117 32.875 29.9261 32.875 29.178H30.875ZM12.579 16.1864L11.421 17.8171L11.421 17.8171L12.579 16.1864ZM12.579 47.815L11.421 46.1843L11.421 46.1843L12.579 47.815ZM30.875 34.8235H32.875C32.875 34.0753 32.4574 33.3897 31.7926 33.0464C31.1279 32.7031 30.3271 32.7596 29.7171 33.1927L30.875 34.8235ZM32.454 47.815L31.296 46.1843L31.296 46.1843L32.454 47.815ZM54.7349 34.4468C56.4191 33.2509 56.4191 30.7505 54.7349 29.5546L52.4191 32.8161C51.8577 32.4174 51.8577 31.584 52.4191 31.1854L54.7349 34.4468ZM54.7349 29.5546L33.6119 14.5557L31.296 17.8171L52.4191 32.8161L54.7349 29.5546ZM33.6119 14.5557C31.6255 13.1452 28.875 14.5655 28.875 17.0018H32.875C32.875 17.8139 31.9582 18.2873 31.296 17.8171L33.6119 14.5557ZM28.875 17.0018V29.178H32.875V17.0018H28.875ZM32.0329 27.5473L13.7369 14.5557L11.421 17.8171L29.7171 30.8087L32.0329 27.5473ZM13.7369 14.5557C11.7504 13.1452 9 14.5655 9 17.0018H13C13 17.8138 12.0832 18.2873 11.421 17.8171L13.7369 14.5557ZM9 17.0018V46.9997H13V17.0018H9ZM9 46.9997C9 49.4359 11.7505 50.8562 13.7369 49.4457L11.421 46.1843C12.0832 45.7141 13 46.1876 13 46.9997H9ZM13.7369 49.4457L32.0329 36.4542L29.7171 33.1927L11.421 46.1843L13.7369 49.4457ZM28.875 34.8235V46.9997H32.875V34.8235H28.875ZM28.875 46.9997C28.875 49.4359 31.6255 50.8562 33.6119 49.4457L31.296 46.1843C31.9582 45.7141 32.875 46.1876 32.875 46.9997H28.875ZM33.6119 49.4457L54.7349 34.4468L52.4191 31.1854L31.296 46.1843L33.6119 49.4457Z"
          fill="none"
          mask="url(#path-1-inside-1_8057_3414)"
        />
      </svg>
    ),
    'previous-song': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="previous-song"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M19.9174 32L50.9961 13.0024C50.9974 13.0016 50.9986 13.001 50.9995 13.0005C50.9996 13.0006 50.9998 13.0006 51 13.0007V50.9993C50.9998 50.9994 50.9997 50.9994 50.9995 50.9995C50.9986 50.999 50.9974 50.9984 50.9961 50.9976L19.9174 32ZM13 13.3707C13 13.3705 13 13.3702 13 13.3699C13 13.3702 13 13.3705 13 13.3707L13 50.6293V13.3707Z"
          stroke="none"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    'next-song': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="next-song"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M44.0826 32L13.0039 50.9975L13.5255 51.8508L13.0039 50.9976C13.0026 50.9984 13.0014 50.999 13.0005 50.9995C13.0004 50.9994 13.0002 50.9994 13 50.9993V13.0007C13.0002 13.0006 13.0003 13.0006 13.0005 13.0005C13.0014 13.001 13.0026 13.0016 13.0039 13.0024L44.0826 32Z"
          stroke="none"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  map: {
    'map-marker': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="map-marker"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 12.4889L31.9147 12.4852C23.8428 12.1395 16.4202 20.255 17.0166 28.981C17.1526 30.9704 18.1207 33.4629 19.6927 36.2129C21.2418 38.9226 23.2701 41.6999 25.312 44.2192C27.349 46.7323 29.3702 48.9527 30.8842 50.5463C31.2981 50.982 31.6734 51.3701 32 51.7037C32.3265 51.3701 32.7018 50.982 33.1156 50.5463C34.6296 48.9527 36.6508 46.7323 38.6877 44.2192C40.7297 41.7 42.7579 38.9226 44.307 36.2129C45.8791 33.463 46.8473 30.9704 46.9834 28.981C47.5798 20.255 40.1572 12.1395 32.0853 12.4852L32 12.4889ZM48.9622 29.115C48.2959 38.8524 32 54.5 32 54.5C32 54.5 15.7034 38.8524 15.0378 29.115C14.3722 19.377 22.5895 10.1096 32 10.5127C41.4105 10.1096 49.6278 19.377 48.9622 29.115ZM39.9333 27.564C39.9333 31.9257 36.3814 35.4615 32 35.4615C27.6185 35.4615 24.0666 31.9257 24.0666 27.564C24.0666 23.2024 27.6185 19.6666 32 19.6666C36.3814 19.6666 39.9333 23.2024 39.9333 27.564ZM37.95 27.564C37.95 30.8353 35.2861 33.4871 32 33.4871C28.7139 33.4871 26.05 30.8353 26.05 27.564C26.05 24.2928 28.7139 21.641 32 21.641C35.2861 21.641 37.95 24.2928 37.95 27.564Z"
          fill="white"
        />
      </svg>
    ),
    off: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="map-off"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.7083 9.79165C54.9748 10.0582 55.068 10.4523 54.9491 10.8099L40.3127 54.8185C40.173 55.2387 39.7726 55.5161 39.3301 55.4993C38.8876 55.4824 38.5094 55.1754 38.402 54.7458L32.6724 31.8276L9.75419 26.098C9.32461 25.9906 9.01757 25.6124 9.00073 25.1699C8.98388 24.7274 9.26128 24.327 9.68146 24.1873L53.6901 9.55091C54.0477 9.43197 54.4418 9.52515 54.7083 9.79165ZM13.5585 24.9964L33.735 30.0406C34.0917 30.1297 34.3703 30.4083 34.4594 30.765L39.5036 50.9415L52.4321 12.0679L13.5585 24.9964Z"
          fill="white"
        />
      </svg>
    ),
    'around-me': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="around-me"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M11.4783 52.1766L31.456 12.2619C31.8339 11.5068 32.8897 11.5068 33.2677 12.2619L53.2453 52.1766C53.7013 53.0877 52.7312 54.0536 51.8522 53.5635L32.8491 42.9678C32.5454 42.7985 32.1783 42.7985 31.8746 42.9678L12.8714 53.5635C11.9925 54.0536 11.0223 53.0877 11.4783 52.1766Z"
          fill="white"
        />
      </svg>
    ),
    recenter: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="recenter"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41 32.5C41 37.4706 36.9706 41.5 32 41.5C27.0294 41.5 23 37.4706 23 32.5C23 27.5294 27.0294 23.5 32 23.5C36.9706 23.5 41 27.5294 41 32.5ZM39 32.5C39 36.366 35.866 39.5 32 39.5C28.134 39.5 25 36.366 25 32.5C25 28.634 28.134 25.5 32 25.5C35.866 25.5 39 28.634 39 32.5Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.9741 31.5C50.4713 21.8026 42.6974 14.0287 33 13.5259V9.5C33 8.94772 32.5523 8.5 32 8.5C31.4477 8.5 31 8.94772 31 9.5V13.5259C21.3026 14.0287 13.5287 21.8026 13.0259 31.5H9C8.44772 31.5 8 31.9477 8 32.5C8 33.0523 8.44772 33.5 9 33.5H13.0259C13.5287 43.1974 21.3026 50.9713 31 51.4741V55.5C31 56.0523 31.4477 56.5 32 56.5C32.5523 56.5 33 56.0523 33 55.5V51.4741C42.6974 50.9713 50.4713 43.1974 50.9741 33.5H55C55.5523 33.5 56 33.0523 56 32.5C56 31.9477 55.5523 31.5 55 31.5H50.9741ZM15 32.5C15 23.1112 22.6112 15.5 32 15.5C41.3888 15.5 49 23.1112 49 32.5C49 41.8888 41.3888 49.5 32 49.5C22.6112 49.5 15 41.8888 15 32.5Z"
          fill="white"
        />
      </svg>
    ),
    compass: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="compass"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37 32.5C37 35.2614 34.7614 37.5 32 37.5C29.2386 37.5 27 35.2614 27 32.5C27 29.7386 29.2386 27.5 32 27.5C34.7614 27.5 37 29.7386 37 32.5ZM35 32.5C35 34.1569 33.6569 35.5 32 35.5C30.3431 35.5 29 34.1569 29 32.5C29 30.8431 30.3431 29.5 32 29.5C33.6569 29.5 35 30.8431 35 32.5Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.8786 14.1946C53.4478 12.602 51.9176 11.0601 50.3193 11.6157L22.7581 21.196C22.1874 21.3944 21.7359 21.8383 21.5281 22.4054L11.1271 50.79C10.5399 52.3924 12.0886 53.9525 13.6967 53.3786L41.6577 43.3989C42.2266 43.1958 42.6743 42.7484 42.8775 42.1799L52.8786 14.1946ZM23.4201 23.0978L50.9812 13.5174L40.9801 41.5027L13.019 51.4823L23.4201 23.0978Z"
          fill="white"
        />
      </svg>
    ),
    'locations-car-services': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="locations-car-services"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.0326 12.7637C46.4846 13.6433 46.1211 14.5478 45.8491 14.9906C45.8079 15.0576 45.759 15.1195 45.7033 15.175L41.3273 19.5359L44.9899 23.1859C45.5633 22.6044 46.271 21.8953 46.9664 21.2142C47.9701 20.2313 49.0073 19.2476 49.5603 18.825C49.9558 18.5228 50.4334 18.3364 50.9523 18.3827C51.4677 18.4288 51.877 18.6914 52.1646 19.004C52.713 19.6002 52.9444 20.4909 52.9138 21.3169C52.8788 22.264 52.8844 23.0047 52.893 23.6268C52.894 23.7011 52.8951 23.7744 52.8962 23.8468C52.904 24.3676 52.9111 24.8391 52.8875 25.271C52.8288 26.3487 52.5788 27.195 51.8684 28.4497C50.3828 31.0733 47.8294 32.8011 45.6537 33.2533C44.5891 33.4746 43.5107 33.4678 42.7212 33.413C42.3216 33.3852 41.9845 33.3443 41.7451 33.3099C41.6252 33.2927 41.5292 33.2771 41.4615 33.2654C41.4276 33.2595 41.4007 33.2546 41.3814 33.2511L41.3675 33.2484L38.2432 32.7447L15.9933 54.9178C15.2143 55.6941 13.954 55.6941 13.1749 54.9177L9.50355 51.259C8.72082 50.479 8.72083 49.2115 9.50355 48.4315L31.8074 26.2048C31.7847 25.5977 31.7191 24.8037 31.6464 23.9225C31.6254 23.6684 31.6038 23.407 31.5825 23.1407C31.4737 21.7824 31.372 20.2982 31.4439 19.2426C31.5453 17.7517 32.3026 16.3516 33.1755 15.2491C34.0543 14.139 35.139 13.2178 36.0682 12.6955C37.9299 11.649 40.0007 11.5412 43.0914 11.5007C44.4379 11.483 45.5476 11.8196 46.0326 12.7637ZM41.7342 31.2864L41.7344 31.2865L41.746 31.2886C41.7573 31.2907 41.7759 31.2941 41.8012 31.2985C41.8518 31.3072 41.9291 31.3199 42.0289 31.3342C42.2288 31.3629 42.5167 31.398 42.8595 31.4218C43.555 31.4701 44.4317 31.4687 45.2474 31.2991C46.8323 30.9697 48.9144 29.6153 50.1312 27.4663C50.7189 26.4285 50.8552 25.879 50.8943 25.1624C50.9138 24.8047 50.908 24.4094 50.9002 23.8749C50.8991 23.8039 50.898 23.7305 50.897 23.6544C50.8882 23.0183 50.8821 22.2392 50.919 21.2431C50.9271 21.0251 50.8983 20.8238 50.848 20.6601C50.8166 20.5575 50.7805 20.4817 50.7488 20.4291C50.3038 20.7749 49.3762 21.6481 48.3633 22.6402C47.3526 23.63 46.3138 24.6816 45.715 25.2986C45.529 25.4902 45.274 25.5994 45.007 25.6016C44.74 25.6038 44.4832 25.499 44.2941 25.3105L39.2088 20.2428C39.0209 20.0555 38.9152 19.8012 38.9152 19.5359C38.9152 19.2706 39.0209 19.0163 39.2088 18.829L44.1932 13.8619C44.2188 13.8065 44.2367 13.7515 44.2446 13.7052C44.2465 13.694 44.2476 13.6848 44.2483 13.6773C44.2293 13.6644 44.1968 13.646 44.1441 13.6249C43.9806 13.5596 43.6661 13.4893 43.1176 13.4965C39.9495 13.538 38.3966 13.6764 37.0465 14.4354C36.3698 14.8158 35.478 15.5565 34.7407 16.4879C33.9973 17.4269 33.4987 18.4479 33.4355 19.378C33.3755 20.2592 33.461 21.5908 33.5724 22.9814C33.5918 23.2246 33.6122 23.4701 33.6324 23.7145C33.7233 24.8123 33.8121 25.8851 33.8121 26.6107C33.8121 26.8759 33.7065 27.1303 33.5186 27.3175L10.9127 49.8453L10.2081 49.1384L10.9127 49.8453L14.5841 53.504L37.1948 30.9715C37.4213 30.7457 37.7424 30.6422 38.0582 30.6931L41.6993 31.2801C41.7106 31.282 41.7218 31.284 41.7329 31.2862C41.733 31.2862 41.7331 31.2862 41.7332 31.2862L41.7335 31.2863L41.7336 31.2863C41.7337 31.2863 41.7338 31.2863 41.7339 31.2863C41.734 31.2864 41.7341 31.2864 41.7342 31.2864ZM44.2711 13.6964C44.2709 13.6965 44.2692 13.6949 44.2667 13.6915C44.27 13.6946 44.2713 13.6963 44.2711 13.6964ZM44.2487 13.654C44.2484 13.6527 44.2483 13.652 44.2483 13.652L44.2487 13.654ZM50.8445 20.3657C50.8445 20.3657 50.8435 20.3661 50.8417 20.3667C50.8436 20.3659 50.8445 20.3656 50.8445 20.3657Z"
          fill="white"
        />
      </svg>
    ),
    'locations-charger': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="locations-charger"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.3705 6.57124C38.8 6.74255 39.056 7.18598 38.9897 7.64359L36.1555 27.189H46C46.3737 27.189 46.7161 27.3973 46.888 27.7291C47.0598 28.0609 47.0323 28.4608 46.8168 28.766L26.8168 57.0771C26.55 57.4547 26.059 57.6002 25.6295 57.4289C25.2 57.2576 24.944 56.8142 25.0104 56.3566L27.8445 36.8112H18C17.6264 36.8112 17.2839 36.6029 17.112 36.2711C16.9402 35.9393 16.9677 35.5394 17.1832 35.2342L37.1832 6.9231C37.45 6.54544 37.941 6.39994 38.3705 6.57124ZM19.9308 34.8112H29C29.2903 34.8112 29.5662 34.9373 29.7561 35.1568C29.9461 35.3763 30.0313 35.6674 29.9897 35.9547L27.5877 52.5195L44.0692 29.189H35C34.7097 29.189 34.4338 29.0629 34.2439 28.8434C34.0539 28.6239 33.9687 28.3327 34.0104 28.0455L36.4123 11.4807L19.9308 34.8112Z"
          fill="white"
        />
      </svg>
    ),
    'locations-bodyshop': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="locations-bodyshop"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M50.312 33.6114C50.8609 33.545 51.236 33.148 51.1499 32.7246C51.0638 32.3013 50.5491 32.0119 50.0002 32.0783C41.0308 33.1636 23.9847 33.1653 13.9863 32.0766C13.4362 32.0167 12.9273 32.3121 12.8496 32.7364C12.772 33.1607 13.155 33.5533 13.7051 33.6132C23.8792 34.7211 41.1262 34.7229 50.312 33.6114Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.434 15.8488C34.8463 15.3877 29.2977 15.3799 18.6985 15.8484C16.6665 15.9382 14.8856 16.9272 14.1229 18.38L9.86487 26.4915C8.55196 26.954 7.5023 27.6223 6.7449 28.5035C5.91698 29.4668 5.47941 30.6362 5.36622 31.9707C4.86597 37.8684 4.90537 39.0624 5.3198 46.6079C5.35454 47.2403 5.53249 47.8649 5.84562 48.4505L5.86734 48.4911C6.51749 49.7068 8.0541 50.5 9.75905 50.5H13.9082C14.6819 50.5 15.3914 50.1677 15.7483 49.6382L17.3439 47.2706C17.5384 46.9821 17.9249 46.8011 18.3465 46.8011H44.872C45.7399 46.8011 46.5266 47.1951 46.8797 47.8066L47.8871 49.5512C48.2203 50.1282 48.9626 50.5 49.7816 50.5H54.7455C55.908 50.5 56.9755 50.0048 57.5206 49.2128L57.8805 48.6898C58.3724 47.975 58.6506 47.1813 58.6966 46.3747L58.7302 45.7861C59.0673 39.8884 59.1439 38.5495 58.636 31.9752C58.5371 30.6951 58.2561 29.5157 57.4873 28.5318C56.7654 27.6077 55.6715 26.9279 54.1298 26.4679L50.0369 18.4219C49.2862 16.9463 47.4886 15.9383 45.434 15.8488ZM18.8136 17.3978C29.3347 16.9327 34.807 16.9403 45.3206 17.3982C46.5874 17.4534 47.6995 18.0757 48.164 18.9887L52.5954 27.7001L53.0419 27.8149C54.4636 28.1805 55.2675 28.6971 55.7641 29.3328C56.2826 29.9963 56.5356 30.8764 56.6276 32.0675C57.1294 38.5623 57.0556 39.8514 56.7216 45.6934L56.6866 46.3065C56.6536 46.8845 56.454 47.4527 56.1035 47.9622L55.7435 48.4852C55.5475 48.7701 55.1636 48.9481 54.7455 48.9481H49.7816C49.7571 48.9481 49.7349 48.937 49.725 48.9198L48.7176 47.1752C48.0412 46.0038 46.5344 45.2492 44.872 45.2492H18.3465C17.1742 45.2492 16.0995 45.7526 15.5588 46.5548L13.9632 48.9224C13.9525 48.9382 13.9313 48.9481 13.9082 48.9481H9.75905C8.86892 48.9481 8.06667 48.534 7.72723 47.8993L7.70552 47.8587C7.48206 47.4408 7.35475 46.9943 7.32992 46.5422C6.91714 39.0269 6.88007 37.8935 7.37384 32.072C7.47026 30.9353 7.83366 30.0453 8.42177 29.361C9.00436 28.6832 9.84812 28.1594 11.0154 27.7993L11.4134 27.6765L15.9878 18.9624C16.4597 18.0633 17.5614 17.4531 18.8136 17.3978Z"
          fill="white"
        />
      </svg>
    ),
    'locations-satellite-service': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="locations-satellite-service"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16.3147 44.464C15.7929 44.2897 15.2288 44.5723 15.0549 45.0952C14.8809 45.618 15.1629 46.1832 15.6847 46.3575C17.2951 46.8954 19.7581 47.2769 22.5564 47.5275C25.3772 47.7801 28.6134 47.9057 31.8118 47.9057C35.0098 47.9057 38.1854 47.7801 40.8844 47.5271C43.5478 47.2774 45.8553 46.895 47.2468 46.3373C47.7575 46.1326 48.006 45.5519 47.8017 45.0401C47.5974 44.5284 47.0176 44.2794 46.5069 44.4841C45.4083 44.9244 43.3581 45.2905 40.6989 45.5398C38.0754 45.7858 34.9636 45.9097 31.8118 45.9097C28.6605 45.9097 25.4846 45.7858 22.7338 45.5395C19.9606 45.2911 17.6925 44.9241 16.3147 44.464Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.6271 55.7314H20.3731L20.2795 55.828C19.9174 56.2021 19.5528 56.5788 19.1927 56.8537C18.6815 57.2438 18.1023 57.4999 17.3477 57.4999H12.7544C12.2227 57.4999 11.7382 57.3737 11.331 57.0962C10.9271 56.8209 10.6792 56.4513 10.5242 56.0996C10.2942 55.5775 10.2205 54.9342 10.1773 54.5567C10.1687 54.4821 10.1614 54.4179 10.1542 54.3671L10.1445 54.2979V54.115L10.0203 49.4409V48.4386L10.0186 48.3956C10.017 48.3534 10.0148 48.2925 10.0125 48.215C10.0079 48.0601 10.003 47.8385 10.001 47.5678C9.99703 47.0275 10.0049 46.2855 10.0531 45.4831C10.1012 44.6843 10.1905 43.8045 10.3545 42.9955C10.5106 42.2257 10.7547 41.4119 11.1728 40.8005C12.1731 39.1429 13.3336 38.4678 14.3753 38.1341C14.7127 38.026 15.0744 37.946 15.3381 37.8878C15.4325 37.8669 15.5148 37.8487 15.5783 37.8331C15.7152 37.7995 15.7978 37.772 15.8451 37.7536C15.8672 37.713 15.8924 37.6658 15.9212 37.612C15.9515 37.5553 16.0002 37.4638 16.0558 37.3591C16.1322 37.2155 16.2219 37.0471 16.2952 36.9099C16.596 36.3474 16.9906 35.6204 17.4187 34.8862C17.8445 34.1562 18.3152 33.3984 18.7691 32.7819C18.9956 32.4743 19.2313 32.1833 19.4671 31.943C19.6859 31.7201 19.978 31.4638 20.3248 31.3227L20.3372 31.3177C21.2795 30.9489 22.5734 30.7184 24.2289 30.574C25.9003 30.4283 28.0125 30.365 30.631 30.365H32.3691C34.9876 30.365 37.1 30.4283 38.7713 30.574C40.4268 30.7184 41.7207 30.9489 42.663 31.3177L42.6755 31.3226C43.0222 31.4637 43.3142 31.7201 43.533 31.943C43.7688 32.1833 44.0046 32.4743 44.2311 32.7819C44.685 33.3984 45.1556 34.1562 45.5813 34.8862C46.0095 35.6204 46.4042 36.3474 46.705 36.9099C46.7779 37.0461 46.8667 37.2132 46.9428 37.3562L46.9441 37.3587C46.9999 37.4636 47.0486 37.5552 47.0789 37.612C47.1077 37.6658 47.133 37.713 47.1551 37.7536C47.2024 37.772 47.2849 37.7995 47.4218 37.8331C47.4855 37.8487 47.5675 37.8668 47.6622 37.8878C47.9258 37.946 48.2876 38.026 48.6249 38.1341C49.6666 38.4678 50.8271 39.1429 51.8274 40.8005C52.2455 41.412 52.4896 42.2257 52.6457 42.9955C52.8097 43.8045 52.8989 44.6843 52.9469 45.4831C52.9952 46.2855 53.0032 47.0275 52.9992 47.5678C52.9972 47.8385 52.9921 48.0601 52.9876 48.215C52.9853 48.2925 52.9832 48.3534 52.9816 48.3956L52.9798 48.4386V49.4409L52.8556 54.1151V54.2979L52.846 54.3671C52.8389 54.4179 52.8315 54.4821 52.8229 54.5567C52.7797 54.9342 52.706 55.5776 52.476 56.0996C52.3211 56.4513 52.073 56.8209 51.6691 57.0962C51.2619 57.3737 50.7775 57.4999 50.2458 57.4999H45.6525C44.8979 57.4999 44.3187 57.2438 43.8075 56.8537C43.4474 56.5789 43.0834 56.2028 42.7214 55.8287L42.6271 55.7314ZM21.0845 33.1681C21.7573 32.9093 22.8162 32.7008 24.4017 32.5625C25.9891 32.424 28.0355 32.361 30.631 32.361H32.3691C34.9646 32.361 37.0111 32.424 38.5986 32.5625C40.184 32.7008 41.2428 32.9093 41.9156 33.1681C41.9156 33.1681 41.9178 33.1698 41.9209 33.1721C41.9391 33.185 42.0026 33.2304 42.1127 33.3425C42.258 33.4906 42.4316 33.7 42.628 33.9667C43.0198 34.499 43.4491 35.1862 43.8614 35.8931C44.2712 36.5959 44.6525 37.2979 44.9491 37.8526C45.0435 38.029 45.1098 38.1538 45.1707 38.2685C45.2209 38.3629 45.2674 38.4505 45.3229 38.5544C45.4084 38.7143 45.5026 38.8903 45.5646 38.9849L45.6186 39.0673L45.6875 39.1375C46.0877 39.5447 46.6102 39.6889 46.9479 39.7717C47.0936 39.8075 47.2215 39.8355 47.3425 39.8621C47.5689 39.9117 47.7709 39.956 48.0182 40.0353C48.6464 40.2365 49.4026 40.6292 50.1363 41.8558L50.155 41.8871L50.176 41.9169C50.3651 42.1863 50.5496 42.684 50.6934 43.393C50.832 44.0762 50.9135 44.8545 50.9585 45.6032C51.0034 46.3482 51.0109 47.0432 51.0071 47.553C51.0052 47.8073 51.0006 48.0141 50.9964 48.1563C50.9943 48.2273 50.9924 48.2821 50.991 48.3185L50.9893 48.359L50.9889 48.3684L50.9888 48.3706L50.9877 48.3937V49.4144L50.8636 54.0884V54.1598C50.8496 54.2638 50.84 54.347 50.831 54.4249C50.8173 54.5431 50.8049 54.65 50.7812 54.7985C50.7459 55.0189 50.7042 55.1787 50.6536 55.2936C50.6068 55.3998 50.5677 55.4329 50.5488 55.4458C50.5331 55.4565 50.4589 55.504 50.2458 55.504H45.6525C45.414 55.504 45.2483 55.4443 45.0146 55.2659C44.7842 55.0901 44.5574 54.8565 44.2143 54.503C44.1137 54.3994 44.003 54.2853 43.8793 54.1595C43.7669 54.0451 43.6337 53.9636 43.4916 53.9151C43.3301 53.8018 43.1334 53.7354 42.9213 53.7354H19.9548C19.6452 53.7354 19.3685 53.8769 19.1858 54.0989C19.1635 54.118 19.1419 54.1382 19.1209 54.1595C18.9974 54.2852 18.8868 54.3991 18.7863 54.5026C18.4431 54.8562 18.216 55.0901 17.9856 55.2659C17.7519 55.4443 17.5862 55.504 17.3477 55.504H12.7544C12.5414 55.504 12.467 55.4565 12.4513 55.4458C12.4324 55.4329 12.3934 55.3998 12.3466 55.2936C12.296 55.1787 12.2543 55.0189 12.219 54.7985C12.1953 54.6498 12.183 54.5435 12.1692 54.4251C12.1602 54.3471 12.1505 54.2639 12.1365 54.1598V54.0884L12.0124 49.4144V48.3937L12.0114 48.3706L12.0113 48.3684L12.0108 48.359L12.0092 48.3185C12.0078 48.2821 12.0058 48.2273 12.0037 48.1563C11.9995 48.0141 11.9948 47.8073 11.993 47.553C11.9892 47.0432 11.9968 46.3482 12.0417 45.6032C12.0867 44.8545 12.1681 44.0762 12.3067 43.393C12.4505 42.684 12.6351 42.1863 12.8243 41.9169L12.8451 41.8871L12.8639 41.8558C13.5977 40.6292 14.3538 40.2365 14.982 40.0353C15.2294 39.956 15.4312 39.9117 15.6576 39.8621C15.7785 39.8356 15.9067 39.8075 16.0523 39.7717C16.39 39.6889 16.9124 39.5447 17.3125 39.1375L17.3815 39.0673L17.4355 38.9849C17.4975 38.8903 17.5918 38.7143 17.6773 38.5544C17.7328 38.4506 17.7793 38.3631 17.8294 38.2687L17.8301 38.2673C17.8908 38.153 17.9572 38.0281 18.0511 37.8526C18.3477 37.2979 18.729 36.5959 19.1388 35.8931C19.5511 35.1862 19.9804 34.499 20.3722 33.9667C20.5686 33.7 20.7422 33.4906 20.8875 33.3425C20.9976 33.2304 21.061 33.185 21.0792 33.1721C21.0823 33.1698 21.0845 33.1681 21.0845 33.1681Z"
          fill="white"
        />
        <path
          className={color}
          d="M45.9532 19.8984C41.8409 23.0035 36.8184 24.8213 31.4052 24.8213C25.8632 24.8213 20.7127 22.8755 16.7217 19.7648C16.2918 19.4297 16.2173 18.8125 16.5553 18.3863C16.8934 17.9601 17.516 17.8863 17.946 18.2214C21.6078 21.0756 26.332 22.8579 31.4052 22.8579C36.3603 22.8579 40.9656 21.1962 44.753 18.3364C45.1881 18.0079 45.8095 18.0912 46.1409 18.5225C46.4723 18.9538 46.3883 19.5698 45.9532 19.8984Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.2818 18.2351C35.2157 18.2351 38.7516 16.9133 41.6214 14.812C42.0613 14.4899 42.1545 13.8752 41.8295 13.4391C41.5046 13.003 40.8845 12.9106 40.4445 13.2327C37.8833 15.108 34.7539 16.2716 31.2818 16.2716C27.9309 16.2716 24.6887 15.107 22.142 13.1258C21.7117 12.7911 21.0892 12.8655 20.7515 13.292C20.4138 13.7186 20.4888 14.3357 20.9191 14.6704C23.8035 16.9143 27.4735 18.2351 31.2818 18.2351Z"
          fill="white"
        />
        <path
          className={color}
          d="M37.4363 9.58408C35.7671 10.8445 33.5766 11.5246 31.4052 11.5246C29.0964 11.5246 27.047 10.8371 25.2811 9.60618C24.8336 9.29433 24.726 8.68197 25.0406 8.23844C25.3552 7.79491 25.9729 7.68816 26.4203 8.00001C27.8636 9.00595 29.5173 9.56113 31.4052 9.56113C33.1837 9.56113 34.9429 8.99859 36.2361 8.02213C36.6712 7.6936 37.2927 7.77691 37.6241 8.20823C37.9555 8.63955 37.8714 9.25555 37.4363 9.58408Z"
          fill="white"
        />
      </svg>
    ),
    'locations-charge-stop': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="locations-charge-stop"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.9999 51.953C32.3292 51.6151 32.7076 51.2219 33.125 50.7806C34.6517 49.1663 36.6898 46.9171 38.7439 44.3714C40.803 41.8194 42.8483 39.0059 44.4104 36.261C45.9957 33.4754 46.972 30.9505 47.1093 28.9352C47.7049 20.181 40.2766 12.2272 32 12.2271M49.1047 29.071C48.4328 38.9348 32 54.7856 32 54.7856C32 54.7856 15.5664 38.9348 14.8952 29.071C14.224 19.2065 22.5 10.2272 32 10.2271C41.4792 10.2272 49.7759 19.2065 49.1047 29.071ZM32 12.2271C23.7043 12.2272 16.2949 20.1794 16.8906 28.9352C17.0277 30.9504 18.004 33.4753 19.5893 36.261C21.1513 39.0059 23.1966 41.8193 25.2558 44.3713C27.3099 46.9171 29.3481 49.1662 30.8748 50.7806C31.2922 51.2219 31.6707 51.6151 31.9999 51.953"
          fill="white"
        />
        <path
          className={color}
          d="M31.1969 30.0965H27L34.3523 20.2001L33.303 27.7825H37.5L30.1476 37.0001L31.1969 30.0965Z"
          fill="white"
        />
      </svg>
    ),
    'locations-ea': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="locations-ea"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M32.3997 22.5154C34.9862 22.5154 36.3029 23.7652 36.3029 25.0151C36.3029 26.8204 34.4689 28.3479 27.7441 28.3479C26.7566 28.3479 25.6279 28.3016 24.4053 28.209C25.816 24.9688 28.7787 22.5154 32.3997 22.5154ZM42.0871 24.8299C42.0871 29.644 38.9834 32.514 28.4025 32.514C26.9447 32.514 25.3458 32.4214 23.5118 32.3288V32.4677C23.5118 35.7542 25.5809 37.7447 29.343 37.7447C31.9765 37.7447 33.7635 36.7726 35.3624 35.3839C35.7856 34.9673 36.397 34.6896 37.0553 34.6896C37.7607 34.6896 38.4191 35.0136 38.8423 35.4765L47.0719 24.8762L49 22.3766L42.0401 23.9504C42.0401 24.2744 42.0871 24.5522 42.0871 24.8299ZM32.6819 17.9791C35.0802 17.9791 37.0553 18.442 38.5602 19.2289L44.6736 1.5L25.8631 5.75863L19.9848 24.5985C22.6653 20.4787 27.3209 17.9791 32.6819 17.9791ZM17.6805 32.6528C17.6805 32.4214 17.6805 32.2362 17.7275 32.0048L15 40.7998L20.408 39.6425C18.574 37.8835 17.6805 35.4302 17.6805 32.6528ZM22.8534 41.309L16.3638 64.5L33.9046 41.8644C32.5408 42.3273 31.036 42.6051 29.2019 42.6051C26.6625 42.6051 24.5463 42.1422 22.8534 41.309Z"
          fill="white"
        />
      </svg>
    ),
    'closures-doors': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="closures-doors"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M13.6693 32.9177L13.6667 32.917C13.2561 32.8021 12.8303 33.0439 12.716 33.4573C12.6017 33.8707 12.842 34.2992 13.2527 34.4143C13.4597 34.4692 13.2536 34.4146 13.2536 34.4146L13.2552 34.415L13.2603 34.4164L13.278 34.4213C13.2932 34.4254 13.3151 34.4314 13.3436 34.4389C13.4007 34.4541 13.4843 34.4759 13.594 34.5033C13.8133 34.5582 14.1368 34.6358 14.5599 34.7286C15.4062 34.914 16.6513 35.16 18.2597 35.4054C21.4762 35.8964 26.1467 36.3856 31.986 36.3856C41.5009 36.3856 45.6846 35.2938 48.21 34.6347C48.3058 34.6097 48.3993 34.5853 48.4905 34.5616L48.5073 34.5577L48.574 34.5421C48.6298 34.5291 48.7043 34.5119 48.7804 34.4948C48.8574 34.4775 48.9322 34.4612 48.9897 34.4495C49.0033 34.4468 49.0149 34.4445 49.0245 34.4426C49.0315 34.4413 49.0374 34.4402 49.0424 34.4393C49.434 34.4018 49.7404 34.0698 49.7404 33.6656C49.7404 33.2364 49.3948 32.8885 48.9685 32.8885C48.8883 32.8885 48.8104 32.9023 48.7942 32.9051L48.792 32.9055C48.7579 32.9113 48.7203 32.9186 48.6843 32.9259C48.6115 32.9407 48.5248 32.9597 48.4444 32.9778C48.3631 32.996 48.2845 33.0142 48.2264 33.0277L48.1562 33.0441L48.1291 33.0505L48.1212 33.0524L48.1134 33.0544C48.0153 33.0798 47.9145 33.1062 47.8108 33.1333C45.3709 33.7708 41.3124 34.8314 31.986 34.8314C26.232 34.8314 21.6393 34.3492 18.4911 33.8687C16.917 33.6285 15.7043 33.3887 14.8883 33.2099C14.4804 33.1205 14.1716 33.0463 13.9665 32.995C13.864 32.9693 13.7874 32.9493 13.7372 32.936L13.6819 32.9211L13.6693 32.9177Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1501 26.59C15.1959 26.5794 15.24 26.5687 15.2832 26.5575C15.5226 26.4957 15.6074 26.4473 15.6351 26.4266C15.6424 26.4144 15.6519 26.3983 15.6639 26.3775C15.6968 26.3208 15.7392 26.2458 15.7914 26.1527C15.8474 26.0528 15.8986 25.9608 15.9549 25.8597L15.9557 25.8583C16.0222 25.7389 16.0962 25.6059 16.1935 25.4323C16.516 24.8567 16.9372 24.1158 17.3924 23.3704C17.8455 22.6283 18.3423 21.8652 18.8166 21.2512C19.0533 20.9446 19.2957 20.6606 19.5341 20.4308C19.7572 20.2158 20.0362 19.9892 20.352 19.8746C21.3369 19.5074 22.6801 19.2688 24.4389 19.1181C26.0221 18.9824 27.9813 18.915 30.3828 18.9022C30.4024 18.9007 30.4222 18.8999 30.4422 18.8999H32.7579C32.7779 18.8999 32.7977 18.9007 32.8173 18.9022C35.2188 18.915 37.178 18.9824 38.7612 19.1181C40.52 19.2688 41.8632 19.5074 42.8481 19.8746C43.1639 19.9892 43.4429 20.2158 43.666 20.4308C43.9044 20.6606 44.1468 20.9446 44.3835 21.2512C44.8578 21.8652 45.3546 22.6283 45.8077 23.3704C46.2629 24.1158 46.6841 24.8567 47.0066 25.4323C47.1039 25.606 47.1777 25.7384 47.2442 25.858C47.3008 25.9596 47.3525 26.0523 47.4087 26.1527C47.4609 26.2458 47.5033 26.3208 47.5362 26.3775C47.5482 26.3983 47.5577 26.4144 47.565 26.4266C47.5927 26.4473 47.6775 26.4957 47.9169 26.5575C47.9601 26.5687 48.0042 26.5794 48.05 26.59C48.6594 26.5891 49.1397 26.5717 49.593 26.5539L49.689 26.5501C50.1151 26.5333 50.5313 26.5168 51.0048 26.5165L53.0144 26.4448C53.5926 26.3692 54.2302 26.3693 54.7364 26.3693H54.7521L57.7153 26.2961L61.4678 26.1485H61.4835C62.4265 26.1485 63.2001 26.8441 63.2001 27.837V27.8663L63.1979 27.8956C62.9627 31.1434 61.7198 36.1086 60.4404 38.6508L60.4357 38.6598C59.8533 39.7821 59.0467 40.5525 57.8054 41.1028C56.7259 41.5814 55.3196 41.8921 53.4694 42.1658L53.4508 42.8158V42.8977L53.449 42.9244L53.4434 43.008C53.413 43.466 53.366 44.1741 53.0869 44.7685C52.9278 45.1074 52.6827 45.4385 52.3065 45.6793C51.9321 45.919 51.4846 46.0328 50.979 46.0336L46.0728 46.0998L46.0625 46.0999C45.3012 46.0999 44.7371 45.8708 44.2222 45.4983C43.9073 45.2705 43.5778 44.9585 43.2415 44.64L43.1418 44.5456H20.0583L19.959 44.6396C19.6226 44.9581 19.2928 45.2705 18.9779 45.4983C18.463 45.8708 17.8989 46.0999 17.1376 46.0999L17.1273 46.0998L12.2211 46.0336C11.7155 46.0328 11.268 45.919 10.8936 45.6793C10.5174 45.4385 10.2723 45.1074 10.1132 44.7685C9.8341 44.1741 9.7871 43.466 9.75671 43.008L9.7511 42.9244L9.74926 42.8977V42.8158L9.73067 42.1658C7.8805 41.8921 7.27424 41.5814 6.19471 41.1028C4.95337 40.5525 4.14681 39.7821 3.56436 38.6598L3.55972 38.6508C2.28035 36.1086 1.03735 31.1434 0.802166 27.8956L0.800049 27.8663V27.837C0.800049 26.8441 1.57364 26.1485 2.51663 26.1485H2.53225L6.28477 26.2961L9.24804 26.3693H9.26367C9.76992 26.3693 10.4075 26.3692 10.9857 26.4448L12.1953 26.5165C12.6688 26.5168 13.0849 26.5333 13.5111 26.5501L13.6071 26.5539C14.0604 26.5717 14.5407 26.5891 15.1501 26.59ZM20.8754 21.337L20.885 21.3334C22.1937 20.6358 28.3451 20.4566 31.2573 20.4542H31.9428C34.8549 20.4566 41.0064 20.6358 42.3151 21.3334L42.3247 21.337C42.3285 21.3387 42.3523 21.3498 42.3973 21.3819C42.45 21.4194 42.5171 21.4752 42.5984 21.5536C42.762 21.7113 42.9529 21.931 43.1648 22.2053C43.5879 22.7531 44.0504 23.4603 44.4925 24.1844C44.9326 24.9051 45.3427 25.6262 45.6619 26.1959C45.739 26.3336 45.8262 26.49 45.9037 26.629L45.9041 26.6297C45.9676 26.7438 46.0246 26.846 46.0641 26.9165C46.1597 27.087 46.2547 27.2555 46.3141 27.342L46.3291 27.3639L46.3456 27.3847C46.6859 27.8145 47.178 27.9713 47.5333 28.0631C47.5901 28.0777 47.6491 28.092 47.709 28.1059C47.7877 28.1367 47.8707 28.1556 47.9545 28.1606L47.9846 28.1672C48.0279 28.1767 48.0707 28.186 48.1119 28.1951C48.305 28.2379 48.4957 28.2828 48.6905 28.3411C49.4263 28.561 50.3021 28.9899 51.1434 30.3035L51.1501 30.3139L51.1571 30.324C51.3732 30.6391 51.5659 31.184 51.7138 31.9113C51.8576 32.6186 51.944 33.4189 51.9939 34.1828C52.0436 34.9438 52.0562 35.6529 52.0562 36.1726C52.0562 36.432 52.0531 36.643 52.05 36.7885C52.0484 36.8612 52.0469 36.9174 52.0458 36.955L52.0434 38.0221L51.907 42.7934V42.844C51.8705 43.3738 51.8354 43.7971 51.6911 44.1043C51.6285 44.2376 51.5581 44.3165 51.4782 44.3677C51.3978 44.4192 51.2503 44.4794 50.9736 44.4794L50.9633 44.4794L46.0577 44.5456C45.6621 44.5448 45.4085 44.4426 45.1231 44.2361C44.8926 44.0693 44.6817 43.8691 44.3954 43.5975L44.2671 43.4759C44.1388 43.206 43.8519 42.9913 43.565 42.9913H19.6351C19.3843 42.9913 19.1334 43.1555 18.9885 43.3771C18.9735 43.396 18.9588 43.415 18.9443 43.4337C18.8976 43.4939 18.8527 43.5518 18.8047 43.5975C18.5184 43.8691 18.3075 44.0693 18.077 44.2361C17.7916 44.4426 17.538 44.5448 17.1424 44.5456L12.2368 44.4794L12.2265 44.4794C11.9498 44.4794 11.8023 44.4192 11.7219 44.3677C11.642 44.3165 11.5716 44.2376 11.509 44.1043C11.3647 43.7971 11.3296 43.3738 11.2931 42.844V42.7934L11.1567 38.0221L11.1543 36.955C11.1532 36.9174 11.1517 36.8612 11.1501 36.7885C11.147 36.643 11.1439 36.432 11.1439 36.1726C11.1439 35.6529 11.1565 34.9438 11.2062 34.1828C11.2561 33.4189 11.3425 32.6186 11.4863 31.9113C11.6342 31.184 11.8269 30.6391 12.043 30.324L12.05 30.3139L12.0567 30.3035C12.898 28.9899 13.7738 28.561 14.5096 28.3411C14.7044 28.2828 14.8951 28.2379 15.0882 28.1951C15.1293 28.186 15.1718 28.1767 15.2151 28.1673C15.2251 28.1651 15.2355 28.1628 15.2456 28.1607C15.3293 28.1556 15.4124 28.1367 15.4911 28.1059C15.551 28.092 15.61 28.0777 15.6668 28.0631C16.0221 27.9713 16.5142 27.8145 16.8545 27.3847L16.871 27.3639L16.886 27.342C16.9454 27.2555 17.0404 27.087 17.136 26.9165C17.1755 26.846 17.2325 26.7438 17.296 26.6297L17.2977 26.6268C17.3748 26.4884 17.4615 26.3328 17.5382 26.1959C17.8574 25.6262 18.2675 24.9051 18.7076 24.1844C19.1497 23.4603 19.6122 22.7531 20.0353 22.2053C20.2472 21.931 20.4381 21.7113 20.6017 21.5536C20.683 21.4752 20.7501 21.4194 20.8028 21.3819C20.8478 21.3498 20.8716 21.3387 20.8754 21.337ZM11.8572 28.1162L10.8501 28.0518L10.8103 28.0463C10.3396 27.9815 9.78541 27.9801 9.23824 27.9801H9.22843L6.23392 27.9061L2.50542 27.7595C2.46952 27.7606 2.44591 27.767 2.43251 27.7722C2.41792 27.7778 2.41219 27.783 2.41096 27.7842C2.41096 27.7842 2.40856 27.7866 2.40678 27.7909C2.40544 27.7941 2.40236 27.8028 2.40087 27.8184C2.63125 30.8983 3.82565 35.6119 4.98475 37.9182C5.39495 38.7068 5.9248 39.2231 6.83956 39.6286C7.67222 39.9978 8.01891 40.2729 9.6839 40.5298L9.61284 38.0445V37.0532L9.6112 37.0021C9.60993 36.9602 9.60827 36.8993 9.60662 36.8218C9.60332 36.6667 9.60005 36.4444 9.60005 36.1726C9.60005 35.6299 9.61308 34.8852 9.66566 34.0807C9.71806 33.279 9.81069 32.402 9.97384 31.5996C10.1319 30.822 10.3721 30.03 10.7655 29.4513C11.1183 28.9021 11.4858 28.4656 11.8572 28.1162ZM52.4346 29.4513C52.0818 28.9021 51.7143 28.4656 51.3429 28.1162L53.15 28.0518L53.1898 28.0463C53.6605 27.9815 54.2147 27.9801 54.7619 27.9801H54.7717L57.7662 27.9061L61.4947 27.7595C61.5306 27.7606 61.5542 27.767 61.5676 27.7722C61.5822 27.7778 61.5879 27.783 61.5891 27.7842C61.5891 27.7842 61.5915 27.7866 61.5933 27.7909C61.5947 27.7941 61.5977 27.8028 61.5992 27.8184C61.3688 30.8983 60.1744 35.6119 59.0153 37.9182C58.6052 38.7068 58.0753 39.2231 57.1605 39.6286C56.3279 39.9978 55.1812 40.2729 53.5162 40.5298L53.5873 38.0445V37.0532L53.5889 37.0021C53.5902 36.9602 53.5918 36.8993 53.5935 36.8218C53.5968 36.6667 53.6 36.4444 53.6 36.1726C53.6 35.6299 53.587 34.8852 53.5344 34.0807C53.482 33.279 53.3894 32.402 53.2263 31.5996C53.0682 30.822 52.828 30.03 52.4346 29.4513Z"
          fill="white"
        />
      </svg>
    ),
    'range-map': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="range-map"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M24.0997 33.3081L34.9607 18.7036C35.2768 18.2785 35.9503 18.5725 35.8535 19.0934L33.6598 30.8927H39.5005C39.9116 30.8927 40.147 31.3612 39.9017 31.691L29.0407 46.2955C28.7245 46.7206 28.0511 46.4266 28.1479 45.9057L30.3416 34.1064H24.5009C24.0898 34.1064 23.8544 33.6379 24.0997 33.3081Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 32.5C57 46.3071 45.8071 57.5 32 57.5C18.1929 57.5 7 46.3071 7 32.5C7 18.6929 18.1929 7.5 32 7.5C45.8071 7.5 57 18.6929 57 32.5ZM55 32.5C55 45.2025 44.7025 55.5 32 55.5C19.2975 55.5 9 45.2025 9 32.5C9 19.7975 19.2975 9.5 32 9.5C44.7025 9.5 55 19.7975 55 32.5Z"
          fill="white"
        />
      </svg>
    ),
    'scheduled-charging': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="scheduled-charging"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.0457 16.8571C41.8959 14.5314 38.0746 13.0172 33.9132 12.6358V10.1071C33.9132 9.21999 33.09 8.5 32.0737 8.5C31.0573 8.5 30.2341 9.21999 30.2341 10.1071V12.597C26.0061 12.8939 22.1118 14.3585 18.8925 16.66L15.9384 13.8613L11.8381 17.967L14.6594 20.6402C11.7408 24.2409 10 28.7821 10 33.7178C10 45.4137 19.7753 54.8953 31.8336 54.8953C43.8918 54.8953 53.6663 45.4137 53.6663 33.7178C53.6663 28.8997 52.0076 24.4575 49.2138 20.8991L52.3083 17.967L48.208 13.8613L45.0457 16.8571ZM19.7103 20.0179L17.3241 22.4077C14.7524 25.5054 13.2114 29.4403 13.2114 33.7177C13.2114 43.6781 21.566 51.7809 31.8342 51.7809C42.1024 51.7809 50.4561 43.6781 50.4561 33.7177C50.4561 23.758 42.1024 15.6553 31.8342 15.6553C27.2082 15.6553 22.9706 17.2999 19.7103 20.0179ZM25.3333 35.1294H30.6627L29.3303 43.8958L38.6666 32.1909H33.3372L34.6695 22.5625L25.3333 35.1294Z"
          fill="white"
        />
      </svg>
    ),
    'ac-outlet': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="ac-outlet"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25 5.5C25 4.94772 24.5523 4.5 24 4.5C23.4477 4.5 23 4.94772 23 5.5V20.5H19.2216C17.4423 20.5 16 21.9423 16 23.7216V34.5C16 43.0009 22.6295 49.9533 31.0005 50.4693C31.0002 50.4795 31 50.4897 31 50.5V59.7036C31 60.2559 31.4477 60.7036 32 60.7036C32.5523 60.7036 33 60.2559 33 59.7036V50.5C33 50.4897 32.9998 50.4795 32.9995 50.4693C41.3705 49.9533 48 43.0009 48 34.5V23.7216C48 21.9423 46.5577 20.5 44.7784 20.5H42V5.5C42 4.94772 41.5523 4.5 41 4.5C40.4477 4.5 40 4.94772 40 5.5V20.5H25V5.5ZM18 23.7216C18 23.0469 18.5469 22.5 19.2216 22.5H44.7784C45.4531 22.5 46 23.0469 46 23.7216V34.5C46 42.232 39.732 48.5 32 48.5C24.268 48.5 18 42.232 18 34.5V23.7216Z"
          fill="white"
        />
      </svg>
    ),
    'map-service': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="map-service"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.1096 9.70988C53.4392 9.05453 55 10.0133 55 11.4854V44.2393C55 44.953 54.6132 45.6116 53.9872 45.9638L39.047 54.3708C38.7372 54.5451 38.3572 54.5429 38.0495 54.3649L23.5733 45.9928L13.1469 53.2288C11.8214 54.1487 10 53.2085 10 51.6044V19.6854C10 19.0224 10.3342 18.4033 10.8906 18.0355L22.9696 10.0518C23.2547 9.86335 23.6173 9.83277 23.9304 9.97074L38.5296 16.4037L52.1096 9.70988ZM37.5534 18.1435L24.5243 12.4023V44.2472L37.5534 51.7824V18.1435ZM39.5534 51.8059L53 44.2393V11.4854L39.5534 18.1134V51.8059ZM22.5243 44.3004V12.7292L12 19.6854V51.6044L22.5243 44.3004Z"
          fill="white"
        />
      </svg>
    ),
    food: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="food"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 8.5C18.5523 8.5 19 8.94772 19 9.5V22.5C19 23.6046 19.8954 24.5 21 24.5H24V9.5C24 8.94772 24.4477 8.5 25 8.5C25.5523 8.5 26 8.94772 26 9.5V24.5H29C30.1046 24.5 31 23.6046 31 22.5V9.5C31 8.94772 31.4477 8.5 32 8.5C32.5523 8.5 33 8.94772 33 9.5V22.5C33 24.7091 31.2091 26.5 29 26.5H26V55.5C26 56.0523 25.5523 56.5 25 56.5C24.4477 56.5 24 56.0523 24 55.5V26.5H21C18.7909 26.5 17 24.7091 17 22.5V9.5C17 8.94772 17.4477 8.5 18 8.5ZM39 14.5C39 11.1863 41.6863 8.5 45 8.5C46.1046 8.5 47 9.39543 47 10.5V55.5C47 56.0523 46.5523 56.5 46 56.5C45.4477 56.5 45 56.0523 45 55.5V33.5H41C39.8954 33.5 39 32.6046 39 31.5V14.5ZM45 31.5V10.5C42.7909 10.5 41 12.2909 41 14.5V31.5H45Z"
          fill="white"
        />
      </svg>
    ),
    coffee: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="coffee"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M25 7.5C25 6.94772 24.5523 6.5 24 6.5C23.4477 6.5 23 6.94772 23 7.5V20.5C23 21.0523 23.4477 21.5 24 21.5C24.5523 21.5 25 21.0523 25 20.5V7.5Z"
          fill="white"
        />
        <path
          className={color}
          d="M32 11.5C32 10.9477 31.5523 10.5 31 10.5C30.4477 10.5 30 10.9477 30 11.5V20.5C30 21.0523 30.4477 21.5 31 21.5C31.5523 21.5 32 21.0523 32 20.5V11.5Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 24.5C11.8954 24.5 11 25.3954 11 26.5V42.5C11 51.3366 18.1634 58.5 27 58.5H28C35.4554 58.5 41.7198 53.4009 43.4959 46.5H46.5C50.6421 46.5 54 43.1421 54 39C54 34.8579 50.6421 31.5 46.5 31.5H44V26.5C44 25.3954 43.1046 24.5 42 24.5H13ZM42 26.5H13V42.5C13 50.232 19.268 56.5 27 56.5H28C35.732 56.5 42 50.232 42 42.5V26.5ZM44 33.5H46.5C49.5376 33.5 52 35.9624 52 39C52 42.0376 49.5376 44.5 46.5 44.5H43.8762C43.9579 43.8448 44 43.1773 44 42.5V33.5Z"
          fill="white"
        />
      </svg>
    ),
    mountains: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="mountains"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9192 41.3938L32.9267 15.7098L39.4699 33.5946C39.8184 34.547 41.1606 34.5606 41.5282 33.6154L44.0788 27.0567L54.4372 49.4999H44.0001C43.4478 49.4999 43.0001 49.9476 43.0001 50.4999C43.0001 51.0522 43.4478 51.4999 44.0001 51.4999H55.8438C56.6466 51.4999 57.179 50.6679 56.8426 49.939L45.0067 24.2946C44.6 23.4134 43.3345 23.4524 42.9828 24.3569L40.5286 30.6675L34.0258 12.893C33.6836 11.9577 32.374 11.9223 31.9817 12.8376L20.0809 40.606C19.8634 41.1136 20.0985 41.7015 20.6062 41.9191C21.1138 42.1366 21.7017 41.9015 21.9192 41.3938ZM18.0921 36.919L16.0771 32.5532L9.46378 49.4999H39.0001C39.5524 49.4999 40.0001 49.9476 40.0001 50.4999C40.0001 51.0522 39.5524 51.4999 39.0001 51.4999H8.14646C7.37221 51.4999 6.84025 50.7213 7.12172 50L14.9831 29.8554C15.3357 28.9518 16.6001 28.9137 17.0066 29.7943L19.9081 36.0809C20.1395 36.5823 19.9206 37.1764 19.4191 37.4079C18.9177 37.6393 18.3236 37.4204 18.0921 36.919Z"
          fill="white"
        />
      </svg>
    ),
  },
  features: {
    'rear-wheel-drive': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="rear-wheel-drive"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 8C17.25 6.75736 18.2574 5.75 19.5 5.75H22.5C23.7426 5.75 24.75 6.75736 24.75 8V10.75H27.25V10.5C27.25 9.5335 28.0335 8.75 29 8.75H35C35.9665 8.75 36.75 9.5335 36.75 10.5V10.75H39.25V8C39.25 6.75736 40.2574 5.75 41.5 5.75H44.5C45.7426 5.75 46.75 6.75736 46.75 8V15C46.75 16.2426 45.7426 17.25 44.5 17.25H41.5C40.2574 17.25 39.25 16.2426 39.25 15V12.25H36.75V12.5C36.75 13.4665 35.9665 14.25 35 14.25H32.75V18.25H34.2639C35.3056 18.25 36.2578 18.8385 36.7236 19.7702L37.118 20.559C37.3298 20.9825 38.7626 21.25 39.2361 21.25H42C43.5188 21.25 44.75 22.4812 44.75 24V39C44.75 40.5188 43.5188 41.75 42 41.75H37.5207C37.0098 41.75 36.5738 42.1194 36.4898 42.6233C36.2853 43.8505 35.2235 44.75 33.9793 44.75H32.75V47.75H35C35.9665 47.75 36.75 48.5335 36.75 49.5V50.75H39.25V48C39.25 46.7574 40.2574 45.75 41.5 45.75H44.5C45.7426 45.75 46.75 46.7574 46.75 48V55C46.75 56.2426 45.7426 57.25 44.5 57.25H41.5C40.2574 57.25 39.25 56.2426 39.25 55V52.25H36.75V53.5C36.75 54.4665 35.9665 55.25 35 55.25H29C28.0335 55.25 27.25 54.4665 27.25 53.5V52.25H24.75V55C24.75 56.2426 23.7426 57.25 22.5 57.25H19.5C18.2574 57.25 17.25 56.2426 17.25 55V48C17.25 46.7574 18.2574 45.75 19.5 45.75H22.5C23.7426 45.75 24.75 46.7574 24.75 48V50.75H27.25V49.5C27.25 48.5335 28.0335 47.75 29 47.75H31.25V44.75H30.0207C28.7765 44.75 27.7147 43.8505 27.5102 42.6233C27.4262 42.1194 25.9902 41.75 25.4793 41.75H22C20.4812 41.75 19.25 40.5188 19.25 39V24C19.25 22.4812 20.4812 21.25 22 21.25H24.7639C25.2374 21.25 26.6702 20.9825 26.882 20.559L27.2764 19.7702C27.7422 18.8385 28.6944 18.25 29.7361 18.25H31.25V14.25H29C28.0335 14.25 27.25 13.4665 27.25 12.5V12.25H24.75V15C24.75 16.2426 23.7426 17.25 22.5 17.25H19.5C18.2574 17.25 17.25 16.2426 17.25 15V8ZM19.5 7.25C19.0858 7.25 18.75 7.58579 18.75 8V15C18.75 15.4142 19.0858 15.75 19.5 15.75H22.5C22.9142 15.75 23.25 15.4142 23.25 15V8C23.25 7.58579 22.9142 7.25 22.5 7.25H19.5ZM29 10.25C28.8619 10.25 28.75 10.3619 28.75 10.5V12.5C28.75 12.6381 28.8619 12.75 29 12.75H35C35.1381 12.75 35.25 12.6381 35.25 12.5V10.5C35.25 10.3619 35.1381 10.25 35 10.25H29ZM28.75 49.5C28.75 49.3619 28.8619 49.25 29 49.25H35C35.1381 49.25 35.25 49.3619 35.25 49.5V53.5C35.25 53.6381 35.1381 53.75 35 53.75H29C28.8619 53.75 28.75 53.6381 28.75 53.5V49.5ZM29.7361 19.75C29.2626 19.75 28.8298 20.0175 28.618 20.441L28.2236 21.2298C27.7578 22.1615 25.8056 22.75 24.7639 22.75H22C21.3096 22.75 20.75 23.3096 20.75 24V39C20.75 39.6904 21.3096 40.25 22 40.25H25.4793C26.7235 40.25 28.7853 41.1495 28.9898 42.3767C29.0738 42.8806 29.5098 43.25 30.0207 43.25H33.9793C34.4902 43.25 34.9262 42.8806 35.0102 42.3767C35.2147 41.1495 36.2765 40.25 37.5207 40.25H42C42.6904 40.25 43.25 39.6904 43.25 39V24C43.25 23.3096 42.6904 22.75 42 22.75H39.2361C38.1944 22.75 36.2422 22.1615 35.7764 21.2298L35.382 20.441C35.1702 20.0175 34.7374 19.75 34.2639 19.75H29.7361ZM40.75 8C40.75 7.58579 41.0858 7.25 41.5 7.25H44.5C44.9142 7.25 45.25 7.58579 45.25 8V15C45.25 15.4142 44.9142 15.75 44.5 15.75H41.5C41.0858 15.75 40.75 15.4142 40.75 15V8Z"
          fill="white"
        />
      </svg>
    ),
    'all-wheel-drive': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="all-wheel-drive"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 8C17.25 6.75736 18.2574 5.75 19.5 5.75H22.5C23.7426 5.75 24.75 6.75736 24.75 8V10.75H27.25V10.5C27.25 9.5335 28.0335 8.75 29 8.75H35C35.9665 8.75 36.75 9.5335 36.75 10.5V10.75H39.25V8C39.25 6.75736 40.2574 5.75 41.5 5.75H44.5C45.7426 5.75 46.75 6.75736 46.75 8V15C46.75 16.2426 45.7426 17.25 44.5 17.25H41.5C40.2574 17.25 39.25 16.2426 39.25 15V12.25H36.75V12.5C36.75 13.4665 35.9665 14.25 35 14.25H32.75V18.25H34.2639C35.3056 18.25 36.2578 18.8385 36.7236 19.7702L37.118 20.559C37.3298 20.9825 37.7626 21.25 38.2361 21.25H42C43.5188 21.25 44.75 22.4812 44.75 24V39C44.75 40.5188 43.5188 41.75 42 41.75H37.5207C37.0098 41.75 36.5738 42.1194 36.4898 42.6233C36.2853 43.8505 35.2235 44.75 33.9793 44.75H32.75V47.75H35C35.9665 47.75 36.75 48.5335 36.75 49.5V50.75H39.25V48C39.25 46.7574 40.2574 45.75 41.5 45.75H44.5C45.7426 45.75 46.75 46.7574 46.75 48V55C46.75 56.2426 45.7426 57.25 44.5 57.25H41.5C40.2574 57.25 39.25 56.2426 39.25 55V52.25H36.75V53.5C36.75 54.4665 35.9665 55.25 35 55.25H29C28.0335 55.25 27.25 54.4665 27.25 53.5V52.25H24.75V55C24.75 56.2426 23.7426 57.25 22.5 57.25H19.5C18.2574 57.25 17.25 56.2426 17.25 55V48C17.25 46.7574 18.2574 45.75 19.5 45.75H22.5C23.7426 45.75 24.75 46.7574 24.75 48V50.75H27.25V49.5C27.25 48.5335 28.0335 47.75 29 47.75H31.25V44.75H30.0207C28.7765 44.75 27.7147 43.8505 27.5102 42.6233C27.4262 42.1194 25.9902 41.75 25.4793 41.75H22C20.4812 41.75 19.25 40.5188 19.25 39V24C19.25 22.4812 20.4812 21.25 22 21.25H24.7639C25.2374 21.25 26.6702 20.9825 26.882 20.559L27.2764 19.7702C27.7422 18.8385 28.6944 18.25 29.7361 18.25H31.25V14.25H29C28.0335 14.25 27.25 13.4665 27.25 12.5V12.25H24.75V15C24.75 16.2426 23.7426 17.25 22.5 17.25H19.5C18.2574 17.25 17.25 16.2426 17.25 15V8ZM28.75 10.5C28.75 10.3619 28.8619 10.25 29 10.25H35C35.1381 10.25 35.25 10.3619 35.25 10.5V12.5C35.25 12.6381 35.1381 12.75 35 12.75H29C28.8619 12.75 28.75 12.6381 28.75 12.5V10.5ZM29 49.25C28.8619 49.25 28.75 49.3619 28.75 49.5V53.5C28.75 53.6381 28.8619 53.75 29 53.75H35C35.1381 53.75 35.25 53.6381 35.25 53.5V49.5C35.25 49.3619 35.1381 49.25 35 49.25H29ZM28.618 20.441C28.8298 20.0175 29.2626 19.75 29.7361 19.75H34.2639C34.7374 19.75 35.1702 20.0175 35.382 20.441L35.7764 21.2298C36.2422 22.1615 37.1944 22.75 38.2361 22.75H42C42.6904 22.75 43.25 23.3096 43.25 24V39C43.25 39.6904 42.6904 40.25 42 40.25H37.5207C36.2765 40.25 35.2147 41.1495 35.0102 42.3767C34.9262 42.8806 34.4902 43.25 33.9793 43.25H30.0207C29.5098 43.25 29.0738 42.8806 28.9898 42.3767C28.7853 41.1495 26.7235 40.25 25.4793 40.25H22C21.3096 40.25 20.75 39.6904 20.75 39V24C20.75 23.3096 21.3096 22.75 22 22.75H24.7639C25.8056 22.75 27.7578 22.1615 28.2236 21.2298L28.618 20.441Z"
          fill="white"
        />
      </svg>
    ),
    navigation: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="navigation"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M16 6.5C16.5523 6.5 17 6.94772 17 7.5C17 8.05228 16.5523 8.5 16 8.5H12C9.79086 8.5 8 10.2909 8 12.5V16.5C8 17.0523 7.55229 17.5 7 17.5C6.44771 17.5 6 17.0523 6 16.5V12.5C6 9.18629 8.68629 6.5 12 6.5H16Z"
          fill="white"
        />
        <path
          className={color}
          d="M47 7.5C47 6.94772 47.4477 6.5 48 6.5H52C55.3137 6.5 58 9.18629 58 12.5V16.5C58 17.0523 57.5523 17.5 57 17.5C56.4477 17.5 56 17.0523 56 16.5V12.5C56 10.2909 54.2091 8.5 52 8.5H48C47.4477 8.5 47 8.05228 47 7.5Z"
          fill="white"
        />
        <path
          className={color}
          d="M48 58.5C47.4477 58.5 47 58.0523 47 57.5C47 56.9477 47.4477 56.5 48 56.5H52C54.2091 56.5 56 54.7091 56 52.5V48.5C56 47.9477 56.4477 47.5 57 47.5C57.5523 47.5 58 47.9477 58 48.5V52.5C58 55.8137 55.3137 58.5 52 58.5H48Z"
          fill="white"
        />
        <path
          className={color}
          d="M17 57.5C17 58.0523 16.5523 58.5 16 58.5H12C8.68629 58.5 6 55.8137 6 52.5V48.5C6 47.9477 6.44771 47.5 7 47.5C7.55229 47.5 8 47.9477 8 48.5V52.5C8 54.7091 9.79086 56.5 12 56.5H16C16.5523 56.5 17 56.9477 17 57.5Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.9879 19.0588C44.4007 18.9215 44.8557 19.029 45.1633 19.3367C45.471 19.6443 45.5786 20.0993 45.4413 20.5121L35.8958 49.2134C35.7345 49.6984 35.2723 50.0186 34.7615 49.9992C34.2507 49.9797 33.8141 49.6253 33.6902 49.1294L30.0262 34.4738L15.3706 30.8099C14.8747 30.6859 14.5203 30.2493 14.5008 29.7385C14.4814 29.2278 14.8016 28.7655 15.2866 28.6042L43.9879 19.0588ZM19 29.5L31.2528 32.411C31.6646 32.5139 31.9861 32.8354 32.0891 33.2472L35 45.5L43 21.5L19 29.5Z"
          fill="white"
        />
      </svg>
    ),
    audio: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="audio"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31 18.539C31 16.7365 28.8669 15.8239 27.6009 17.0849L18.5597 26.0902H9C7.89543 26.0902 7 27.0013 7 28.1251V38.9102C7 40.034 7.89543 40.9451 9 40.9451H18.5936L27.6871 48.9962C28.9814 50.1422 31 49.2068 31 47.4611V18.539ZM19.9588 27.5443L29 18.539V47.4611L19.9065 39.41C19.5424 39.0877 19.0761 38.9102 18.5936 38.9102H9V28.1251H18.5597C19.0828 28.1251 19.5851 27.9166 19.9588 27.5443Z"
          fill="white"
        />
        <path
          className={color}
          d="M57 33.3576C57 28.0875 55.1085 23.3014 51.7423 19.5072C51.3722 19.0901 50.7399 19.0572 50.3299 19.4337C49.92 19.8102 49.8876 20.4536 50.2577 20.8707C53.3017 24.3018 55 28.6056 55 33.3576C55 38.0999 53.1799 42.5299 50.2443 45.9765C49.8826 46.4012 49.9277 47.0438 50.3451 47.4118C50.7625 47.7798 51.394 47.7339 51.7557 47.3092C54.974 43.5306 57 38.6376 57 33.3576Z"
          fill="white"
        />
        <path
          className={color}
          d="M45.9268 23.6701C47.8151 26.3788 49 29.7117 49 33.4159C49 37.0017 47.8162 40.4615 45.7986 43.1854C45.4662 43.6341 44.8392 43.7238 44.3981 43.3856C43.9571 43.0474 43.869 42.4094 44.2014 41.9606C45.9616 39.5843 47 36.553 47 33.4159C47 30.1653 45.9627 27.2389 44.2955 24.8474C43.9759 24.3891 44.0821 23.754 44.5326 23.4289C44.983 23.1038 45.6072 23.2118 45.9268 23.6701Z"
          fill="white"
        />
        <path
          className={color}
          d="M41 33.3587C41 31.4129 40.6229 29.4276 39.9027 27.8907C39.665 27.3835 39.0681 27.1683 38.5696 27.4102C38.0711 27.652 37.8597 28.2593 38.0973 28.7665C38.6629 29.9733 39 31.6463 39 33.3587C39 35.1733 38.6671 36.7471 38.0847 38.0933C37.8622 38.6076 38.0917 39.2081 38.5972 39.4344C39.1027 39.6608 39.6928 39.4274 39.9153 38.913C40.6187 37.287 41 35.4311 41 33.3587Z"
          fill="white"
        />
      </svg>
    ),
    'heated-seats': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="heated-seats"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9652 53.5172C15.947 53.5091 15.9085 53.4894 15.8482 53.4457C15.7116 53.3468 15.5336 53.1753 15.3212 52.9149C14.8974 52.3955 14.441 51.6526 13.9953 50.8133C13.1082 49.1428 12.3496 47.2554 12.0607 46.4459L12.0594 46.4424C11.9464 46.1293 11.9933 45.5702 12.4028 44.9863C12.7929 44.43 13.4614 43.9409 14.3878 43.7882C14.9339 43.6982 15.3028 43.1874 15.2118 42.6474C15.1208 42.1073 14.6043 41.7424 14.0582 41.8325C12.5787 42.0763 11.4428 42.8761 10.7553 43.8563C10.0875 44.8086 9.78352 46.0331 10.1707 47.1075C10.4837 47.9842 11.2785 49.9618 12.2203 51.7352C12.6893 52.6184 13.2165 53.4927 13.7608 54.1599C14.0323 54.4928 14.3344 54.8069 14.6634 55.0452C14.9841 55.2776 15.4165 55.5 15.9272 55.5H37.9812C41.473 55.5 43.4542 52.7403 44.6144 51.1148C44.8271 50.8168 45.067 50.3387 45.3121 49.8001C45.5682 49.2376 45.8636 48.5329 46.1844 47.7305C46.8264 46.1244 47.5826 44.0955 48.3487 41.9653C49.8808 37.7057 51.4646 33.0073 52.272 30.4122L52.2732 30.4082C53.2982 27.0629 53.84 23.834 53.9693 21.0328C54.0977 18.252 53.8232 15.8166 53.1509 14.099L53.1423 14.0778C52.4313 12.3786 51.0907 11.2488 49.9982 10.5601C49.4448 10.2112 48.9341 9.96207 48.5597 9.79921C48.3719 9.71753 48.2167 9.65685 48.1055 9.61562C48.0499 9.59499 48.0051 9.57916 47.9727 9.56799L47.9333 9.55467L47.9208 9.55057L47.9164 9.54915L47.9147 9.54859L47.9133 9.54814C47.6152 9.45276 47.2892 9.50071 47.032 9.67774C46.7749 9.85477 46.6162 10.1414 46.6031 10.451L46.603 10.4545L46.6023 10.4691L46.5997 10.5282C46.5973 10.5806 46.5936 10.6587 46.5886 10.7603C46.5786 10.9636 46.563 11.2609 46.5413 11.635C46.4978 12.3834 46.4294 13.4384 46.3298 14.6625C46.1303 17.1169 45.8077 20.2264 45.3153 22.9046C45.2162 23.4432 45.5775 23.9593 46.1222 24.0573C46.6669 24.1552 47.1888 23.7979 47.2878 23.2592C47.7979 20.4848 48.1269 17.2991 48.3283 14.8214C48.4186 13.7101 48.4837 12.7363 48.5281 11.999C48.6545 12.0696 48.786 12.1472 48.9204 12.232C49.8291 12.8049 50.79 13.6533 51.2838 14.8217L51.3527 15.0066C51.8364 16.3669 52.0831 18.4171 51.9665 20.9424C51.8452 23.5682 51.3347 26.6333 50.3554 29.83C50.3547 29.8323 50.3538 29.8352 50.3531 29.8374C50.3077 29.9834 50.2597 30.1363 50.2094 30.2954C49.3767 32.9296 47.8967 37.3055 46.4598 41.3009C45.6972 43.4212 44.9497 45.4259 44.3199 47.0016C44.0047 47.79 43.7221 48.4632 43.484 48.9861C43.235 49.5331 43.0644 49.8481 42.9764 49.9714C41.7308 51.7166 40.3036 53.5172 37.9812 53.5172H15.9652ZM47.9133 9.54814L48.1055 9.61562C48.0757 9.60461 47.9133 9.54814 47.9133 9.54814ZM15.9652 53.5172C15.9736 53.521 15.9777 53.5223 15.9777 53.5223C15.9777 53.5223 15.9604 53.5172 15.9272 53.5172H15.9652ZM51.3527 15.0066C51.3346 14.9556 51.3161 14.9056 51.2974 14.8566L51.3527 15.0066ZM51.2854 14.8255L51.2898 14.836L51.2974 14.8566C51.2934 14.8462 51.2894 14.8358 51.2854 14.8255ZM51.2854 14.8255L51.2812 14.8148L51.2838 14.8217C51.2843 14.823 51.2848 14.8243 51.2854 14.8255Z"
          fill="white"
        />
        <path
          className={color}
          d="M20.7114 25.4917L19.2488 25.4808C18.9461 25.4788 18.7596 25.1526 18.914 24.8949L21.6216 20.3652C21.775 20.1085 22.1519 20.1114 22.3013 20.3712L24.9297 24.9395C25.0791 25.2002 24.8876 25.5224 24.5849 25.5204L22.8697 25.5075C22.8697 25.5095 22.8697 25.5105 22.8687 25.5125C22.8547 25.5422 21.4703 28.5154 21.4703 31.8295C21.4703 34.0433 22.0276 35.0833 22.6732 36.2858C23.3469 37.5419 24.1097 38.9645 24.1097 41.671C24.1097 44.773 22.4015 48.1734 22.3284 48.3162C22.1519 48.6632 21.7991 48.8624 21.4322 48.8624C21.2808 48.8624 21.1274 48.8287 20.9831 48.7573C20.4889 48.5115 20.2884 47.9167 20.536 47.4269C20.552 47.3962 22.1048 44.2971 22.1048 41.671C22.1048 39.4573 21.5475 38.4184 20.902 37.2149L20.8999 37.211C20.2277 35.9568 19.4654 34.5343 19.4654 31.8295C19.4654 29.133 20.2433 26.7071 20.7114 25.4917Z"
          fill="white"
        />
        <path
          className={color}
          d="M28.6531 25.4927L27.1334 25.4808C26.8296 25.4788 26.6432 25.1526 26.7976 24.8949L29.5052 20.3652C29.6596 20.1085 30.0365 20.1114 30.1848 20.3712L32.8133 24.9395C32.9626 25.2002 32.7722 25.5224 32.4694 25.5204L30.8094 25.5075C30.7943 25.5392 29.43 28.5134 29.43 31.8295C29.43 34.0433 29.9874 35.0833 30.6329 36.2858C31.3066 37.5419 32.0695 38.9645 32.0695 41.671C32.0695 44.773 30.3613 48.1734 30.2881 48.3162C30.1127 48.6632 29.7588 48.8624 29.3919 48.8624C29.2415 48.8624 29.0872 48.8287 28.9438 48.7573C28.4486 48.5125 28.2481 47.9167 28.4957 47.4269C28.5117 47.3962 30.0646 44.2971 30.0646 41.671C30.0646 39.4573 29.5072 38.4184 28.8617 37.2149C28.1881 35.9598 27.4251 34.537 27.4251 31.8295C27.4251 29.132 28.193 26.7051 28.6531 25.4927Z"
          fill="white"
        />
        <path
          className={color}
          d="M35.1794 25.4808L36.5949 25.4917C36.1057 26.714 35.2967 29.137 35.2967 31.8295C35.2967 34.537 36.0596 35.9596 36.7332 37.2147C37.3788 38.4182 37.9362 39.4573 37.9362 41.671C37.9362 44.2971 36.3834 47.3962 36.3673 47.4269C36.1197 47.9167 36.3202 48.5115 36.8144 48.7573C36.9588 48.8287 37.1122 48.8624 37.2635 48.8624C37.6304 48.8624 37.9833 48.6632 38.1597 48.3162C38.2319 48.1734 39.9411 44.773 39.9411 41.671C39.9411 38.9645 39.1782 37.5419 38.5046 36.2858C37.859 35.0833 37.3016 34.0433 37.3016 31.8295C37.3016 28.5243 38.7452 25.5581 38.7602 25.5283C38.7617 25.5249 38.7622 25.5214 38.7627 25.5179C38.7632 25.5145 38.7637 25.511 38.7652 25.5075L40.5155 25.5204C40.8182 25.5224 41.0097 25.2002 40.8603 24.9395L38.2319 20.3712C38.0825 20.1114 37.7066 20.1085 37.5522 20.3652L34.8446 24.8949C34.6902 25.1526 34.8767 25.4788 35.1794 25.4808Z"
          fill="white"
        />
      </svg>
    ),
    'ventilated-seats': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="ventilated-seats"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M51.2854 15.3255L51.2898 15.336L51.2937 15.3471C51.291 15.3399 51.2882 15.3327 51.2854 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.9147 10.0486L47.9133 10.0481C47.6152 9.95276 47.2892 10.0007 47.032 10.1777C46.7749 10.3548 46.6162 10.6414 46.6031 10.951L46.603 10.9545L46.6023 10.9691L46.5997 11.0282C46.5973 11.0806 46.5936 11.1587 46.5886 11.2603C46.5786 11.4636 46.563 11.7609 46.5413 12.135C46.4978 12.8834 46.4294 13.9384 46.3298 15.1625C46.1303 17.6169 45.8077 20.7264 45.3153 23.4046C45.2162 23.9432 45.5775 24.4593 46.1222 24.5573C46.6669 24.6552 47.1888 24.2979 47.2878 23.7592C47.7979 20.9848 48.1269 17.7991 48.3283 15.3214C48.4186 14.2101 48.4837 13.2363 48.5281 12.499C48.6545 12.5696 48.786 12.6472 48.9204 12.732C49.8287 13.3046 50.7892 14.1526 51.2831 15.3202L51.406 15.6621L51.2937 15.3471C51.8162 16.7041 52.0877 18.8164 51.9665 21.4424C51.8452 24.0682 51.3346 27.1335 50.3553 30.3303C50.3539 30.335 50.3523 30.3402 50.3508 30.3449C49.5527 32.9084 47.9821 37.5681 46.4598 41.8009C45.6972 43.9212 44.9497 45.9259 44.3199 47.5016C44.0047 48.29 43.7221 48.9632 43.484 49.4861C43.235 50.0331 43.0644 50.3481 42.9764 50.4714C41.7308 52.2166 40.3036 54.0172 37.9812 54.0172H15.9652C15.947 54.0091 15.9085 53.9894 15.8482 53.9457C15.7116 53.8468 15.5336 53.6753 15.3212 53.4149C14.8974 52.8955 14.441 52.1526 13.9953 51.3133C13.1082 49.6428 12.3496 47.7554 12.0607 46.9459L12.0594 46.9424C11.9464 46.6293 11.9933 46.0702 12.4028 45.4863C12.7929 44.93 13.4614 44.4409 14.3878 44.2882C14.9339 44.1982 15.3028 43.6874 15.2118 43.1474C15.1208 42.6073 14.6043 42.2424 14.0582 42.3325C12.5787 42.5763 11.4428 43.3761 10.7553 44.3563C10.0875 45.3086 9.78352 46.5331 10.1707 47.6075C10.1813 47.6373 10.1925 47.6684 10.2043 47.7007C10.5379 48.6185 11.3105 50.5221 12.2203 52.2352C12.6893 53.1184 13.2165 53.9927 13.7608 54.6599C14.0323 54.9928 14.3344 55.3069 14.6634 55.5452C14.9841 55.7776 15.4165 56 15.9272 56H37.9812C41.473 56 43.4542 53.2403 44.6144 51.6148C44.8271 51.3168 45.067 50.8387 45.3121 50.3001C45.5682 49.7376 45.8636 49.0329 46.1844 48.2305C46.8264 46.6244 47.5826 44.5955 48.3487 42.4653C49.8808 38.2057 51.4646 33.5073 52.272 30.9122L52.2732 30.9082C53.2982 27.5629 53.84 24.334 53.9693 21.5328C54.0977 18.752 53.8232 16.3166 53.1509 14.599L53.1423 14.5778C52.4313 12.8786 51.0907 11.7488 49.9982 11.0601C49.4448 10.7112 48.9341 10.4621 48.5597 10.2992C48.3719 10.2175 48.2167 10.1568 48.1055 10.1156C48.0499 10.095 48.0051 10.0792 47.9727 10.068L47.9333 10.0547L47.9208 10.0506L47.9164 10.0491L47.9147 10.0486ZM51.2854 15.3255L51.2812 15.3148L51.2831 15.3202C51.2839 15.322 51.2846 15.3238 51.2854 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          d="M15.9652 54.0172C15.9736 54.021 15.9777 54.0223 15.9777 54.0223C15.9777 54.0223 15.9604 54.0172 15.9272 54.0172H15.9652Z"
          fill="white"
        />
        <path
          className={color}
          d="M28.2357 38.8898C26.8543 41.0104 25.1391 41.859 23.2675 41.396C21.3959 40.9341 20.3093 39.2517 19.9003 37.3621C19.4913 35.4735 19.3299 33.8784 19.9394 33.3619C20.2685 33.0833 20.898 33.1857 21.8165 33.3352C22.6495 33.4708 23.7201 33.6451 25.0198 33.6088C26.7711 33.5592 28.1916 33.4035 29.0758 33.2429C27.8498 32.9039 25.7286 32.2337 24.281 31.3117C22.1368 29.9456 21.2797 28.2494 21.7468 26.3985C22.215 24.5476 23.9151 23.4729 25.8258 23.0684C27.7365 22.6629 29.3494 22.5043 29.8707 23.1071C30.1524 23.4324 30.0489 24.0548 29.8979 24.9626C29.761 25.7864 29.5849 26.8452 29.6221 28.1304C29.6722 29.8623 29.8286 31.2681 29.992 32.1425C30.3338 30.9291 31.0125 28.8323 31.9448 27.4007C33.3262 25.2802 35.0414 24.4326 36.9129 24.8945C38.7845 25.3575 39.8702 27.0399 40.2802 28.9285C40.6892 30.818 40.8506 32.4132 40.2411 32.9287C39.9121 33.2073 39.2824 33.1049 38.3642 32.9556C37.531 32.8201 36.4601 32.646 35.1607 32.6828C33.4094 32.7324 31.9889 32.887 31.1037 33.0486C32.3307 33.3867 34.4519 34.0569 35.8995 34.9788C38.0427 36.346 38.9008 38.0422 38.4327 39.8921C37.9655 41.743 36.2644 42.8187 34.3547 43.2232C32.444 43.6276 30.8311 43.7872 30.3088 43.1845C30.0278 42.8588 30.1312 42.2369 30.282 41.33C30.419 40.5059 30.5951 39.4464 30.5574 38.1602C30.5083 36.4282 30.3509 35.0225 30.1885 34.1481C29.8456 35.3615 29.168 37.4593 28.2357 38.8898Z"
          fill="white"
        />
      </svg>
    ),
    'heated-ventilated-seats': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="heated-ventilated-seats"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9652 54.0172C15.947 54.0091 15.9085 53.9894 15.8482 53.9457C15.7116 53.8468 15.5336 53.6753 15.3212 53.4149C14.8974 52.8955 14.441 52.1526 13.9953 51.3133C13.1082 49.6428 12.3496 47.7554 12.0607 46.9459L12.0594 46.9424C11.9464 46.6293 11.9933 46.0702 12.4028 45.4863C12.7929 44.93 13.4614 44.4409 14.3878 44.2882C14.9339 44.1982 15.3028 43.6874 15.2118 43.1474C15.1208 42.6073 14.6043 42.2424 14.0582 42.3325C12.5787 42.5763 11.4428 43.3761 10.7553 44.3563C10.0875 45.3086 9.78352 46.5331 10.1707 47.6075C10.4837 48.4842 11.2785 50.4618 12.2203 52.2352C12.6893 53.1184 13.2165 53.9927 13.7608 54.6599C14.0323 54.9928 14.3344 55.3069 14.6634 55.5452C14.9841 55.7776 15.4165 56 15.9272 56H37.9812C41.473 56 43.4542 53.2403 44.6144 51.6148C44.8271 51.3168 45.067 50.8387 45.3121 50.3001C45.5682 49.7376 45.8636 49.0329 46.1844 48.2305C46.8264 46.6244 47.5826 44.5955 48.3487 42.4653C49.8808 38.2057 51.4646 33.5073 52.272 30.9122L52.2732 30.9082C53.2982 27.5629 53.84 24.334 53.9693 21.5328C54.0977 18.752 53.8232 16.3166 53.1509 14.599L53.1423 14.5778C52.4313 12.8786 51.0907 11.7488 49.9982 11.0601C49.4448 10.7112 48.9341 10.4621 48.5597 10.2992C48.3719 10.2175 48.2167 10.1568 48.1055 10.1156C48.0499 10.095 48.0051 10.0792 47.9727 10.068L47.9333 10.0547L47.9208 10.0506L47.9165 10.0491L47.9269 10.0529C47.9184 10.0499 47.9133 10.0481 47.9133 10.0481C47.6152 9.95276 47.2892 10.0007 47.032 10.1777C46.7749 10.3548 46.6162 10.6414 46.6031 10.951L46.603 10.9545L46.6023 10.9691L46.5997 11.0282C46.5973 11.0806 46.5936 11.1587 46.5886 11.2603C46.5786 11.4636 46.563 11.7609 46.5413 12.135C46.4978 12.8834 46.4294 13.9384 46.3298 15.1625C46.1303 17.6169 45.8077 20.7264 45.3153 23.4046C45.2162 23.9432 45.5775 24.4593 46.1222 24.5573C46.6669 24.6552 47.1888 24.2979 47.2878 23.7592C47.7979 20.9848 48.1269 17.7991 48.3283 15.3214C48.4186 14.2101 48.4837 13.2363 48.5281 12.499C48.6545 12.5696 48.786 12.6472 48.9204 12.732C49.8291 13.3049 50.79 14.1533 51.2838 15.3217L51.3527 15.5066C51.8364 16.8669 52.0831 18.9171 51.9665 21.4424C51.8452 24.0682 51.3347 27.1333 50.3554 30.33L50.3531 30.3374C50.3077 30.4834 50.2597 30.6363 50.2094 30.7954C49.3767 33.4296 47.8967 37.8055 46.4598 41.8009C45.6972 43.9212 44.9497 45.9259 44.3199 47.5016C44.0047 48.29 43.7221 48.9632 43.484 49.4861C43.235 50.0331 43.0644 50.3481 42.9764 50.4714C41.7308 52.2166 40.3036 54.0172 37.9812 54.0172H15.9652ZM15.9652 54.0172L15.974 54.021L15.9777 54.0223C15.9777 54.0223 15.9604 54.0172 15.9272 54.0172H15.9652ZM51.3527 15.5066C51.3346 15.4556 51.3161 15.4056 51.2974 15.3566L51.3527 15.5066ZM51.2854 15.3255L51.2898 15.336L51.2974 15.3566L51.2854 15.3255ZM51.2854 15.3255L51.2812 15.3148L51.2838 15.3217L51.2854 15.3255ZM48.1055 10.1156L47.9269 10.0529C47.9666 10.0667 48.081 10.1066 48.1055 10.1156Z"
          fill="white"
        />
        <path
          className={color}
          d="M14.1424 29.9154C15.7188 30.3096 17.1634 29.5869 18.3269 27.781C19.1121 26.5626 19.6829 24.7761 19.9716 23.7426C20.1084 24.4873 20.241 25.6845 20.2823 27.1595C20.3141 28.2549 20.1658 29.1572 20.0504 29.8591C19.9234 30.6314 19.8363 31.1611 20.073 31.4385C20.3193 31.7259 20.8536 31.8098 21.5588 31.7675L25.6375 25.0932C25.3862 24.8706 25.1009 24.656 24.7817 24.4502C23.5625 23.665 21.7759 23.0942 20.7425 22.8063C21.488 22.6687 22.6844 22.537 24.1595 22.4947C25.254 22.4634 26.1559 22.6117 26.8576 22.7271C27.631 22.8542 28.1614 22.9414 28.4385 22.7041C28.9518 22.2651 28.8159 20.9066 28.4714 19.2974C28.1261 17.689 27.2117 16.2562 25.6353 15.8619C24.059 15.4684 22.6144 16.1903 21.4509 17.9963C20.6657 19.2155 20.0941 21.0012 19.8061 22.0346C19.6685 21.2899 19.5368 20.0927 19.4946 18.6177C19.4633 17.5232 19.6116 16.6214 19.7269 15.9199C19.8541 15.1468 19.9412 14.6167 19.704 14.3396C19.2649 13.8263 17.9064 13.9613 16.2971 14.3067C14.6879 14.6511 13.2559 15.5664 12.8616 17.1427C12.4682 18.719 13.1901 20.1636 14.9961 21.3271C16.2153 22.1123 18.0018 22.683 19.0344 22.9718C18.2897 23.1086 17.0933 23.2411 15.6183 23.2833C14.5237 23.3142 13.6219 23.1658 12.9203 23.0504C12.1467 22.923 11.6165 22.8358 11.3393 23.0731C10.826 23.513 10.9619 24.8715 11.3064 26.4799C11.6509 28.0891 12.5661 29.5219 14.1424 29.9154Z"
          fill="white"
        />
        <path
          className={color}
          d="M26.2331 30.5671L25.172 30.5593C24.9524 30.5579 24.8171 30.3255 24.9291 30.1418L26.8935 26.9138C27.0048 26.7308 27.2782 26.7329 27.3866 26.918L29.2936 30.1736C29.4019 30.3594 29.263 30.589 29.0434 30.5876L27.799 30.5784L27.7983 30.5819C27.7881 30.6031 26.7837 32.7219 26.7837 35.0838C26.7837 36.6614 27.1881 37.4025 27.6564 38.2595C28.1452 39.1547 28.6986 40.1685 28.6986 42.0973C28.6986 44.3079 27.4593 46.7313 27.4062 46.833C27.2782 47.0803 27.0222 47.2223 26.7561 47.2223C26.6462 47.2223 26.535 47.1983 26.4302 47.1474C26.0717 46.9722 25.9262 46.5483 26.1059 46.1993C26.1175 46.1774 27.2441 43.9688 27.2441 42.0973C27.2441 40.5197 26.8397 39.7793 26.3714 38.9217L26.3699 38.9189C25.8822 38.0251 25.3291 37.0114 25.3291 35.0838C25.3291 33.1621 25.8935 31.4333 26.2331 30.5671Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.9949 30.5678L30.8923 30.5593C30.6719 30.5579 30.5367 30.3255 30.6487 30.1418L32.6131 26.9138C32.7251 26.7308 32.9985 26.7329 33.1062 26.918L35.0131 30.1736C35.1215 30.3594 34.9833 30.589 34.7637 30.5876L33.5593 30.5784C33.5484 30.601 32.5585 32.7205 32.5585 35.0838C32.5585 36.6614 32.9629 37.4025 33.4313 38.2595C33.92 39.1547 34.4735 40.1685 34.4735 42.0973C34.4735 44.3079 33.2342 46.7313 33.1811 46.833C33.0538 47.0803 32.7971 47.2223 32.5309 47.2223C32.4218 47.2223 32.3098 47.1983 32.2058 47.1474C31.8465 46.9729 31.7011 46.5483 31.8807 46.1993C31.8923 46.1774 33.0189 43.9688 33.0189 42.0973C33.0189 40.5197 32.6146 39.7793 32.1462 38.9217C31.6575 38.0272 31.104 37.0133 31.104 35.0838C31.104 33.1614 31.6611 31.4319 31.9949 30.5678Z"
          fill="white"
        />
        <path
          className={color}
          d="M37.7567 30.5671L36.7298 30.5593C36.5101 30.5579 36.3749 30.3255 36.4869 30.1418L38.4513 26.9138C38.5633 26.7308 38.836 26.7329 38.9444 26.918L40.8513 30.1736C40.9597 30.3594 40.8208 30.589 40.6011 30.5876L39.3313 30.5784C39.3302 30.5809 39.3298 30.5834 39.3295 30.5858C39.3291 30.5883 39.3287 30.5908 39.3277 30.5932C39.3167 30.6144 38.2694 32.7283 38.2694 35.0838C38.2694 36.6614 38.6738 37.4025 39.1422 38.2595C39.6309 39.1547 40.1844 40.1685 40.1844 42.0973C40.1844 44.3079 38.9444 46.7313 38.892 46.833C38.764 47.0803 38.508 47.2223 38.2418 47.2223C38.132 47.2223 38.0207 47.1983 37.916 47.1474C37.5574 46.9722 37.412 46.5483 37.5916 46.1993C37.6033 46.1774 38.7298 43.9688 38.7298 42.0973C38.7298 40.5197 38.3254 39.7792 37.8571 38.9215C37.3683 38.0271 36.8149 37.0133 36.8149 35.0838C36.8149 33.1649 37.4018 31.4382 37.7567 30.5671Z"
          fill="white"
        />
      </svg>
    ),
    'air-dreamdrive': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="air-dreamdrive"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <g clipPath="url(#clip0_20491_73311)">
          <path
            className={color}
            d="M4.94214 45.6673C2.24547 42.2424 0.666748 38.0596 0.666748 33.5512C0.666748 28.9357 2.35656 24.6462 5.05809 21.3223C5.34913 20.9643 5.88514 20.9022 6.2553 21.1838C6.62545 21.4653 6.68956 21.9839 6.39852 22.3419C3.91978 25.3917 2.37192 29.3261 2.37192 33.5512C2.37192 37.678 3.81502 41.5134 6.29863 44.6677C6.58395 45.0301 6.51157 45.5476 6.13699 45.8236C5.7624 46.0996 5.22746 46.0296 4.94214 45.6673Z"
            fill="white"
          />
          <path
            className={color}
            d="M7.38034 33.4484C7.38034 36.7247 8.52823 39.6695 10.3531 42.0596C10.6329 42.426 11.1667 42.5036 11.5455 42.2329C11.9242 41.9623 12.0045 41.4459 11.7247 41.0795C10.0961 38.9464 9.08552 36.3401 9.08552 33.4484C9.08552 30.6577 10.0969 27.9575 11.8176 25.8365C12.1083 25.4782 12.0436 24.9597 11.6732 24.6785C11.3028 24.3973 10.7668 24.4597 10.4761 24.8181C8.5274 27.2202 7.38034 30.2768 7.38034 33.4484Z"
            fill="white"
          />
          <path
            className={color}
            d="M20.5759 33.355C20.1624 33.2164 19.7155 33.4411 19.5776 33.8569C19.4398 34.2727 19.6633 34.7221 20.0768 34.8607C21.3528 35.2884 23.3042 35.5918 25.5215 35.7911C27.7565 35.992 30.3206 36.0919 32.8548 36.0919C35.3887 36.0919 37.9048 35.992 40.0434 35.7908C42.1536 35.5922 43.9819 35.2882 45.0845 34.8447C45.4891 34.6819 45.6859 34.22 45.5241 33.8131C45.3622 33.4062 44.9029 33.2082 44.4982 33.371C43.6278 33.7211 42.0034 34.0122 39.8964 34.2105C37.8177 34.4061 35.3521 34.5046 32.8548 34.5046C30.3579 34.5046 27.8416 34.4061 25.662 34.2102C23.4647 34.0127 21.6675 33.7209 20.5759 33.355Z"
            fill="white"
          />
          <path
            className={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.4241 42.3149H23.7915L23.7174 42.3918C23.4305 42.6892 23.1416 42.9888 22.8563 43.2074C22.4513 43.5176 21.9923 43.7213 21.3944 43.7213H17.7549C17.3336 43.7213 16.9498 43.6209 16.6272 43.4002C16.3072 43.1813 16.1106 42.8874 15.9878 42.6077C15.8056 42.1925 15.7472 41.681 15.713 41.3808L15.7118 41.3703C15.7055 41.3157 15.7001 41.2679 15.6948 41.23L15.687 41.175V41.0295L15.5887 37.3127V36.5156L15.5873 36.4814C15.586 36.4479 15.5843 36.3994 15.5825 36.3378C15.5789 36.2146 15.5749 36.0384 15.5733 35.8231C15.5701 35.3935 15.5764 34.8035 15.6147 34.1653C15.6528 33.5301 15.7235 32.8306 15.8535 32.1872C15.9772 31.5751 16.1705 30.928 16.5017 30.4418C17.2943 29.1236 18.2139 28.5867 19.0393 28.3214C19.3066 28.2354 19.5932 28.1718 19.8021 28.1255C19.8766 28.109 19.9423 28.0944 19.9925 28.082C20.101 28.0553 20.1663 28.0334 20.2038 28.0188C20.2213 27.9865 20.2414 27.949 20.2641 27.9062L20.3914 27.6662C20.447 27.5613 20.5088 27.4448 20.5604 27.3479C20.7987 26.9006 21.1115 26.3224 21.4507 25.7386C21.788 25.1581 22.161 24.5555 22.5206 24.0653C22.7001 23.8206 22.8868 23.5893 23.0737 23.3982C23.247 23.2209 23.4784 23.0171 23.7531 22.9049L23.7631 22.9009C24.5097 22.6076 25.5349 22.4244 26.8466 22.3095C28.1708 22.1936 29.8445 22.1433 31.9193 22.1433H33.2964C35.3711 22.1433 37.0448 22.1936 38.3691 22.3095C39.6808 22.4244 40.7059 22.6076 41.4525 22.9009L41.4625 22.9048C41.7372 23.017 41.9686 23.2209 42.1419 23.3982C42.3288 23.5893 42.5155 23.8206 42.695 24.0653C43.0546 24.5555 43.4276 25.1581 43.7649 25.7386C44.1042 26.3224 44.4169 26.9006 44.6552 27.3479C44.7047 27.4408 44.7635 27.5518 44.8173 27.6532L44.8435 27.7028L44.8446 27.7048L44.9515 27.9062C44.9743 27.949 44.9944 27.9865 45.0118 28.0188C45.0494 28.0334 45.1147 28.0553 45.2232 28.082C45.2735 28.0944 45.3381 28.1088 45.4128 28.1253C45.6217 28.1717 45.909 28.2354 46.1763 28.3214C47.0017 28.5867 47.9213 29.1236 48.7139 30.4418C49.0451 30.928 49.2384 31.5751 49.3621 32.1872C49.4921 32.8306 49.5628 33.5301 49.6009 34.1653C49.6392 34.8035 49.6455 35.3935 49.6423 35.8231C49.6407 36.0384 49.6367 36.2146 49.6331 36.3378C49.6313 36.3994 49.6296 36.4479 49.6283 36.4814L49.6269 36.5156V37.3127L49.5286 41.0296V41.175L49.5208 41.23C49.5155 41.268 49.5101 41.3154 49.5039 41.3703L49.5027 41.3808C49.4684 41.681 49.41 42.1926 49.2278 42.6077C49.105 42.8874 48.9085 43.1813 48.5885 43.4002C48.2658 43.6209 47.882 43.7213 47.4607 43.7213H43.8212C43.2233 43.7213 42.7644 43.5176 42.3594 43.2074C42.0742 42.989 41.786 42.6902 41.4994 42.3929L41.4241 42.3149ZM24.3552 24.3724C24.8883 24.1666 25.7273 24.0007 26.9835 23.8908C28.2413 23.7807 29.8627 23.7305 31.9193 23.7305H33.2964C35.3529 23.7305 36.9743 23.7807 38.2321 23.8908C39.4883 24.0007 40.3273 24.1666 40.8604 24.3724L40.8647 24.3755C40.879 24.3858 40.9293 24.4219 41.0165 24.5111C41.1316 24.6288 41.2693 24.7954 41.4249 25.0075C41.7353 25.4307 42.0755 25.9771 42.4021 26.5393C42.7268 27.0982 43.0289 27.6564 43.2639 28.0975C43.3376 28.2358 43.3897 28.3343 43.4375 28.4245L43.4394 28.4283C43.4792 28.5033 43.5162 28.573 43.5602 28.6556C43.6279 28.7827 43.7025 28.9227 43.7517 28.9979L43.7944 29.0634L43.8491 29.1193C44.1661 29.4431 44.58 29.5577 44.8476 29.6236C44.9624 29.6519 45.0634 29.6741 45.1587 29.6951L45.1603 29.6955C45.3397 29.735 45.4997 29.7702 45.6957 29.8332C46.1934 29.9932 46.7926 30.3055 47.3739 31.2809L47.3887 31.3058L47.4053 31.3295C47.5551 31.5438 47.7015 31.9395 47.8154 32.5033C47.9251 33.0466 47.9897 33.6655 48.0253 34.2608C48.0609 34.8533 48.0669 35.406 48.0639 35.8114C48.0625 36.0136 48.0587 36.1781 48.0554 36.2911C48.0538 36.3476 48.0522 36.3911 48.0511 36.4201L48.0495 36.4598L48.0494 36.4615L48.0486 36.4799V37.2916L47.9502 41.0084V41.0652C47.9394 41.1461 47.9319 41.2113 47.9248 41.2721L47.9244 41.276C47.9135 41.37 47.9036 41.4549 47.8848 41.573C47.8569 41.7483 47.8238 41.8754 47.7837 41.9668C47.7467 42.0513 47.7158 42.0775 47.7008 42.0878C47.6883 42.0963 47.6295 42.1341 47.4607 42.1341H43.8212C43.6322 42.1341 43.501 42.0866 43.3158 41.9447C43.1333 41.8049 42.9536 41.6192 42.6817 41.3381L42.6786 41.3349C42.5997 41.2533 42.513 41.1637 42.4163 41.0649C42.3272 40.9739 42.2216 40.9091 42.1091 40.8706C41.9811 40.7805 41.8252 40.7277 41.6572 40.7277H23.46C23.2147 40.7277 22.9956 40.8402 22.8508 41.0168C22.8331 41.0319 22.8159 41.048 22.7993 41.0649C22.7014 41.1649 22.6138 41.2554 22.5342 41.3378C22.2623 41.6189 22.0823 41.8049 21.8998 41.9447C21.7146 42.0866 21.5834 42.1341 21.3944 42.1341H17.7549C17.5861 42.1341 17.5273 42.0963 17.5149 42.0878C17.4998 42.0775 17.469 42.0513 17.4319 41.9668C17.3918 41.8754 17.3588 41.7483 17.3308 41.573C17.3121 41.4555 17.3023 41.3713 17.2915 41.2779L17.2913 41.2762C17.2842 41.2141 17.2765 41.1479 17.2654 41.0652V41.0084L17.1671 37.2916V36.4799L17.1662 36.4615L17.1661 36.4598L17.1645 36.4201C17.1634 36.3911 17.1618 36.3476 17.1602 36.2911C17.1569 36.1781 17.1532 36.0136 17.1517 35.8114C17.1487 35.406 17.1548 34.8533 17.1903 34.2608C17.226 33.6655 17.2905 33.0466 17.4003 32.5033C17.5142 31.9395 17.6605 31.5438 17.8104 31.3295L17.8269 31.3058L17.8417 31.2809C18.423 30.3055 19.0222 29.9932 19.5199 29.8332C19.7159 29.7702 19.8759 29.735 20.0553 29.6955C20.1509 29.6744 20.253 29.652 20.368 29.6236C20.6356 29.5577 21.0495 29.4431 21.3666 29.1193L21.4212 29.0634L21.464 28.9979C21.5131 28.9227 21.5877 28.7827 21.6555 28.6556C21.6994 28.5731 21.7364 28.5035 21.7761 28.4284L21.7767 28.4273C21.8247 28.3366 21.8775 28.2367 21.9517 28.0975C22.1868 27.6564 22.4888 27.0982 22.8135 26.5393C23.1402 25.9771 23.4804 25.4307 23.7909 25.0075C23.9465 24.7954 24.084 24.6288 24.1991 24.5111C24.2863 24.4219 24.3366 24.3858 24.351 24.3755L24.3552 24.3724Z"
            fill="white"
          />
          <path
            className={color}
            d="M64.6667 33.4488C64.6667 28.9404 63.0879 24.7576 60.3913 21.3327C60.106 20.9704 59.571 20.9004 59.1964 21.1764C58.8218 21.4524 58.7495 21.9699 59.0348 22.3323C61.5184 25.4866 62.9615 29.322 62.9615 33.4488C62.9615 37.6739 61.4136 41.6083 58.9349 44.6581C58.6438 45.0161 58.708 45.5347 59.0781 45.8162C59.4483 46.0978 59.9843 46.0357 60.2753 45.6777C62.9769 42.3538 64.6667 38.0643 64.6667 33.4488Z"
            fill="white"
          />
          <path
            className={color}
            d="M54.9803 24.9404C56.8052 27.3305 57.9531 30.2753 57.9531 33.5516C57.9531 36.7232 56.806 39.7798 54.8573 42.1819C54.5666 42.5403 54.0306 42.6027 53.6602 42.3215C53.2898 42.0403 53.2252 41.5218 53.5159 41.1635C55.2365 39.0425 56.2479 36.3423 56.2479 33.5516C56.2479 30.6599 55.2373 28.0536 53.6087 25.9205C53.3289 25.5541 53.4092 25.0377 53.7879 24.7671C54.1667 24.4964 54.7005 24.574 54.9803 24.9404Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_20491_73311">
            <rect width="64" height="64" fill="white" transform="translate(0.666748 0.5)" />
          </clipPath>
        </defs>
      </svg>
    ),
    'air-heated-steering-wheel': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="air-heated-steering-wheel"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M23.4417 14.6254L23.3997 14.5411C22.9997 13.749 22.6057 12.836 22.6057 11.2498C22.6057 9.3602 23.4595 7.38462 23.556 7.16533C23.8201 6.57024 24.4619 6.32969 24.9883 6.6282C25.5155 6.92575 25.7291 7.65125 25.4668 8.2473C25.2651 8.70425 24.7422 10.135 24.7422 11.2498C24.7422 12.3261 24.9925 12.8238 25.257 13.3493L25.301 13.4369C25.6993 14.2262 26.0916 15.1362 26.0916 16.7205C26.0916 18.6111 25.2378 20.5867 25.1404 20.805C24.9532 21.2272 24.5773 21.4706 24.1859 21.4706C24.0253 21.4706 23.862 21.4291 23.7081 21.3431C23.1809 21.0446 22.9681 20.32 23.2305 19.723C23.4321 19.2661 23.9551 17.8363 23.9551 16.7205C23.9551 15.6436 23.7057 15.1489 23.4417 14.6254Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.766 18.313C20.2259 18.0106 20.354 17.3918 20.0522 16.931C19.7505 16.4701 19.1331 16.3417 18.6732 16.6442C12.0268 21.0151 7.66675 28.6101 7.66675 37.14C7.66675 43.7617 11.0136 49.7832 15.3109 54.1958C16.0626 55.0054 17.4672 55.8167 18.9907 56.4197C20.548 57.0361 22.3935 57.5 24.0997 57.5H40.3334C42.0413 57.5 43.8629 57.0352 45.4077 56.4186C46.9353 55.8089 48.3212 54.9988 49.1047 54.2136L49.1132 54.205C53.3172 49.8893 56.6667 43.8639 56.6667 37.2398C56.6667 28.604 52.2019 21.0116 45.5608 16.6442C45.1009 16.3417 44.4834 16.4701 44.1816 16.931C43.8799 17.3918 44.008 18.0106 44.4679 18.313C49.2729 21.4729 52.8356 26.4672 54.1362 32.3165C53.2821 32.0025 52.4409 31.6863 51.6071 31.373C45.4622 29.0635 39.7199 26.9054 32.2043 26.8609C32.1918 26.8604 32.1792 26.8602 32.1666 26.8602L32.067 26.8603L31.9674 26.8602C31.9548 26.8602 31.9423 26.8604 31.9298 26.8609C24.4185 26.9054 18.6097 29.0602 12.3882 31.3681C11.6676 31.6354 10.9416 31.9048 10.2067 32.1731C11.4989 26.4095 14.9905 21.4535 19.766 18.313ZM50.8394 33.2185C52.0316 33.6658 53.2523 34.1237 54.5197 34.5798C54.6222 35.4522 54.6749 36.3399 54.6749 37.2398C54.6749 38.4488 54.55 39.6413 54.3179 40.8083C54.1416 40.7574 53.9781 40.7223 53.8372 40.6977C53.6562 40.6662 53.5014 40.6502 53.3885 40.6419C53.3319 40.6378 53.2851 40.6356 53.25 40.6344L53.2312 40.6338L53.2062 40.6333L53.1912 40.6331L53.1855 40.6331L53.1831 40.6331L53.181 40.6331C53.1339 40.6331 53.0868 40.6364 53.0402 40.6431C50.7782 40.9669 48.161 41.4849 45.5033 42.0109C45 42.1105 44.4942 42.2106 43.9901 42.3095C44.0261 42.1311 44.0536 41.9504 44.0742 41.7691C44.256 40.1713 43.9477 38.0842 43.4993 35.9374L43.4987 35.9347C43.143 34.2544 42.6292 32.391 41.9982 30.8891C41.8885 30.6281 41.7733 30.373 41.6522 30.128C44.7422 30.9312 47.692 32.0378 50.8394 33.2185ZM38.3903 29.4145C36.4058 29.066 34.3242 28.8622 32.067 28.8564C29.5377 28.8629 27.2204 29.118 25.0071 29.5466C24.8894 29.6377 24.7495 29.7038 24.5938 29.735C24.5938 29.735 24.5509 29.745 24.4637 29.8136C24.3717 29.8861 24.2548 30.0052 24.119 30.187C23.8449 30.5541 23.558 31.0892 23.2747 31.7635C22.7108 33.1056 22.2287 34.8346 21.8872 36.4474C21.4394 38.5915 21.2002 40.3963 21.342 41.6427C21.4033 42.1806 21.5269 42.527 21.665 42.7398C21.843 42.7702 22.0207 42.8003 22.1979 42.8301C25.8302 43.4409 29.3145 43.9258 32.0602 43.9266L32.0671 43.9266H32.2664C34.8458 43.9266 38.175 43.4097 41.6875 42.7524C41.6951 42.7438 41.7024 42.7351 41.7096 42.7262C41.872 42.526 42.0248 42.1608 42.0951 41.5429C42.2369 40.2965 41.9977 38.4918 41.5499 36.3476C41.2085 34.7348 40.7264 33.0058 40.1625 31.6637C39.8792 30.9894 39.5922 30.4543 39.3181 30.0872C39.1823 29.9054 39.0654 29.7863 38.9734 29.7138C38.8862 29.6452 38.843 29.6351 38.843 29.6351C38.6695 29.6003 38.5156 29.5223 38.3903 29.4145ZM13.1487 33.2167C16.0977 32.1247 18.8756 31.0961 21.7435 30.3124C21.6375 30.5313 21.536 30.7578 21.439 30.9889C20.8079 32.4908 20.2942 34.3542 19.9385 36.0345L19.9379 36.0372C19.4895 38.184 19.1811 40.2711 19.3629 41.8689C19.3813 42.0303 19.4051 42.1914 19.4355 42.3508C19.0431 42.2812 18.6509 42.2114 18.2601 42.1418C15.9567 41.7317 13.6993 41.3298 11.6917 41.0423L11.6333 41.0356C11.6206 41.0344 11.6043 41.033 11.5848 41.0316C11.5459 41.0287 11.4938 41.0255 11.4304 41.0235C11.3043 41.0194 11.1306 41.0195 10.9266 41.0353C10.6988 41.0528 10.4175 41.091 10.1147 41.1723C9.81871 39.8572 9.65857 38.5091 9.65857 37.14C9.65857 36.2257 9.71313 35.3232 9.81909 34.4358C10.9606 34.0269 12.0662 33.6175 13.1487 33.2167ZM53.4958 42.6643C53.602 42.6828 53.7157 42.7092 53.8292 42.7454C52.6633 46.5601 50.3967 50.0286 47.6925 52.8059C47.1797 53.3178 46.0776 54.0027 44.6707 54.5642C43.2774 55.1203 41.7128 55.5039 40.3334 55.5039H24.0997C22.7186 55.5039 21.128 55.1195 19.7224 54.5632C18.2899 53.9962 17.2104 53.3151 16.7644 52.8309L16.7557 52.8216L16.7451 52.8105C14.0783 50.0744 11.86 46.7432 10.6499 43.0952C10.7953 43.0576 10.9427 43.036 11.0795 43.0255C11.1992 43.0162 11.2994 43.0164 11.3662 43.0185C11.3986 43.0196 11.4223 43.0211 11.4357 43.022C13.4079 43.305 15.5912 43.694 17.8569 44.0975C19.1745 44.3322 20.52 44.5719 21.8682 44.7986C25.5032 45.4099 29.1371 45.9227 32.0671 45.9227H32.2662L32.2732 45.9227C35.2167 45.9217 38.9603 45.3045 42.6854 44.5952C43.7792 44.387 44.8715 44.1708 45.9469 43.9579C48.5459 43.4435 51.0473 42.9485 53.2327 42.632L53.2441 42.6328C53.3025 42.637 53.3905 42.6459 53.4958 42.6643Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.4091 14.6252C31.6731 15.1487 31.9226 15.6436 31.9226 16.7205C31.9226 17.8363 31.3997 19.2661 31.198 19.723C30.9356 20.32 31.1484 21.0446 31.6757 21.3431C31.8295 21.4291 31.9927 21.4706 32.1533 21.4706C32.5447 21.4706 32.9208 21.2272 33.1079 20.805C33.2053 20.5867 34.0591 18.6111 34.0591 16.7205C34.0591 15.1362 33.6668 14.2262 33.2686 13.4369L33.2245 13.3493C32.9601 12.8238 32.7097 12.3261 32.7097 11.2498C32.7097 10.135 33.2326 8.70425 33.4343 8.2473C33.6967 7.65125 33.4831 6.92575 32.9558 6.6282C32.4294 6.32969 31.7876 6.57024 31.5236 7.16533C31.427 7.38462 30.5732 9.3602 30.5732 11.2498C30.5732 12.836 30.9673 13.749 31.3672 14.5411L31.4091 14.6252Z"
          fill="white"
        />
        <path
          className={color}
          d="M39.3766 14.6254L39.3346 14.5411C38.9347 13.749 38.5408 12.836 38.5408 11.2498C38.5408 9.3602 39.3944 7.38462 39.491 7.16533C39.755 6.57024 40.3968 6.32969 40.9232 6.6282C41.4505 6.92575 41.6642 7.65125 41.4019 8.2473C41.2002 8.70425 40.6771 10.135 40.6771 11.2498C40.6771 12.3261 40.9276 12.8238 41.192 13.3493L41.2361 13.4369C41.6343 14.2262 42.0265 15.1362 42.0265 16.7205C42.0265 18.6111 41.1727 20.5867 41.0753 20.805C40.8882 21.2272 40.5122 21.4706 40.1208 21.4706C39.9602 21.4706 39.7969 21.4291 39.6431 21.3431C39.1158 21.0446 38.9031 20.32 39.1654 19.723C39.3671 19.2661 39.8901 17.8363 39.8901 16.7205C39.8901 15.6436 39.6406 15.1489 39.3766 14.6254Z"
          fill="white"
        />
      </svg>
    ),
    'air-metal-roof': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="air-metal-roof"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M26.2324 33.9683C26.2149 33.5821 25.8876 33.2832 25.5014 33.3008C25.1152 33.3183 24.8163 33.6456 24.8339 34.0318L25.3339 45.0318C25.3514 45.418 25.6787 45.7169 26.0649 45.6993C26.4511 45.6818 26.75 45.3545 26.7324 44.9683L26.2324 33.9683Z"
          fill="white"
        />
        <path
          className={color}
          d="M40.2324 34.0318C40.25 33.6456 39.9511 33.3183 39.5649 33.3008C39.1787 33.2832 38.8514 33.5821 38.8339 33.9683L38.3339 44.9683C38.3163 45.3545 38.6152 45.6818 39.0014 45.6993C39.3876 45.7169 39.7149 45.418 39.7324 45.0318L40.2324 34.0318Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.321 17.7839C26.6597 16.6111 28.9468 15.8 32.5463 15.8C36.1446 15.8 38.4507 16.6106 39.7908 17.7837C41.1372 18.9624 41.4563 20.4735 41.0961 21.6482C40.9968 22.0826 40.8594 22.727 40.7083 23.4356L40.7081 23.4366C40.4381 24.7027 40.1245 26.1739 39.906 27.0199C39.7971 27.4417 39.692 27.7921 39.5737 28.0733C39.4557 28.3538 39.303 28.6187 39.07 28.8214C38.8229 29.0363 38.5488 29.1268 38.2902 29.1662C38.0669 29.2002 37.8171 29.2001 37.5925 29.2001L27.5312 29.2L27.4552 29.2002C27.0204 29.2016 26.4283 29.2035 25.9251 28.833C25.4022 28.448 25.1032 27.7706 24.8496 26.8374C24.8442 26.8172 24.8396 26.7968 24.8359 26.7762L23.9187 21.6067C23.6534 20.4591 23.9737 18.9641 25.321 17.7839ZM26.2435 18.8369C25.2766 19.6839 25.1323 20.6605 25.2855 21.3032C25.2887 21.3165 25.2915 21.3299 25.2939 21.3433L26.2088 26.5002C26.4531 27.3887 26.6523 27.6299 26.7551 27.7056C26.8488 27.7745 26.968 27.8 27.5312 27.8H37.5614C37.8304 27.8 37.9734 27.7983 38.0795 27.7822C38.1242 27.7754 38.1437 27.7682 38.1493 27.7659C38.1514 27.765 38.1514 27.765 38.1513 27.765C38.1562 27.7608 38.2055 27.7152 38.2833 27.5303C38.3609 27.3459 38.4457 27.0756 38.5505 26.6698C38.7636 25.8444 39.0592 24.4564 39.323 23.2179C39.4807 22.4775 39.627 21.7905 39.7375 21.309C39.7418 21.2903 39.7469 21.2718 39.7527 21.2535C39.9479 20.6393 39.8349 19.683 38.8686 18.8371C37.8848 17.9758 35.9692 17.2 32.5463 17.2C29.1247 17.2 27.2272 17.9752 26.2435 18.8369Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.9215 49.4176C26.7574 49.3082 26.5548 49.2731 26.3635 49.321C25.5216 49.5314 23.3333 50.6569 23.3333 53.5001C23.3333 55.3165 24.406 56.7675 26.0555 57.7297C27.6939 58.6854 29.9515 59.2001 32.5333 59.2001C35.115 59.2001 37.3726 58.6854 39.011 57.7297C40.6605 56.7675 41.7333 55.3165 41.7333 53.5001C41.7333 50.7768 39.704 49.7911 38.9583 49.4288C38.9168 49.4087 38.8793 49.3904 38.8463 49.374C38.6216 49.2616 38.354 49.2783 38.145 49.4176L38.1353 49.4241C37.7881 49.6558 36.8228 50.3001 32.5333 50.3001C28.2437 50.3001 27.2785 49.6558 26.9312 49.4241L26.9215 49.4176ZM24.7333 53.5001C24.7333 51.8165 25.8274 51.0328 26.4461 50.7684C27.1967 51.191 28.6571 51.7001 32.5333 51.7001C36.3175 51.7001 37.7991 51.2149 38.5658 50.7987C39.3061 51.1806 40.3333 51.8541 40.3333 53.5001C40.3333 54.6836 39.656 55.7326 38.3055 56.5204C36.9439 57.3147 34.9515 57.8001 32.5333 57.8001C30.115 57.8001 28.1226 57.3147 26.761 56.5204C25.4105 55.7326 24.7333 54.6836 24.7333 53.5001Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.4501 3.80433C30.6466 3.76002 28.0262 4.05141 25.6301 5.07758C23.0823 6.16876 20.7236 8.12563 19.9785 11.4312L19.971 11.4648C19.969 11.4735 19.9676 11.4823 19.9668 11.4912L19.9638 11.5254C19.7896 13.5156 19.5713 18.2351 20.1497 21.0374V22.5079C20.0276 22.6024 19.8959 22.6979 19.7538 22.7998L19.6947 22.8422C19.4761 22.9988 19.2313 23.1741 19.0091 23.3614C18.5278 23.7672 18 24.3533 18 25.2162V26.3356C18 26.3978 18.0289 26.4564 18.0782 26.4942C18.1275 26.5321 18.1915 26.5449 18.2516 26.5289L18.958 26.3402C19.2395 26.2651 19.7064 26.1379 20.1497 26.0107V38.3153C20.0991 40.8525 19.9688 46.2071 19.8507 47.6019C19.7722 48.4678 19.7226 49.9065 19.8231 51.4526C19.9221 52.9756 20.1701 54.6638 20.716 56.0186C20.7658 56.1911 20.8135 56.3639 20.8613 56.537L20.8617 56.5382L20.862 56.5392L20.8675 56.5593C21.2552 57.9628 21.6498 59.391 23.1194 60.411C24.7081 61.5137 27.4413 62.0796 32.4455 62.1952H32.4547C37.4589 62.0796 40.1921 61.5137 41.7808 60.411C43.2504 59.391 43.6449 57.9628 44.0326 56.5593L44.038 56.5399L44.0385 56.5382C44.0864 56.3649 44.1343 56.1913 44.1841 56.0185C44.7301 54.6638 44.9781 52.9756 45.0771 51.4526C45.1776 49.9064 45.1279 48.4676 45.0494 47.6018C44.9314 46.2067 44.8011 40.8524 44.7505 38.3153V26.0107C45.1937 26.1379 45.6607 26.2651 45.9422 26.3402L46.6486 26.5289C46.7086 26.5449 46.7727 26.5321 46.822 26.4942C46.8713 26.4564 46.9002 26.3978 46.9002 26.3356V25.2162C46.9002 24.3533 46.3724 23.7672 45.891 23.3614C45.6689 23.1742 45.4241 22.9988 45.2055 22.8422L45.2027 22.8401L45.1463 22.7998C45.0043 22.6979 44.8726 22.6024 44.7505 22.5079V21.0374C45.3288 18.2351 45.1106 13.5156 44.9363 11.5254L44.9333 11.4912C44.9326 11.4823 44.9312 11.4735 44.9292 11.4648L44.9217 11.4313C44.1765 8.12568 41.8178 6.16876 39.27 5.07758C36.874 4.05141 34.2535 3.76002 32.4501 3.80433ZM32.4446 5.26896C30.8145 5.22434 28.4067 5.48977 26.2428 6.41651C24.0043 7.37523 22.0913 9.00712 21.4676 11.6975C21.3807 12.7084 21.2893 14.3483 21.2877 16.0558C21.2862 17.7747 21.3758 19.5473 21.6473 20.8151L21.6586 20.868C21.6615 20.8817 21.663 20.8957 21.663 20.9098V23.0787C21.663 23.136 21.6384 23.1905 21.5955 23.2285L21.4168 23.3865C21.1676 23.6068 20.8953 23.8038 20.6552 23.976L20.6065 24.0109C20.3763 24.176 20.1774 24.3187 20.0033 24.4655C19.9672 24.4959 19.9335 24.5255 19.902 24.5542C20.224 24.4605 20.4987 24.3761 20.6265 24.3269L21.3911 24.0324C21.4526 24.0087 21.5219 24.0168 21.5762 24.0541C21.6305 24.0914 21.663 24.1531 21.663 24.219V38.3223L21.663 38.3242L21.6629 38.3343L21.6629 38.3364C21.6129 40.8436 21.4819 46.2725 21.3588 47.7238L21.3584 47.7276C21.2862 48.5235 21.2379 49.89 21.3334 51.3607C21.4297 52.8422 21.6684 54.3674 22.138 55.5162L22.1483 55.5414C22.151 55.548 22.1533 55.5547 22.1553 55.5614L22.1629 55.5876C22.2204 55.7859 22.2739 55.9761 22.3251 56.158C22.7365 57.6198 22.9979 58.5246 24.0016 59.2212C25.1722 60.0337 27.4592 60.6129 32.4501 60.7306C37.441 60.6129 39.728 60.0337 40.8986 59.2212C41.9022 58.5246 42.1637 57.6198 42.5751 56.158C42.6263 55.9761 42.6798 55.7858 42.7373 55.5876L42.7449 55.5615L42.7475 55.553C42.7489 55.5491 42.7503 55.5452 42.7519 55.5414L42.7622 55.5162C43.2318 54.3674 43.4705 52.8422 43.5668 51.3607C43.6623 49.89 43.614 48.5239 43.5418 47.728L43.5415 47.7246C43.4183 46.2732 43.2873 40.8436 43.2373 38.3364L43.2373 38.3343L43.2372 38.3242L43.2372 38.3223V24.219C43.2372 24.1531 43.2696 24.0914 43.324 24.0541C43.3783 24.0168 43.4475 24.0087 43.509 24.0324L44.2737 24.3269C44.4015 24.3761 44.6762 24.4605 44.9981 24.5542C44.9667 24.5255 44.933 24.4959 44.8969 24.4655C44.7228 24.3187 44.5239 24.176 44.2937 24.011L44.245 23.976C44.0049 23.8038 43.7326 23.6068 43.4834 23.3865L43.3047 23.2285C43.2617 23.1905 43.2372 23.136 43.2372 23.0787V20.9098C43.2372 20.8957 43.2386 20.8817 43.2416 20.868L43.2529 20.8151C43.5244 19.5474 43.614 17.7747 43.6124 16.0558C43.6109 14.3483 43.5195 12.7084 43.4326 11.6975C42.8088 9.00712 40.8959 7.37523 38.6573 6.41651C36.4935 5.48977 34.0856 5.22434 32.4556 5.26896H32.4446Z"
          fill="white"
        />
      </svg>
    ),
    'air-glass-canopy': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="air-glass-canopy"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.321 17.7839C26.6597 16.6111 28.9468 15.8 32.5463 15.8C36.1446 15.8 38.4507 16.6106 39.7908 17.7837C41.1363 18.9616 41.4559 20.4714 41.0968 21.6458C41.0367 21.9266 40.9327 22.7141 40.81 23.9593C40.6858 25.2203 40.5464 26.9075 40.4157 28.912C40.1542 32.921 39.9282 38.1901 39.9282 43.8449C39.9282 43.9039 39.9208 43.9627 39.906 44.0199C39.516 45.5301 38.4301 46.4616 37.0912 46.9987C35.7736 47.5272 34.159 47.7001 32.5463 47.7001C30.8585 47.7001 29.1626 47.5773 27.783 47.0478C26.3612 46.5021 25.2454 45.5082 24.844 43.8154C24.8315 43.7625 24.8252 43.7083 24.8252 43.6539C24.8252 38.5951 24.5958 33.0622 24.3659 28.7896C24.251 26.6543 24.1362 24.8359 24.05 23.5514C24.007 22.9093 23.9711 22.4007 23.946 22.0529C23.9334 21.879 23.9236 21.7453 23.9169 21.6551L23.9105 21.5703C23.6602 20.4276 23.9879 18.9516 25.321 17.7839ZM24.6046 21.4656C25.3026 21.4122 25.3026 21.4122 25.3026 21.4124L24.6046 21.4656ZM25.3026 21.4124L25.313 21.5513C25.3198 21.6424 25.3297 21.7771 25.3424 21.9521C25.3676 22.3021 25.4036 22.8131 25.4469 23.4578C25.5334 24.7471 25.6486 26.5719 25.7639 28.7144C25.993 32.9737 26.2226 38.4967 26.2251 43.5685C26.5119 44.6758 27.2252 45.3341 28.2847 45.7408C29.4104 46.1728 30.8877 46.3 32.5463 46.3C34.0873 46.3 35.4946 46.1307 36.57 45.6993C37.5941 45.2885 38.2635 44.667 38.5283 43.7511C38.5307 38.0966 38.757 32.8328 39.0186 28.8209C39.1502 26.8038 39.2908 25.1009 39.4168 23.8221C39.5406 22.5643 39.6543 21.6715 39.7375 21.309C39.7418 21.2903 39.7469 21.2718 39.7527 21.2535C39.9479 20.6393 39.8349 19.683 38.8686 18.8371C37.8848 17.9758 35.9692 17.2 32.5463 17.2C29.1247 17.2 27.2272 17.9752 26.2435 18.8369C25.2766 19.6839 25.1323 20.6605 25.2855 21.3032C25.2941 21.3391 25.2998 21.3757 25.3026 21.4124Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.9215 49.4176C26.7574 49.3082 26.5548 49.2731 26.3635 49.321C25.5216 49.5314 23.3333 50.6569 23.3333 53.5001C23.3333 55.3165 24.406 56.7675 26.0555 57.7297C27.6939 58.6854 29.9515 59.2001 32.5333 59.2001C35.115 59.2001 37.3726 58.6854 39.011 57.7297C40.6605 56.7675 41.7333 55.3165 41.7333 53.5001C41.7333 50.7768 39.704 49.7911 38.9583 49.4288C38.9168 49.4087 38.8793 49.3904 38.8463 49.374C38.6216 49.2616 38.354 49.2783 38.145 49.4176L38.1353 49.4241C37.7881 49.6558 36.8228 50.3001 32.5333 50.3001C28.2437 50.3001 27.2785 49.6558 26.9312 49.4241L26.9215 49.4176ZM24.7333 53.5001C24.7333 51.8165 25.8274 51.0328 26.4461 50.7684C27.1967 51.191 28.6571 51.7001 32.5333 51.7001C36.3175 51.7001 37.7991 51.2149 38.5658 50.7987C39.3061 51.1806 40.3333 51.8541 40.3333 53.5001C40.3333 54.6836 39.656 55.7326 38.3055 56.5204C36.9439 57.3147 34.9515 57.8001 32.5333 57.8001C30.115 57.8001 28.1226 57.3147 26.761 56.5204C25.4105 55.7326 24.7333 54.6836 24.7333 53.5001Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.6301 5.07758C28.0262 4.05141 30.6466 3.76002 32.4501 3.80433C34.2535 3.76002 36.874 4.05141 39.27 5.07758C41.8178 6.16876 44.1765 8.12568 44.9217 11.4313L44.9292 11.4648C44.9312 11.4735 44.9326 11.4823 44.9333 11.4912L44.9363 11.5254C45.1106 13.5156 45.3288 18.2351 44.7505 21.0374V22.5079C44.8726 22.6024 45.0043 22.6979 45.1463 22.7998L45.2055 22.8422C45.4241 22.9988 45.6689 23.1742 45.891 23.3614C46.3724 23.7672 46.9002 24.3533 46.9002 25.2162V26.3356C46.9002 26.3978 46.8713 26.4564 46.822 26.4942C46.7727 26.5321 46.7086 26.5449 46.6486 26.5289L45.9422 26.3402C45.6607 26.2651 45.1937 26.1379 44.7505 26.0107V38.3153C44.8011 40.8524 44.9314 46.2067 45.0494 47.6018C45.1279 48.4676 45.1776 49.9064 45.0771 51.4526C44.9781 52.9756 44.7301 54.6638 44.1841 56.0185C44.1343 56.1913 44.0864 56.3649 44.0385 56.5382L44.038 56.5399L44.0326 56.5593C43.6449 57.9628 43.2504 59.391 41.7808 60.411C40.1921 61.5137 37.4589 62.0796 32.4547 62.1952H32.4455C27.4413 62.0796 24.7081 61.5137 23.1194 60.411C21.6498 59.391 21.2552 57.9628 20.8675 56.5593L20.862 56.5392L20.8617 56.5382L20.8613 56.537C20.8135 56.3639 20.7658 56.1911 20.716 56.0186C20.1701 54.6638 19.9221 52.9756 19.8231 51.4526C19.7226 49.9065 19.7722 48.4678 19.8507 47.6019C19.9688 46.2071 20.0991 40.8525 20.1497 38.3153V26.0107C19.7064 26.1379 19.2395 26.2651 18.958 26.3402L18.2516 26.5289C18.1915 26.5449 18.1275 26.5321 18.0782 26.4942C18.0289 26.4564 18 26.3978 18 26.3356V25.2162C18 24.3533 18.5278 23.7672 19.0091 23.3614C19.2313 23.1741 19.4761 22.9988 19.6947 22.8422L19.7538 22.7998C19.8959 22.6979 20.0276 22.6024 20.1497 22.5079V21.0374C19.5713 18.2351 19.7896 13.5156 19.9638 11.5254L19.9668 11.4912C19.9676 11.4823 19.969 11.4735 19.971 11.4648L19.9785 11.4312C20.7236 8.12563 23.0823 6.16876 25.6301 5.07758ZM26.2428 6.41651C28.4067 5.48977 30.8145 5.22434 32.4446 5.26896H32.4556C34.0856 5.22434 36.4935 5.48977 38.6573 6.41651C40.8959 7.37523 42.8088 9.00712 43.4326 11.6975C43.5195 12.7084 43.6109 14.3483 43.6124 16.0558C43.614 17.7747 43.5244 19.5474 43.2529 20.8151L43.2416 20.868C43.2386 20.8817 43.2372 20.8957 43.2372 20.9098V23.0787C43.2372 23.136 43.2617 23.1905 43.3047 23.2285L43.4834 23.3865C43.7326 23.6068 44.0049 23.8038 44.245 23.976L44.2937 24.011C44.5239 24.176 44.7228 24.3187 44.8969 24.4655C44.933 24.4959 44.9667 24.5255 44.9981 24.5542C44.6762 24.4605 44.4015 24.3761 44.2737 24.3269L43.509 24.0324C43.4475 24.0087 43.3783 24.0168 43.324 24.0541C43.2696 24.0914 43.2372 24.1531 43.2372 24.219V38.3223L43.2372 38.3242L43.2373 38.3343L43.2373 38.3364C43.2873 40.8436 43.4183 46.2732 43.5415 47.7246L43.5418 47.728C43.614 48.5239 43.6623 49.89 43.5668 51.3607C43.4705 52.8422 43.2318 54.3674 42.7622 55.5162L42.7519 55.5414C42.7503 55.5452 42.7489 55.5491 42.7475 55.553L42.7449 55.5615L42.7373 55.5876C42.6798 55.7858 42.6263 55.9759 42.5751 56.1578C42.1638 57.6197 41.9022 58.5246 40.8986 59.2212C39.728 60.0337 37.441 60.6129 32.4501 60.7306C27.4592 60.6129 25.1722 60.0337 24.0016 59.2212C22.9979 58.5246 22.7365 57.6198 22.3251 56.158C22.2739 55.9761 22.2204 55.7859 22.1629 55.5876L22.1553 55.5614C22.1533 55.5547 22.151 55.548 22.1483 55.5414L22.138 55.5162C21.6684 54.3674 21.4297 52.8422 21.3334 51.3607C21.2379 49.89 21.2862 48.5235 21.3584 47.7276L21.3588 47.7238C21.4819 46.2725 21.6129 40.8436 21.6629 38.3364L21.6629 38.3343L21.663 38.3242L21.663 38.3223V24.219C21.663 24.1531 21.6305 24.0914 21.5762 24.0541C21.5219 24.0168 21.4526 24.0087 21.3911 24.0324L20.6265 24.3269C20.4987 24.3761 20.224 24.4605 19.902 24.5542C19.9335 24.5255 19.9672 24.4959 20.0033 24.4655C20.1774 24.3187 20.3763 24.176 20.6065 24.0109L20.6552 23.976C20.8953 23.8038 21.1676 23.6068 21.4168 23.3865L21.5955 23.2285C21.6384 23.1905 21.663 23.136 21.663 23.0787V20.9098C21.663 20.8957 21.6615 20.8817 21.6586 20.868L21.6473 20.8151C21.3758 19.5473 21.2862 17.7747 21.2877 16.0558C21.2893 14.3483 21.3807 12.7084 21.4676 11.6975C22.0913 9.00712 24.0043 7.37523 26.2428 6.41651Z"
          fill="white"
        />
      </svg>
    ),
    'air-comfort-and-convenience': (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="air-comfort-and-convenience"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          className={color}
          d="M23.1208 1.11077C22.6539 0.846246 22.1167 1.08137 21.9123 1.54199C21.8633 1.6534 21.4071 2.70139 21.4071 3.72618C21.4071 4.59173 21.6265 5.10327 21.8412 5.52873L21.8618 5.57006L21.8626 5.5716C21.9293 5.70385 21.9796 5.80518 22.0172 5.9329C22.0541 6.05808 22.0818 6.22067 22.0818 6.46156C22.0818 6.69367 22.026 6.97622 21.9515 7.24088C21.878 7.50229 21.7929 7.72258 21.7493 7.82148C21.5547 8.26423 21.6975 8.8292 22.1359 9.07741L22.1375 9.07835C22.2654 9.1498 22.4057 9.18659 22.5472 9.18659C22.8937 9.18659 23.1999 8.97154 23.3444 8.64563C23.3948 8.53273 23.85 7.48684 23.85 6.46156C23.85 5.59655 23.6313 5.08641 23.4172 4.66209L23.3954 4.61871C23.3286 4.48595 23.278 4.38377 23.2402 4.25542C23.2031 4.12966 23.1753 3.96676 23.1753 3.72618C23.1753 3.49433 23.2311 3.21177 23.3056 2.94702C23.3792 2.68552 23.4642 2.46512 23.5078 2.36626C23.7026 1.92376 23.5591 1.35842 23.1208 1.11077Z"
          fill="white"
        />
        <path
          className={color}
          d="M19.4999 1.11075C19.033 0.84626 18.4959 1.08138 18.2915 1.54199C18.2424 1.6534 17.7863 2.70139 17.7863 3.72618C17.7863 4.59173 18.0056 5.10327 18.2204 5.52872L18.2409 5.57006L18.2417 5.5716C18.3084 5.70385 18.3587 5.80518 18.3963 5.9329C18.4332 6.05808 18.4609 6.22067 18.4609 6.46156C18.4609 6.69367 18.4052 6.97622 18.3307 7.24088C18.2571 7.50229 18.1721 7.72258 18.1284 7.82148C17.9339 8.26423 18.0766 8.8292 18.515 9.07741L18.5167 9.07835C18.6445 9.1498 18.7848 9.18659 18.9264 9.18659C19.2729 9.18659 19.5791 8.97154 19.7236 8.64563C19.7739 8.53273 20.2292 7.48684 20.2292 6.46156C20.2292 5.59655 20.0105 5.08641 19.7964 4.66209L19.7746 4.61871C19.7078 4.48595 19.6572 4.38377 19.6193 4.25542C19.5823 4.12966 19.5545 3.96676 19.5545 3.72618C19.5545 3.49433 19.6102 3.21177 19.6847 2.94702C19.7583 2.68552 19.8434 2.46512 19.887 2.36626C20.0818 1.92375 19.9383 1.35839 19.4999 1.11075Z"
          fill="white"
        />
        <path
          className={color}
          d="M19.515 53.4457C19.5753 53.4894 19.6137 53.5091 19.6319 53.5172H19.5939C19.6271 53.5172 19.6444 53.5223 19.6444 53.5223L19.6412 53.5211L19.6319 53.5172H41.6479C43.9703 53.5172 45.3975 51.7166 46.6432 49.9714C46.7312 49.8481 46.9017 49.5331 47.1507 48.9861C47.3888 48.4632 47.6714 47.79 47.9866 47.0016C48.6165 45.4259 49.3639 43.4212 50.1265 41.3009C51.5635 37.3055 53.0435 32.9296 53.8762 30.2954C53.9265 30.1363 53.9744 29.9834 54.0199 29.8374L54.0222 29.83C55.0014 26.6333 55.512 23.5682 55.6332 20.9424C55.7498 18.4171 55.5032 16.3669 55.0195 15.0066C55.0013 14.9556 54.9829 14.9056 54.9641 14.8566L54.9565 14.836L54.9521 14.8255L54.9479 14.8148L54.9505 14.8217C54.4568 13.6533 53.4959 12.8049 52.5872 12.232C52.4527 12.1472 52.3212 12.0696 52.1948 11.999C52.1505 12.7363 52.0854 13.7101 51.995 14.8214C51.7936 17.2991 51.4647 20.4848 50.9546 23.2592C50.8555 23.7979 50.3337 24.1552 49.789 24.0573C49.2443 23.9593 48.883 23.4432 48.982 22.9046C49.4744 20.2264 49.797 17.1169 49.9966 14.6625C50.0961 13.4384 50.1645 12.3834 50.208 11.635C50.2298 11.2609 50.2453 10.9636 50.2554 10.7603C50.2604 10.6587 50.264 10.5806 50.2664 10.5282L50.2691 10.4691L50.2697 10.4545L50.2699 10.451C50.2829 10.1414 50.4416 9.85477 50.6988 9.67774C50.9559 9.50071 51.282 9.45276 51.5801 9.54814L51.5936 9.55286L51.7723 9.61562C51.8834 9.65685 52.0386 9.71753 52.2264 9.79921C52.6009 9.96207 53.1116 10.2112 53.6649 10.5601C54.7574 11.2488 56.0981 12.3786 56.8091 14.0778L56.8176 14.099C57.4899 15.8166 57.7644 18.252 57.636 21.0328C57.5067 23.834 56.965 27.0629 55.9399 30.4082L55.9387 30.4122C55.1313 33.0073 53.5475 37.7057 52.0155 41.9653C51.2493 44.0955 50.4931 46.1244 49.8511 47.7305C49.5304 48.5329 49.235 49.2376 48.9789 49.8001C48.7337 50.3387 48.4939 50.8168 48.2811 51.1148C47.1209 52.7403 45.1398 55.5 41.6479 55.5H19.5939C19.0832 55.5 18.6509 55.2776 18.3301 55.0452C18.0011 54.8069 17.6991 54.4928 17.4275 54.1599C16.8833 53.4927 16.356 52.6184 15.887 51.7352C14.9453 49.9618 14.1504 47.9842 13.8374 47.1075C13.4503 46.0331 13.7542 44.8086 14.422 43.8563C15.1095 42.8761 16.2454 42.0763 17.7249 41.8325C18.2711 41.7424 18.7875 42.1073 18.8786 42.6474C18.9696 43.1874 18.6007 43.6982 18.0546 43.7882C17.1282 43.9409 16.4597 44.43 16.0695 44.9863C15.6601 45.5702 15.6131 46.1293 15.7262 46.4424L15.7275 46.4459C16.0163 47.2554 16.7749 49.1428 17.662 50.8133C18.1077 51.6526 18.5642 52.3955 18.9879 52.9149C19.2003 53.1753 19.3784 53.3468 19.515 53.4457Z"
          fill="white"
        />
        <path
          className={color}
          d="M51.7723 9.61562C51.7166 9.59499 51.6719 9.57916 51.6394 9.56799L51.6001 9.55468L51.5876 9.55057L51.5832 9.54915L51.5936 9.55286C51.6333 9.56667 51.7477 9.60655 51.7723 9.61562Z"
          fill="white"
        />
        <path
          className={color}
          d="M54.9505 14.8217L54.9521 14.8255L54.9641 14.8566L55.0195 15.0066L54.9505 14.8217Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.4618 13.9885C30.7256 11.5121 29.1272 9.40836 27.0358 8.03298C26.6236 7.7619 26.5092 7.20797 26.7793 6.79555C27.0497 6.38263 27.6036 6.26709 28.0164 6.5385C31.411 8.77095 33.694 12.6521 33.694 17.0675C33.694 20.481 31.9709 23.5584 29.8415 25.7443L29.8408 25.7451L29.8366 25.7493L29.834 25.752C29.3914 26.1954 28.6489 26.6212 27.8691 26.9324C27.074 27.2498 26.1206 27.4962 25.209 27.4962H17.1734C16.2634 27.4962 15.2986 27.2506 14.4973 26.9334C13.7252 26.6278 12.9663 26.2008 12.5333 25.7364C10.36 23.5036 8.63916 20.4296 8.63916 17.0181C8.63916 12.6576 10.8682 8.77405 14.2675 6.5385C14.6803 6.26708 15.2342 6.38264 15.5046 6.79555C15.7746 7.20797 15.6602 7.7619 15.248 8.03297C13.1735 9.39725 11.606 11.4806 10.8768 13.9196L11.2577 13.7784C14.325 12.6405 17.2555 11.5534 21.0415 11.53L21.1665 11.5296C21.1753 11.5296 21.1841 11.5297 21.1929 11.53C24.982 11.5535 27.8801 12.6427 30.9103 13.7815L30.9302 13.789C31.1069 13.8554 31.284 13.922 31.4618 13.9885ZM31.0272 18.7469C31.0446 18.7475 31.0677 18.7486 31.0958 18.7506C31.121 18.7524 31.1503 18.7551 31.1832 18.7588C31.2233 18.7634 31.2686 18.7697 31.3179 18.7782C31.3876 18.7904 31.4686 18.8078 31.5558 18.8329C31.5819 18.7017 31.6053 18.5697 31.6258 18.4372C31.6956 17.9866 31.7325 17.529 31.7325 17.0666C31.7325 16.6211 31.7064 16.1817 31.6557 15.7499C31.0284 15.5241 30.4241 15.2974 29.834 15.076C28.4479 14.5561 27.7146 14.066 26.3656 13.6841C26.1984 13.6367 26.0305 13.591 25.8618 13.5472C25.9218 13.6684 25.9788 13.7947 26.0331 13.9239C26.046 13.9547 26.0589 13.9859 26.0717 14.0173C26.3664 14.7437 26.6071 15.6242 26.7758 16.4215L26.7761 16.4228C26.9842 17.419 27.1314 18.3893 27.0748 19.1584C27.071 19.2097 27.0663 19.26 27.0607 19.3095C27.0505 19.3992 27.0369 19.4887 27.0191 19.577C27.1592 19.5495 27.2995 19.5218 27.4397 19.4941L27.7681 19.4291C29.0837 19.1688 29.8037 18.9115 30.9233 18.7512C30.9464 18.7479 30.9697 18.7462 30.9931 18.7462H30.9941L30.9953 18.7462L30.9981 18.7463L31.0055 18.7463L31.0179 18.7466L31.0272 18.7469ZM25.6249 19.4367C25.6455 19.3775 25.6683 19.2866 25.6836 19.1523C25.7458 18.6057 25.6413 17.769 25.4198 16.7082C25.2536 15.9234 25.0213 15.0945 24.7557 14.4623C24.6216 14.1432 24.4943 13.9114 24.386 13.7663C24.3515 13.7202 24.325 13.691 24.3078 13.674C24.2286 13.6499 24.1545 13.6154 24.0871 13.5722C23.1538 13.4131 22.1757 13.3205 21.1172 13.3177C19.9226 13.3209 18.8259 13.4384 17.7773 13.637C17.7167 13.673 17.6512 13.7022 17.5817 13.7234C17.5645 13.7404 17.538 13.7695 17.5035 13.8157C17.3952 13.9608 17.2679 14.1926 17.1338 14.5117C16.8681 15.1439 16.6359 15.9727 16.4697 16.7575C16.2482 17.8184 16.1436 18.6551 16.2058 19.2017C16.217 19.2997 16.2322 19.3749 16.2478 19.4317L16.2983 19.4402C18.0961 19.7425 19.791 19.977 21.1131 19.9774L21.1173 19.9774L21.2159 19.9774C22.4085 19.9774 23.9545 19.7455 25.6249 19.4367ZM11.5 18.9357C12.4937 19.0779 13.1424 19.2909 14.2825 19.4939L14.8647 19.5974C14.8496 19.5185 14.8378 19.4388 14.8287 19.3589C14.8222 19.3012 14.8169 19.2422 14.8128 19.182C14.7614 18.4171 14.9076 17.4573 15.1133 16.4722L15.1136 16.4709C15.2789 15.6901 15.5131 14.8295 15.7996 14.112C15.8183 14.0651 15.8372 14.0189 15.8564 13.9733C15.9044 13.8589 15.9546 13.7468 16.0071 13.6385C15.8386 13.6845 15.6706 13.7323 15.5031 13.7816C14.2598 14.1477 13.0391 14.5997 11.7527 15.076C11.2169 15.2745 11.1381 15.463 10.5731 15.6655C10.5206 16.1047 10.4936 16.5515 10.4936 17.004C10.4936 17.5461 10.5444 18.0816 10.6397 18.6074C10.6635 18.7389 10.6901 18.8698 10.7194 19C10.8768 18.9357 10.9468 18.9361 11 18.9263C11.0863 18.9105 11.0516 18.9375 11.1213 18.9322C11.2223 18.9244 11.3083 18.9243 11.3707 18.9263C11.4021 18.9273 11.4279 18.9289 11.4471 18.9303L11.4711 18.9323L11.5 18.9357ZM11.084 20.3602C11.6878 21.8967 12.6626 23.3089 13.8194 24.4957L13.8227 24.4992L13.8302 24.507L13.8344 24.5116L13.8367 24.514C13.9966 24.6876 14.4644 24.9977 15.1539 25.2706C15.8192 25.5339 16.5552 25.7082 17.1734 25.7082H25.209C25.8257 25.7082 26.5485 25.5346 27.2077 25.2715C27.8783 25.0038 28.3667 24.6905 28.5673 24.4914C29.7477 23.2786 30.7481 21.7986 31.3381 20.1796C30.345 20.3342 29.2305 20.5547 28.0654 20.7853C27.5333 20.8906 26.9911 20.9979 26.4481 21.1013C24.6071 21.4519 22.7196 21.7649 21.2201 21.7655L21.2158 21.7655L21.1173 21.7655C19.63 21.7655 17.8017 21.5061 16.0025 21.2035C15.3338 21.0911 14.6667 20.9723 14.0156 20.8563L14.0131 20.8558C12.9804 20.6719 11.9895 20.4954 11.084 20.3602Z"
          fill="white"
        />
        <path
          className={color}
          d="M23.6939 36.2515L23.6951 36.2515L24.4815 36.2554C24.4046 36.5539 24.3272 36.8969 24.2593 37.2397C24.1291 37.8965 24.0195 38.6214 24.0195 39.0984C24.0195 40.5391 24.4225 41.5534 24.8033 42.4001C24.8415 42.485 24.8789 42.5672 24.9152 42.6472L24.9159 42.6486L24.9168 42.6507L24.9178 42.6529C25.2507 43.385 25.4991 43.9314 25.4991 44.5984C25.4991 45.3814 25.2945 45.9545 25.0973 46.3278C24.9983 46.5154 24.9003 46.6539 24.8294 46.7438C24.794 46.7886 24.7651 46.8216 24.7457 46.8429C24.736 46.8537 24.7283 46.8619 24.7218 46.8687L24.7097 46.8816C24.7077 46.8838 24.7022 46.8898 24.6958 46.8973C24.6927 46.9008 24.6858 46.9089 24.6782 46.9188C24.6739 46.9244 24.6514 46.9532 24.6305 46.9932L24.6276 46.999C24.3772 47.4943 24.582 48.0933 25.0758 48.3378C25.2193 48.409 25.3728 48.4423 25.5219 48.4423C25.8674 48.4423 26.2075 48.2628 26.3919 47.9401L26.414 47.9127C26.4474 47.8714 26.4948 47.8117 26.5507 47.7351C26.6624 47.5818 26.8058 47.3637 26.9471 47.0799C27.2306 46.5104 27.5016 45.6847 27.5016 44.5984C27.5016 43.3575 27.0882 42.4386 26.7188 41.6171L26.7177 41.6149C26.3453 40.7868 26.0219 40.0644 26.0219 39.0984C26.0219 38.5892 26.1813 37.815 26.3578 37.1276C26.4439 36.7922 26.5303 36.4912 26.5957 36.2732L26.5977 36.2665L27.6944 36.2714C28.2235 36.2744 28.5729 35.7037 28.3029 35.2324L28.2936 35.2162L26.3402 32.3295C26.0715 31.893 25.4393 31.8918 25.1636 32.316L23.1108 35.1841L23.1003 35.2016C22.8189 35.6714 23.1654 36.248 23.6939 36.2515Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.6951 36.2515L31.6939 36.2515C31.1654 36.248 30.8189 35.6714 31.1003 35.2016L31.1108 35.1841L33.1636 32.316C33.4393 31.8918 34.0715 31.893 34.3402 32.3295L36.2936 35.2162L36.3029 35.2324C36.5729 35.7037 36.2235 36.2744 35.6944 36.2714L34.5972 36.2659L34.5957 36.2732C34.5303 36.4912 34.4439 36.7922 34.3578 37.1276C34.1813 37.815 34.0219 38.5892 34.0219 39.0984C34.0219 40.0644 34.3453 40.7868 34.7177 41.6149L34.7188 41.6171C35.0882 42.4386 35.5016 43.3575 35.5016 44.5984C35.5016 45.6847 35.2306 46.5104 34.9471 47.0799C34.8058 47.3637 34.6624 47.5818 34.5507 47.7351C34.4948 47.8117 34.4474 47.8714 34.414 47.9127L34.3919 47.9401C34.2075 48.2628 33.8674 48.4423 33.5219 48.4423C33.3728 48.4423 33.2193 48.409 33.0758 48.3378C32.582 48.0933 32.3772 47.4943 32.6276 46.999L32.6305 46.9932C32.6514 46.9532 32.6739 46.9244 32.6782 46.9188C32.6858 46.9089 32.6927 46.9008 32.6958 46.8973C32.7022 46.8898 32.7077 46.8838 32.7097 46.8816L32.7218 46.8687L32.7278 46.8623L32.7457 46.8429C32.7651 46.8216 32.794 46.7886 32.8294 46.7438C32.9003 46.6539 32.9983 46.5154 33.0973 46.3278C33.2945 45.9545 33.4991 45.3814 33.4991 44.5984C33.4991 43.9314 33.2507 43.385 32.9178 42.6529L32.9168 42.6507L32.9159 42.6486C32.8793 42.5682 32.8417 42.4854 32.8033 42.4001C32.4225 41.5534 32.0195 40.5391 32.0195 39.0984C32.0195 38.6214 32.1291 37.8965 32.2593 37.2397C32.3272 36.8969 32.4046 36.5539 32.4815 36.2554L31.6951 36.2515Z"
          fill="white"
        />
        <path
          className={color}
          d="M39.6939 36.2515L39.6951 36.2515L40.4815 36.2554C40.4046 36.5539 40.3272 36.8969 40.2593 37.2397C40.1291 37.8965 40.0195 38.6214 40.0195 39.0984C40.0195 40.5391 40.4225 41.5534 40.8033 42.4001C40.8424 42.4869 40.8806 42.5711 40.9178 42.6529C41.2507 43.385 41.4991 43.9314 41.4991 44.5984C41.4991 45.3814 41.2945 45.9545 41.0974 46.3278C40.9983 46.5154 40.9003 46.6539 40.8294 46.7438C40.794 46.7886 40.7651 46.8216 40.7457 46.8429C40.736 46.8537 40.7283 46.8619 40.7218 46.8687L40.7097 46.8816C40.7097 46.8816 40.7065 46.8851 40.7038 46.8881C40.7015 46.8907 40.6987 46.8938 40.6958 46.8973C40.6927 46.9008 40.6858 46.9089 40.6782 46.9188C40.6739 46.9244 40.6514 46.9532 40.6305 46.9932L40.6276 46.999C40.3772 47.4943 40.582 48.0933 41.0758 48.3378C41.2193 48.409 41.3728 48.4423 41.5219 48.4423C41.8674 48.4423 42.2075 48.2628 42.3919 47.9401L42.414 47.9127C42.4474 47.8714 42.4948 47.8117 42.5507 47.7351C42.6624 47.5818 42.8058 47.3637 42.9471 47.0799C43.2306 46.5104 43.5016 45.6847 43.5016 44.5984C43.5016 43.3575 43.0882 42.4386 42.7188 41.6171L42.7177 41.6149C42.3453 40.7868 42.0219 40.0644 42.0219 39.0984C42.0219 38.5892 42.1813 37.815 42.3578 37.1276C42.4439 36.7922 42.5303 36.4912 42.5957 36.2732L42.5977 36.2665L43.6944 36.2714C44.2235 36.2744 44.5729 35.7037 44.3029 35.2324L44.2936 35.2162L42.3402 32.3295C42.0715 31.893 41.4393 31.8918 41.1636 32.316L39.1108 35.1841L39.1003 35.2016C38.8189 35.6714 39.1654 36.248 39.6939 36.2515Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-dreamdrive': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-dreamdrive"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <g clipPath="url(#clip0_20605_72433)">
          <path
            className={color}
            d="M4.60864 45.6673C1.91198 42.2424 0.333252 38.0596 0.333252 33.5512C0.333252 28.9357 2.02306 24.6462 4.72459 21.3223C5.01563 20.9643 5.55165 20.9022 5.9218 21.1838C6.29196 21.4653 6.35607 21.9839 6.06503 22.3419C3.58628 25.3917 2.03842 29.3261 2.03842 33.5512C2.03842 37.678 3.48152 41.5134 5.96513 44.6677C6.25045 45.0301 6.17807 45.5476 5.80349 45.8236C5.42891 46.0996 4.89396 46.0296 4.60864 45.6673Z"
            fill="white"
          />
          <path
            className={color}
            d="M7.04685 33.4484C7.04685 36.7247 8.19474 39.6695 10.0196 42.0596C10.2994 42.426 10.8332 42.5036 11.212 42.2329C11.5907 41.9623 11.671 41.4459 11.3912 41.0795C9.76259 38.9464 8.75202 36.3401 8.75202 33.4484C8.75202 30.6577 9.76345 27.9575 11.4841 25.8365C11.7748 25.4782 11.7101 24.9597 11.3397 24.6785C10.9693 24.3973 10.4334 24.4597 10.1427 24.8181C8.1939 27.2202 7.04685 30.2768 7.04685 33.4484Z"
            fill="white"
          />
          <path
            className={color}
            d="M64.3332 33.4488C64.3332 28.9404 62.7544 24.7576 60.0578 21.3327C59.7725 20.9704 59.2375 20.9004 58.8629 21.1764C58.4883 21.4524 58.416 21.9699 58.7013 22.3323C61.1849 25.4866 62.628 29.322 62.628 33.4488C62.628 37.6739 61.0801 41.6083 58.6014 44.6581C58.3104 45.0161 58.3745 45.5347 58.7446 45.8162C59.1148 46.0978 59.6508 46.0357 59.9418 45.6777C62.6434 42.3538 64.3332 38.0643 64.3332 33.4488Z"
            fill="white"
          />
          <path
            className={color}
            d="M54.6468 24.9404C56.4717 27.3305 57.6196 30.2753 57.6196 33.5516C57.6196 36.7232 56.4725 39.7798 54.5238 42.1819C54.2331 42.5403 53.6971 42.6027 53.3267 42.3215C52.9563 42.0403 52.8917 41.5218 53.1824 41.1635C54.903 39.0425 55.9144 36.3423 55.9144 33.5516C55.9144 30.6599 54.9038 28.0536 53.2752 25.9205C52.9954 25.5541 53.0757 25.0377 53.4544 24.7671C53.8332 24.4964 54.367 24.574 54.6468 24.9404Z"
            fill="white"
          />
          <path
            className={color}
            d="M43.9696 33.9336C44.4313 33.8618 44.7499 33.4313 44.6768 32.9692C44.6038 32.5076 44.1684 32.195 43.7071 32.2668C38.1579 33.1301 27.5885 33.132 21.3954 32.2649C20.9331 32.2002 20.5025 32.5193 20.4367 32.982C20.3707 33.4452 20.6959 33.8707 21.1586 33.9355C27.4996 34.8233 38.2382 34.8252 43.9696 33.9336Z"
            fill="white"
          />
          <path
            className={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8893 44.4615L15.8759 44.429C15.6712 43.937 15.5549 43.4121 15.5322 42.8807C15.2745 36.8484 15.2497 36.8858 15.5613 32.1631C15.6335 31.0682 15.9138 30.0935 16.4552 29.2837C16.9352 28.5657 17.5934 28.0181 18.4059 27.6346L21.0184 21.236C21.525 19.9952 22.7075 19.1515 24.0558 19.0749C30.6502 18.7001 34.1062 18.7063 40.693 19.0752C42.0562 19.1515 43.2498 20.0114 43.7485 21.2718L46.2559 27.6092C47.2048 27.991 47.8975 28.5517 48.3609 29.3144C48.8668 30.1468 49.0445 31.1323 49.1068 32.168C49.4229 37.4298 49.3752 37.5075 49.1655 42.2246L49.1446 42.6948C49.1146 43.3724 48.9328 44.0391 48.6113 44.6398L48.3877 45.0577C48.0098 45.7637 47.2703 46.2041 46.4661 46.2041H43.3819C42.7857 46.2041 42.2441 45.8562 42.0007 45.3141L41.3747 43.9204C41.1917 43.5129 40.7833 43.2492 40.3313 43.2492H23.8498C23.6703 43.2492 23.5068 43.3482 23.4249 43.5044L22.4335 45.3958C22.1728 45.8931 21.6553 46.2041 21.092 46.2041H18.514C17.3651 46.2041 16.3283 45.5169 15.8893 44.4615ZM24.1399 20.5357C30.6771 20.1642 34.0773 20.1703 40.6099 20.5361C41.397 20.5802 42.0881 21.0773 42.3766 21.8067L45.1301 28.7661L45.4075 28.8578C46.2909 29.1498 46.7904 29.5625 47.099 30.0703C47.4211 30.6004 47.5783 31.3035 47.6355 32.255C47.9473 37.4436 47.9015 37.4734 47.6939 42.1403L47.6721 42.6302C47.6517 43.092 47.5276 43.5459 47.3098 43.9529L47.0862 44.3707C46.9644 44.5983 46.7258 44.7405 46.466 44.7405H43.3817C43.3665 44.7405 43.3527 44.7317 43.3466 44.7179L42.7206 43.3242C42.3003 42.3884 41.3641 41.7856 40.3312 41.7856H23.8496C23.1213 41.7856 22.4535 42.1877 22.1175 42.8286L21.1261 44.72C21.1194 44.7326 21.1063 44.7405 21.0919 44.7405H18.5139C17.9608 44.7405 17.4623 44.4097 17.2514 43.9026L17.2379 43.8702C17.0991 43.5364 17.02 43.1796 17.0045 42.8185C16.748 36.8147 16.725 36.9093 17.0318 32.2586C17.0917 31.3505 17.3175 30.6395 17.6829 30.0929C18.0449 29.5514 18.5692 29.133 19.2945 28.8452L19.5418 28.7472L22.3841 21.7857C22.6773 21.0675 23.3618 20.58 24.1399 20.5357Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_20605_72433">
            <rect width="64" height="64" fill="white" transform="translate(0.333252 0.5)" />
          </clipPath>
        </defs>
      </svg>
    ),
    'gravity-heated-steering-wheel': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-heated-steering-wheel"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M25.7375 10.7532C25.9281 10.2846 25.6963 9.7528 25.2197 9.56536C24.7431 9.37792 24.2022 9.60584 24.0116 10.0744C23.2829 11.8655 23.059 13.1888 23.1651 14.2843C23.2704 15.371 23.6964 16.1386 24.0415 16.7606L24.0586 16.7913C24.4076 17.4205 24.6662 17.9021 24.7335 18.5965C24.8016 19.3 24.6771 20.3185 24.0116 21.9543C23.821 22.4229 24.0528 22.9547 24.5294 23.1421C25.006 23.3296 25.5469 23.1016 25.7375 22.633C26.4661 20.842 26.6901 19.5187 26.5839 18.4232C26.4787 17.3364 26.0527 16.5688 25.7075 15.9469L25.6904 15.9161C25.3414 15.287 25.0828 14.8054 25.0155 14.111C24.9474 13.4074 25.072 12.389 25.7375 10.7532Z"
          fill="white"
        />
        <path
          className={color}
          d="M33.1727 10.7532C33.3634 10.2846 33.1316 9.7528 32.655 9.56536C32.1784 9.37792 31.6375 9.60584 31.4469 10.0744C30.7182 11.8655 30.4943 13.1888 30.6004 14.2843C30.7056 15.371 31.1316 16.1386 31.4768 16.7606L31.4939 16.7913C31.8429 17.4205 32.1015 17.9021 32.1688 18.5965C32.2369 19.3 32.1124 20.3185 31.4469 21.9543C31.2563 22.4229 31.4881 22.9547 31.9647 23.1421C32.4412 23.3296 32.9821 23.1016 33.1728 22.633C33.9014 20.842 34.1253 19.5187 34.0192 18.4232C33.9139 17.3364 33.4879 16.5688 33.1428 15.9469L33.1257 15.9161C32.7767 15.287 32.5181 14.8054 32.4508 14.111C32.3827 13.4074 32.5073 12.389 33.1727 10.7532Z"
          fill="white"
        />
        <path
          className={color}
          d="M40.0903 9.56536C40.5669 9.7528 40.7987 10.2846 40.608 10.7532C39.9425 12.389 39.818 13.4074 39.8861 14.111C39.9534 14.8054 40.212 15.287 40.561 15.9161L40.5781 15.9469C40.9232 16.5688 41.3492 17.3364 41.4545 18.4232C41.5606 19.5187 41.3367 20.842 40.6081 22.633C40.4174 23.1016 39.8765 23.3296 39.3999 23.1421C38.9234 22.9547 38.6915 22.4229 38.8822 21.9543C39.5476 20.3185 39.6722 19.3 39.6041 18.5965C39.5368 17.9021 39.2782 17.4205 38.9292 16.7913L38.9121 16.7606C38.5669 16.1386 38.1409 15.371 38.0357 14.2843C37.9295 13.1888 38.1535 11.8655 38.8822 10.0744C39.0728 9.60584 39.6137 9.37792 40.0903 9.56536Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.4226 17.2822C19.4226 16.7373 18.9062 16.3392 18.3868 16.5042C16.2825 17.1725 14.3863 18.1469 12.692 19.5636C9.03835 22.6186 7.55177 28.1831 7.44107 33.5638C7.33006 38.96 8.59466 44.4952 10.7973 47.6714C12.8641 50.6515 15.0967 52.3944 18.4698 53.3576C21.7614 54.2976 26.1188 54.4867 32.3934 54.4985C38.6464 54.5102 42.8886 54.4587 46.1195 53.5817C49.4503 52.6776 51.6793 50.9101 53.9878 47.681C56.0775 44.7578 57.4552 39.4259 57.4341 34.0649C57.413 28.7044 55.9915 23.0365 52.1685 19.5844C50.5719 18.1427 48.6149 17.1677 46.4787 16.5054C45.9596 16.3445 45.4461 16.7424 45.4461 17.2858C45.4461 17.6582 45.6945 17.9833 46.0498 18.095C47.9817 18.7023 49.6807 19.5682 51.0384 20.7942C53.4095 22.9353 54.7929 26.1511 55.3978 29.6968L43.0736 29.6968C42.1014 27.5664 39.9262 26.1021 37.4251 26.1021H27.4471C24.946 26.1021 22.7708 27.5664 21.7986 29.6968H9.45948C10.0648 26.0007 11.4616 22.7487 13.7743 20.815C15.2603 19.5725 16.9306 18.7002 18.8236 18.0904C19.1764 17.9768 19.4226 17.6529 19.4226 17.2822ZM43.5542 31.3395L55.6209 31.3395C55.7134 32.2405 55.7598 33.1549 55.7634 34.0712C55.7669 34.9432 55.7315 35.8091 55.6615 36.6582L44.8237 40.2319C44.6436 40.2913 44.4628 40.3482 44.2813 40.4027L43.5959 31.717C43.5859 31.5899 43.572 31.4641 43.5542 31.3395ZM45.3549 41.7893L55.4589 38.4576C54.9648 41.9085 53.9126 44.9297 52.621 46.7363C50.472 49.7424 48.5385 51.221 45.6749 51.9983C42.7116 52.8026 38.7278 52.8677 32.3966 52.8558C26.0871 52.8439 21.9649 52.6452 18.9358 51.7802C15.9882 50.9384 14.0591 49.4588 12.1777 46.7459C10.7762 44.7251 9.73916 41.4632 9.31534 37.8369L19.1192 41.4964C21.6764 42.4509 24.3889 42.9401 27.1241 42.9401H38.1836C40.6216 42.9401 43.0434 42.5515 45.3549 41.7893ZM9.49554 36.1471C9.38543 36.106 9.27198 36.0893 9.16136 36.0942C9.11174 35.2697 9.09419 34.4341 9.11141 33.597C9.12705 32.8368 9.17119 32.0821 9.24476 31.3395H21.318C21.3003 31.4641 21.2863 31.5899 21.2763 31.717L20.6014 40.2702C20.3029 40.1737 20.0064 40.0705 19.7122 39.9607L9.49554 36.1471ZM42.7605 40.7983L42.0532 31.8347C41.8657 29.458 39.8496 27.6235 37.4251 27.6235H27.4471C25.0227 27.6235 23.0065 29.458 22.819 31.8347L22.1195 40.6991C23.754 41.0958 25.4344 41.2975 27.1241 41.2975H38.1836C39.7255 41.2975 41.2604 41.1296 42.7605 40.7983Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-comfort-and-convenience': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-comfort-and-convenience"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M17.1719 3.68434C16.7515 3.51619 16.2745 3.72065 16.1063 4.14101C15.7444 5.04567 15.6171 5.753 15.6756 6.36719C15.7333 6.97339 15.9681 7.40358 16.1346 7.70865L16.1478 7.73278C16.3156 8.0405 16.4029 8.2147 16.4271 8.46868C16.4521 8.73127 16.4125 9.16514 16.1063 9.93051C15.9382 10.3509 16.1426 10.8279 16.563 10.9961C16.9834 11.1642 17.4604 10.9598 17.6286 10.5394C17.9904 9.63475 18.1178 8.92741 18.0593 8.31322C18.0015 7.70703 17.7667 7.27685 17.6003 6.97178L17.5871 6.94763C17.539 6.85944 17.4975 6.78222 17.4622 6.71095C17.3744 6.53353 17.325 6.39294 17.3077 6.21176C17.2827 5.94916 17.3224 5.51529 17.6286 4.74992C17.7967 4.32956 17.5923 3.85249 17.1719 3.68434Z"
          fill="white"
        />
        <path
          className={color}
          d="M20.7347 3.68434C20.3143 3.51619 19.8372 3.72065 19.6691 4.14101C19.3072 5.04567 19.1799 5.753 19.2384 6.36719C19.2961 6.97339 19.5309 7.40359 19.6974 7.70866L19.7106 7.7328C19.8784 8.04051 19.9657 8.2147 19.9899 8.46868C20.0149 8.73127 19.9752 9.16514 19.6691 9.93051C19.5009 10.3509 19.7054 10.8279 20.1258 10.9961C20.5461 11.1642 21.0232 10.9598 21.1913 10.5394C21.5532 9.63475 21.6805 8.92741 21.622 8.31322C21.5643 7.70703 21.3295 7.27685 21.163 6.97178L21.1498 6.94763C21.1017 6.85945 21.0603 6.78223 21.025 6.71096C20.9371 6.53353 20.8878 6.39295 20.8705 6.21176C20.8455 5.94916 20.8852 5.51529 21.1913 4.74992C21.3595 4.32956 21.155 3.85249 20.7347 3.68434Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4899 8.33689C12.4899 8.22046 12.4358 8.11066 12.3434 8.0398C12.251 7.96894 12.1309 7.94509 12.0185 7.97527C10.7666 8.31122 9.64052 8.84488 8.64786 9.68904C6.77327 11.2832 6.05376 14.1321 6.00001 16.7895C5.94596 19.4616 6.55744 22.2469 7.67323 23.8832C8.70508 25.3964 9.8429 26.3058 11.5545 26.803C13.1906 27.2781 15.3312 27.368 18.3301 27.3738C21.309 27.3795 23.3995 27.3574 25.0075 26.9135C26.7083 26.444 27.8426 25.5168 28.9845 23.8922C30.0465 22.3813 30.7142 19.6962 30.7039 17.0398C30.6936 14.3841 30.004 11.4942 28.0596 9.70861C27.1141 8.84031 25.9336 8.30902 24.6806 7.979C24.5683 7.94942 24.4486 7.97362 24.3566 8.04451C24.2647 8.1154 24.2108 8.22494 24.2108 8.34106V9.17112C24.2108 9.33833 24.3217 9.48528 24.4825 9.53116C25.491 9.81897 26.3495 10.2417 27.0116 10.8498C27.9726 11.7323 28.5878 13.0395 28.9023 14.5381L23.6807 14.5381C23.1137 13.4902 22.0051 12.7863 20.7418 12.7863H15.9606C14.6974 12.7863 13.5888 13.4902 13.0217 14.5381H7.78954C8.10462 12.9698 8.72428 11.6579 9.65158 10.8693C10.3915 10.2401 11.2363 9.81398 12.2204 9.527C12.3801 9.48041 12.4899 9.33397 12.4899 9.16756V8.33689ZM14.1163 15.9834C14.191 15.0201 14.9945 14.2766 15.9606 14.2766H20.7418C21.708 14.2766 22.5114 15.0201 22.5862 15.9834L22.8996 20.023C22.309 20.135 21.7083 20.1916 21.1052 20.1916H15.8059C15.1324 20.1916 14.4622 20.121 13.8061 19.9817L14.1163 15.9834ZM24.3635 19.6261L24.089 16.0875L29.1176 16.0875C29.1412 16.4046 29.1533 16.7248 29.1546 17.0458C29.1558 17.3763 29.1456 17.705 29.1248 18.0294L24.3635 19.6261ZM7.54906 16.8208C7.55404 16.5746 7.5652 16.3299 7.58265 16.0875H12.6135L12.3449 19.5485L7.55858 17.7314C7.54626 17.4296 7.5429 17.1254 7.54906 16.8208ZM8.95332 23.0103C8.40434 22.2052 7.96264 20.9301 7.72853 19.4532L11.8373 21.013C13.1051 21.4943 14.4498 21.741 15.8059 21.741H21.1052C22.3139 21.741 23.5146 21.545 24.6606 21.1607L28.9138 19.7343C28.6563 21.122 28.2174 22.2893 27.7169 23.0013C26.723 24.4153 25.8627 25.0701 24.5952 25.42C23.2353 25.7955 21.3844 25.8303 18.333 25.8244C15.3017 25.8186 13.3793 25.7196 11.9867 25.3151C10.6696 24.9325 9.81328 24.2715 8.95332 23.0103Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.632 53.5172C14.6137 53.5091 14.5753 53.4894 14.515 53.4457C14.3784 53.3468 14.2003 53.1753 13.9879 52.9149C13.5642 52.3955 13.1077 51.6526 12.662 50.8133C11.7749 49.1428 11.0163 47.2554 10.7275 46.4459L10.7262 46.4424C10.6131 46.1293 10.6601 45.5702 11.0695 44.9863C11.4597 44.43 12.1282 43.9409 13.0546 43.7882C13.6007 43.6982 13.9696 43.1874 13.8786 42.6474C13.7876 42.1073 13.2711 41.7424 12.725 41.8325C11.2454 42.0763 10.1095 42.8761 9.42205 43.8563C8.75424 44.8086 8.45028 46.0331 8.83744 47.1075C9.15045 47.9842 9.94526 49.9618 10.887 51.7352C11.3561 52.6184 11.8833 53.4927 12.4275 54.1599C12.6991 54.4928 13.0011 54.8069 13.3302 55.0452C13.6509 55.2776 14.0832 55.5 14.5939 55.5H36.6479C40.1398 55.5 42.1209 52.7403 43.2811 51.1148C43.4939 50.8168 43.7337 50.3387 43.9789 49.8001C44.235 49.2376 44.5304 48.5329 44.8511 47.7305C45.4931 46.1244 46.2494 44.0955 47.0155 41.9653C48.5475 37.7057 50.1313 33.0073 50.9387 30.4122L50.94 30.4082C51.965 27.0629 52.5067 23.834 52.636 21.0328C52.7644 18.252 52.49 15.8166 51.8176 14.099L51.8091 14.0778C51.0981 12.3786 49.7574 11.2488 48.6649 10.5601C48.1116 10.2112 47.6009 9.96207 47.2264 9.79921C47.0386 9.71753 46.8835 9.65685 46.7723 9.61562C46.7167 9.59499 46.6719 9.57916 46.6394 9.56799L46.6001 9.55467L46.5876 9.55057L46.5832 9.54915L46.5936 9.55286L46.5801 9.54814C46.282 9.45276 45.9559 9.50071 45.6988 9.67774C45.4416 9.85477 45.2829 10.1414 45.2699 10.451L45.2697 10.4545L45.2691 10.4691L45.2664 10.5282C45.264 10.5806 45.2604 10.6587 45.2554 10.7603C45.2453 10.9636 45.2298 11.2609 45.208 11.635C45.1645 12.3834 45.0961 13.4384 44.9966 14.6625C44.7971 17.1169 44.4744 20.2264 43.982 22.9046C43.883 23.4432 44.2443 23.9593 44.789 24.0573C45.3337 24.1552 45.8556 23.7979 45.9546 23.2592C46.4647 20.4848 46.7936 17.2991 46.9951 14.8214C47.0854 13.7101 47.1505 12.7363 47.1948 11.999C47.3212 12.0696 47.4527 12.1472 47.5872 12.232C48.4959 12.8049 49.4568 13.6533 49.9505 14.8217L50.0195 15.0066C50.5032 16.3669 50.7498 18.4171 50.6332 20.9424C50.512 23.5682 50.0014 26.6333 49.0222 29.83L49.0199 29.8374C48.9744 29.9834 48.9265 30.1363 48.8762 30.2954C48.0435 32.9296 46.5635 37.3055 45.1265 41.3009C44.3639 43.4212 43.6165 45.4259 42.9866 47.0016C42.6714 47.79 42.3888 48.4632 42.1507 48.9861C41.9017 49.5331 41.7312 49.8481 41.6432 49.9714C40.3975 51.7166 38.9703 53.5172 36.6479 53.5172H14.632ZM14.632 53.5172L14.6412 53.5211L14.6444 53.5223C14.6444 53.5223 14.6271 53.5172 14.5939 53.5172H14.632ZM50.0195 15.0066C50.0014 14.9556 49.9829 14.9056 49.9641 14.8566L50.0195 15.0066ZM49.9521 14.8255L49.9565 14.836L49.9641 14.8566L49.9521 14.8255ZM49.9521 14.8255L49.9479 14.8148L49.9505 14.8217L49.9521 14.8255ZM46.5936 9.55286L46.7723 9.61562C46.7477 9.60655 46.6333 9.56667 46.5936 9.55286Z"
          fill="white"
        />
        <path
          className={color}
          d="M18.6951 36.2515L18.6939 36.2515C18.1654 36.248 17.8189 35.6714 18.1003 35.2016L18.1108 35.1841L20.1636 32.316C20.4394 31.8918 21.0715 31.893 21.3402 32.3295L23.2936 35.2162L23.3029 35.2324C23.5729 35.7037 23.2235 36.2744 22.6944 36.2714L21.5977 36.2665L21.5957 36.2732C21.5303 36.4912 21.4439 36.7922 21.3578 37.1276C21.1814 37.815 21.0219 38.5892 21.0219 39.0984C21.0219 40.0644 21.3453 40.7868 21.7178 41.6149L21.7188 41.6171C22.0882 42.4386 22.5016 43.3575 22.5016 44.5984C22.5016 45.6847 22.2306 46.5104 21.9471 47.0799C21.8058 47.3637 21.6624 47.5818 21.5507 47.7351C21.4948 47.8117 21.4474 47.8714 21.414 47.9127L21.3919 47.9401C21.2075 48.2628 20.8674 48.4423 20.5219 48.4423C20.3728 48.4423 20.2193 48.409 20.0758 48.3378C19.582 48.0933 19.3772 47.4943 19.6276 46.999L19.6305 46.9932C19.6514 46.9532 19.6739 46.9244 19.6782 46.9188C19.6858 46.9089 19.6927 46.9008 19.6958 46.8973C19.7022 46.8898 19.7077 46.8838 19.7097 46.8816L19.7353 46.8543L19.7457 46.8429C19.7651 46.8216 19.794 46.7886 19.8294 46.7438C19.9003 46.6539 19.9983 46.5154 20.0974 46.3278C20.2945 45.9545 20.4991 45.3814 20.4991 44.5984C20.4991 43.9314 20.2507 43.385 19.9178 42.6529L19.9168 42.6507L19.9159 42.6486L19.9153 42.6472C19.8789 42.5672 19.8415 42.485 19.8033 42.4001C19.4225 41.5534 19.0195 40.5391 19.0195 39.0984C19.0195 38.6214 19.1291 37.8965 19.2593 37.2397C19.3272 36.8969 19.4046 36.5539 19.4815 36.2554L18.6951 36.2515Z"
          fill="white"
        />
        <path
          className={color}
          d="M26.6951 36.2515L26.6939 36.2515C26.1654 36.248 25.8189 35.6714 26.1003 35.2016L26.1108 35.1841L28.1636 32.316C28.4394 31.8918 29.0715 31.893 29.3402 32.3295L31.2936 35.2162L31.3029 35.2324C31.5729 35.7037 31.2235 36.2744 30.6944 36.2714L29.5972 36.2659L29.5957 36.2732C29.5303 36.4912 29.4439 36.7922 29.3578 37.1276C29.1814 37.815 29.0219 38.5892 29.0219 39.0984C29.0219 40.0644 29.3453 40.7868 29.7178 41.6149L29.7188 41.6171C30.0882 42.4386 30.5016 43.3575 30.5016 44.5984C30.5016 45.6847 30.2306 46.5104 29.9471 47.0799C29.8058 47.3637 29.6624 47.5818 29.5507 47.7351C29.4948 47.8117 29.4474 47.8714 29.414 47.9127L29.3919 47.9401C29.2075 48.2628 28.8674 48.4423 28.5219 48.4423C28.3728 48.4423 28.2193 48.409 28.0758 48.3378C27.582 48.0933 27.3772 47.4943 27.6276 46.999L27.6305 46.9932C27.6514 46.9532 27.6739 46.9244 27.6782 46.9188C27.6858 46.9089 27.6927 46.9008 27.6958 46.8973L27.7021 46.8901L27.7097 46.8816L27.7218 46.8687L27.7278 46.8623L27.7457 46.8429C27.7651 46.8216 27.794 46.7886 27.8294 46.7438C27.9003 46.6539 27.9983 46.5154 28.0974 46.3278C28.2945 45.9545 28.4991 45.3814 28.4991 44.5984C28.4991 43.9314 28.2507 43.385 27.9178 42.6529L27.9168 42.6507L27.9159 42.6486C27.8793 42.5682 27.8417 42.4854 27.8033 42.4001C27.4225 41.5534 27.0195 40.5391 27.0195 39.0984C27.0195 38.6214 27.1291 37.8965 27.2593 37.2397C27.3272 36.8969 27.4046 36.5539 27.4815 36.2554L26.6951 36.2515Z"
          fill="white"
        />
        <path
          className={color}
          d="M34.6951 36.2515L34.6939 36.2515C34.1654 36.248 33.8189 35.6714 34.1003 35.2016L34.1108 35.1841L36.1636 32.316C36.4394 31.8918 37.0715 31.893 37.3402 32.3295L39.2936 35.2162L39.3029 35.2324C39.5729 35.7037 39.2235 36.2744 38.6945 36.2714L37.5977 36.2665L37.5957 36.2732C37.5303 36.4912 37.4439 36.7922 37.3578 37.1276C37.1814 37.815 37.0219 38.5892 37.0219 39.0984C37.0219 40.0644 37.3453 40.7868 37.7178 41.6149L37.7188 41.6171C38.0882 42.4386 38.5016 43.3575 38.5016 44.5984C38.5016 45.6847 38.2306 46.5104 37.9471 47.0799C37.8058 47.3637 37.6624 47.5818 37.5507 47.7351C37.4948 47.8117 37.4474 47.8714 37.414 47.9127L37.3919 47.9401C37.2075 48.2628 36.8674 48.4423 36.5219 48.4423C36.3728 48.4423 36.2193 48.409 36.0758 48.3378C35.582 48.0933 35.3772 47.4943 35.6276 46.999L35.6305 46.9932C35.6514 46.9532 35.6738 46.9244 35.6782 46.9188C35.6858 46.909 35.6927 46.9008 35.6958 46.8973L35.7038 46.8881L35.7097 46.8816L35.7318 46.8581L35.7457 46.8429C35.7651 46.8216 35.794 46.7886 35.8294 46.7438C35.9003 46.6539 35.9983 46.5154 36.0974 46.3278C36.2945 45.9545 36.4991 45.3814 36.4991 44.5984C36.4991 43.9314 36.2507 43.385 35.9178 42.6529L35.9173 42.6518C35.8803 42.5703 35.8422 42.4866 35.8033 42.4001C35.4225 41.5534 35.0195 40.5391 35.0195 39.0984C35.0195 38.6214 35.1291 37.8965 35.2593 37.2397C35.3272 36.8969 35.4046 36.5539 35.4815 36.2554L34.6951 36.2515Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-12-ways-front-seats': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-12-ways-front-seats"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M46.6186 15.3255L46.623 15.336L46.627 15.3471C46.6242 15.3399 46.6214 15.3327 46.6186 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.248 10.0486L43.2466 10.0481C42.9485 9.95276 42.6224 10.0007 42.3653 10.1777C42.1081 10.3548 41.9494 10.6414 41.9364 10.951L41.9362 10.9545L41.9356 10.9691L41.9329 11.0282C41.9305 11.0806 41.9269 11.1587 41.9219 11.2603C41.9118 11.4636 41.8963 11.7609 41.8745 12.135C41.831 12.8834 41.7626 13.9384 41.6631 15.1625C41.4636 17.6169 41.1409 20.7264 40.6485 23.4046C40.5495 23.9432 40.9108 24.4593 41.4555 24.5573C42.0002 24.6552 42.5221 24.2979 42.6211 23.7592C43.1312 20.9848 43.4601 17.7991 43.6616 15.3214C43.7519 14.2101 43.817 13.2363 43.8613 12.499C43.9877 12.5696 44.1192 12.6472 44.2537 12.732C45.162 13.3046 46.1224 14.1526 46.6164 15.3202L46.7393 15.6621L46.627 15.3471C47.1494 16.7041 47.421 18.8164 47.2997 21.4424C47.1785 24.0682 46.6679 27.1335 45.6886 30.3303C45.6871 30.335 45.6855 30.3402 45.6841 30.3449C44.886 32.9084 43.3154 37.5681 41.793 41.8009C41.0304 43.9212 40.283 45.9259 39.6531 47.5016C39.3379 48.29 39.0553 48.9632 38.8172 49.4861C38.5682 50.0331 38.3977 50.3481 38.3097 50.4714C37.064 52.2166 35.6368 54.0172 33.3144 54.0172H11.2985C11.2802 54.0091 11.2418 53.9894 11.1815 53.9457C11.0449 53.8468 10.8668 53.6753 10.6544 53.4149C10.2307 52.8955 9.77424 52.1526 9.32853 51.3133C8.44141 49.6428 7.68283 47.7554 7.39396 46.9459L7.3927 46.9424C7.27963 46.6293 7.32656 46.0702 7.73601 45.4863C8.12618 44.93 8.79468 44.4409 9.72106 44.2882C10.2672 44.1982 10.6361 43.6874 10.5451 43.1474C10.4541 42.6073 9.93756 42.2424 9.39145 42.3325C7.91194 42.5763 6.77602 43.3761 6.08855 44.3563C5.42073 45.3086 5.11677 46.5331 5.50394 47.6075C5.51459 47.6373 5.52579 47.6684 5.53754 47.7007C5.87119 48.6185 6.6438 50.5221 7.55352 52.2352C8.02255 53.1184 8.54976 53.9927 9.09402 54.6599C9.36559 54.9928 9.66762 55.3069 9.99665 55.5452C10.3174 55.7776 10.7497 56 11.2604 56H33.3144C36.8063 56 38.7874 53.2403 39.9476 51.6148C40.1604 51.3168 40.4002 50.8387 40.6454 50.3001C40.9015 49.7376 41.1969 49.0329 41.5176 48.2305C42.1596 46.6244 42.9158 44.5955 43.682 42.4653C45.214 38.2057 46.7978 33.5073 47.6052 30.9122L47.6065 30.9082C48.6315 27.5629 49.1732 24.334 49.3025 21.5328C49.4309 18.752 49.1564 16.3166 48.4841 14.599L48.4756 14.5778C47.7646 12.8786 46.4239 11.7488 45.3314 11.0601C44.7781 10.7112 44.2674 10.4621 43.8929 10.2992C43.7051 10.2175 43.55 10.1568 43.4388 10.1156C43.3832 10.095 43.3384 10.0792 43.3059 10.068L43.2666 10.0547L43.2541 10.0506L43.2497 10.0491L43.248 10.0486ZM46.6186 15.3255L46.6144 15.3148L46.6164 15.3202L46.6186 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          d="M11.2985 54.0172C11.3068 54.021 11.3109 54.0223 11.3109 54.0223C11.3109 54.0223 11.2936 54.0172 11.2604 54.0172H11.2985Z"
          fill="white"
        />
        <path
          className={color}
          d="M14.2349 44.012L14.2334 44.012C13.5479 44.0075 13.0984 43.2595 13.4634 42.6501L13.477 42.6274L16.1398 38.907C16.4975 38.3567 17.3176 38.3583 17.666 38.9245L20.2 42.6689L20.212 42.69C20.5623 43.3014 20.109 44.0417 19.4228 44.0377L18.0001 44.0314L17.9975 44.0401L15.255 44.017L14.2349 44.012Z"
          fill="white"
        />
        <path
          className={color}
          d="M16.8309 49.4688C16.1145 49.4688 15.5337 48.888 15.5337 48.1716V43.6857C15.5337 42.9693 16.1145 42.3885 16.8309 42.3885C17.5473 42.3885 18.1281 42.9693 18.1281 43.6857V48.1716C18.1281 48.888 17.5473 49.4688 16.8309 49.4688Z"
          fill="white"
        />
        <path
          className={color}
          d="M32.79 15.4017L32.7901 15.4001C32.7945 14.7146 33.5425 14.2651 34.1519 14.6301L34.1746 14.6437L37.895 17.3065C38.4453 17.6643 38.4437 18.4843 37.8775 18.8328L34.1331 21.3667L34.112 21.3788C33.5006 21.729 32.7603 21.2758 32.7643 20.5895L32.7706 19.1668L32.7619 19.1642L32.785 16.4218L32.79 15.4017Z"
          fill="white"
        />
        <path
          className={color}
          d="M27.3333 17.9976C27.3333 17.2812 27.914 16.7005 28.6304 16.7005H33.1163C33.8327 16.7005 34.4135 17.2812 34.4135 17.9976C34.4135 18.714 33.8327 19.2948 33.1163 19.2948H28.6304C27.914 19.2948 27.3333 18.714 27.3333 17.9976Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-5-passenger-seating': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-5-passenger-seating"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M50.6186 15.3255L50.623 15.336L50.627 15.3471C50.6242 15.3399 50.6214 15.3327 50.6186 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.248 10.0486L47.2466 10.0481C46.9485 9.95276 46.6224 10.0007 46.3653 10.1777C46.1081 10.3548 45.9494 10.6414 45.9364 10.951L45.9362 10.9545L45.9356 10.9691L45.9329 11.0282C45.9305 11.0806 45.9269 11.1587 45.9219 11.2603C45.9118 11.4636 45.8963 11.7609 45.8745 12.135C45.831 12.8834 45.7626 13.9384 45.6631 15.1625C45.4636 17.6169 45.1409 20.7264 44.6485 23.4046C44.5495 23.9432 44.9108 24.4593 45.4555 24.5573C46.0002 24.6552 46.5221 24.2979 46.6211 23.7592C47.1312 20.9848 47.4601 17.7991 47.6616 15.3214C47.7519 14.2101 47.817 13.2363 47.8613 12.499C47.9877 12.5696 48.1192 12.6472 48.2537 12.732C49.162 13.3046 50.1224 14.1526 50.6164 15.3202L50.7393 15.6621L50.627 15.3471C51.1494 16.7041 51.421 18.8164 51.2997 21.4424C51.1785 24.0682 50.6679 27.1335 49.6886 30.3303C49.6871 30.335 49.6855 30.3402 49.6841 30.3449C48.886 32.9084 47.3154 37.5681 45.793 41.8009C45.0304 43.9212 44.283 45.9259 43.6531 47.5016C43.3379 48.29 43.0553 48.9632 42.8172 49.4861C42.5682 50.0331 42.3977 50.3481 42.3097 50.4714C41.064 52.2166 39.6368 54.0172 37.3144 54.0172H15.2985C15.2802 54.0091 15.2418 53.9894 15.1815 53.9457C15.0449 53.8468 14.8668 53.6753 14.6544 53.4149C14.2307 52.8955 13.7742 52.1526 13.3285 51.3133C12.4414 49.6428 11.6828 47.7554 11.394 46.9459L11.3927 46.9424C11.2796 46.6293 11.3266 46.0702 11.736 45.4863C12.1262 44.93 12.7947 44.4409 13.7211 44.2882C14.2672 44.1982 14.6361 43.6874 14.5451 43.1474C14.4541 42.6073 13.9376 42.2424 13.3915 42.3325C11.9119 42.5763 10.776 43.3761 10.0885 44.3563C9.42073 45.3086 9.11677 46.5331 9.50394 47.6075C9.51459 47.6373 9.52579 47.6684 9.53754 47.7007C9.87119 48.6185 10.6438 50.5221 11.5535 52.2352C12.0225 53.1184 12.5498 53.9927 13.094 54.6599C13.3656 54.9928 13.6676 55.3069 13.9967 55.5452C14.3174 55.7776 14.7497 56 15.2604 56H37.3144C40.8063 56 42.7874 53.2403 43.9476 51.6148C44.1604 51.3168 44.4002 50.8387 44.6454 50.3001C44.9015 49.7376 45.1969 49.0329 45.5176 48.2305C46.1596 46.6244 46.9158 44.5955 47.682 42.4653C49.214 38.2057 50.7978 33.5073 51.6052 30.9122L51.6065 30.9082C52.6315 27.5629 53.1732 24.334 53.3025 21.5328C53.4309 18.752 53.1564 16.3166 52.4841 14.599L52.4756 14.5778C51.7646 12.8786 50.4239 11.7488 49.3314 11.0601C48.7781 10.7112 48.2674 10.4621 47.8929 10.2992C47.7051 10.2175 47.55 10.1568 47.4388 10.1156C47.3832 10.095 47.3384 10.0792 47.3059 10.068L47.2666 10.0547L47.2541 10.0506L47.2497 10.0491L47.248 10.0486ZM50.6186 15.3255L50.6144 15.3148L50.6164 15.3202L50.6186 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          d="M15.2985 54.0172C15.3068 54.021 15.3109 54.0223 15.3109 54.0223C15.3109 54.0223 15.2936 54.0172 15.2604 54.0172H15.2985Z"
          fill="white"
        />
        <path
          className={color}
          d="M28.4453 38.864C26.8586 38.864 25.5146 38.4627 24.4133 37.66C23.3119 36.8387 22.5559 35.6813 22.1453 34.188H22.1733C22.6773 35.2147 23.3866 36.0173 24.3013 36.596C25.2346 37.1747 26.2893 37.464 27.4653 37.464C28.9586 37.464 30.1439 37.0253 31.0213 36.148C31.9173 35.252 32.3653 34.0667 32.3653 32.592C32.3653 31.08 31.9453 29.8853 31.1053 29.008C30.2839 28.112 29.1639 27.664 27.7453 27.664C26.9986 27.664 26.2986 27.7667 25.6453 27.972C24.9919 28.1773 24.3853 28.4853 23.8253 28.896V28.868L26.0933 18.9H33.2893C33.9426 18.9 34.4186 18.844 34.7173 18.732C35.0346 18.62 35.3239 18.3773 35.5853 18.004H35.6133L34.4933 20.888H26.0933L24.4133 28.14H24.4413C24.9639 27.636 25.6173 27.244 26.4013 26.964C27.1853 26.6653 28.0439 26.516 28.9773 26.516C30.1346 26.516 31.1613 26.768 32.0573 27.272C32.9533 27.7573 33.6533 28.4573 34.1573 29.372C34.6613 30.268 34.9133 31.3227 34.9133 32.536C34.9133 33.7493 34.6426 34.8413 34.1013 35.812C33.5599 36.764 32.7946 37.5107 31.8053 38.052C30.8346 38.5933 29.7146 38.864 28.4453 38.864Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-7-passenger-seating': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-7-passenger-seating"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M50.6186 15.3255L50.623 15.336L50.627 15.3471C50.6242 15.3399 50.6214 15.3327 50.6186 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.248 10.0486L47.2466 10.0481C46.9485 9.95276 46.6224 10.0007 46.3653 10.1777C46.1081 10.3548 45.9494 10.6414 45.9364 10.951L45.9362 10.9545L45.9356 10.9691L45.9329 11.0282C45.9305 11.0806 45.9269 11.1587 45.9219 11.2603C45.9118 11.4636 45.8963 11.7609 45.8745 12.135C45.831 12.8834 45.7626 13.9384 45.6631 15.1625C45.4636 17.6169 45.1409 20.7264 44.6485 23.4046C44.5495 23.9432 44.9108 24.4593 45.4555 24.5573C46.0002 24.6552 46.5221 24.2979 46.6211 23.7592C47.1312 20.9848 47.4601 17.7991 47.6616 15.3214C47.7519 14.2101 47.817 13.2363 47.8613 12.499C47.9877 12.5696 48.1192 12.6472 48.2537 12.732C49.162 13.3046 50.1224 14.1526 50.6164 15.3202L50.7393 15.6621L50.627 15.3471C51.1494 16.7041 51.421 18.8164 51.2997 21.4424C51.1785 24.0682 50.6679 27.1335 49.6886 30.3303C49.6871 30.335 49.6855 30.3402 49.6841 30.3449C48.886 32.9084 47.3154 37.5681 45.793 41.8009C45.0304 43.9212 44.283 45.9259 43.6531 47.5016C43.3379 48.29 43.0553 48.9632 42.8172 49.4861C42.5682 50.0331 42.3977 50.3481 42.3097 50.4714C41.064 52.2166 39.6368 54.0172 37.3144 54.0172H15.2985C15.2802 54.0091 15.2418 53.9894 15.1815 53.9457C15.0449 53.8468 14.8668 53.6753 14.6544 53.4149C14.2307 52.8955 13.7742 52.1526 13.3285 51.3133C12.4414 49.6428 11.6828 47.7554 11.394 46.9459L11.3927 46.9424C11.2796 46.6293 11.3266 46.0702 11.736 45.4863C12.1262 44.93 12.7947 44.4409 13.7211 44.2882C14.2672 44.1982 14.6361 43.6874 14.5451 43.1474C14.4541 42.6073 13.9376 42.2424 13.3915 42.3325C11.9119 42.5763 10.776 43.3761 10.0885 44.3563C9.42073 45.3086 9.11677 46.5331 9.50394 47.6075C9.51459 47.6373 9.52579 47.6684 9.53754 47.7007C9.87119 48.6185 10.6438 50.5221 11.5535 52.2352C12.0225 53.1184 12.5498 53.9927 13.094 54.6599C13.3656 54.9928 13.6676 55.3069 13.9967 55.5452C14.3174 55.7776 14.7497 56 15.2604 56H37.3144C40.8063 56 42.7874 53.2403 43.9476 51.6148C44.1604 51.3168 44.4002 50.8387 44.6454 50.3001C44.9015 49.7376 45.1969 49.0329 45.5176 48.2305C46.1596 46.6244 46.9158 44.5955 47.682 42.4653C49.214 38.2057 50.7978 33.5073 51.6052 30.9122L51.6065 30.9082C52.6315 27.5629 53.1732 24.334 53.3025 21.5328C53.4309 18.752 53.1564 16.3166 52.4841 14.599L52.4756 14.5778C51.7646 12.8786 50.4239 11.7488 49.3314 11.0601C48.7781 10.7112 48.2674 10.4621 47.8929 10.2992C47.7051 10.2175 47.55 10.1568 47.4388 10.1156C47.3832 10.095 47.3384 10.0792 47.3059 10.068L47.2666 10.0547L47.2541 10.0506L47.2497 10.0491L47.248 10.0486ZM50.6186 15.3255L50.6144 15.3148L50.6164 15.3202L50.6186 15.3255Z"
          fill="white"
        />
        <path
          className={color}
          d="M15.2985 54.0172C15.3068 54.021 15.3109 54.0223 15.3109 54.0223C15.3109 54.0223 15.2936 54.0172 15.2604 54.0172H15.2985Z"
          fill="white"
        />
        <path
          className={color}
          d="M35.3453 20.916V20.888H28.2053C27.2159 20.888 26.4226 21.084 25.8253 21.476C25.2466 21.868 24.7146 22.5773 24.2293 23.604H24.2013L25.4053 18.9H36.3253V18.928L29.4933 38.5H26.9453L35.3453 20.916Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-dynamic-handling-package': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-dynamic-handling-package"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M46.2221 38.1415C46.2221 29.7055 39.4876 22.8663 31.1807 22.8663C22.8738 22.8663 16.1393 29.7055 16.1393 38.1415C16.1393 46.5775 22.8738 53.4167 31.1807 53.4167C39.4876 53.4167 46.2221 46.5775 46.2221 38.1415ZM47.5681 38.1415C47.5681 47.333 40.2315 54.7837 31.1807 54.7837C22.1299 54.7837 14.7932 47.333 14.7932 38.1415C14.7932 28.95 22.1299 21.4993 31.1807 21.4993C40.2315 21.4993 47.5681 28.95 47.5681 38.1415Z"
          fill="white"
        />
        <path
          className={color}
          d="M51.8344 38.1415C51.8344 26.5577 42.5871 17.1667 31.1807 17.1667C19.7742 17.1667 10.527 26.5577 10.527 38.1415C10.527 38.5192 10.2259 38.825 9.85392 38.825C9.48197 38.825 9.18088 38.5192 9.18088 38.1415C9.18088 25.8022 19.0303 15.7997 31.1807 15.7997C43.3311 15.7997 53.1804 25.8022 53.1804 38.1415C53.1804 38.5192 52.8794 38.825 52.5074 38.825C52.1355 38.825 51.8344 38.5192 51.8344 38.1415Z"
          fill="white"
        />
        <path
          className={color}
          d="M34.548 38.1415C34.548 40.0301 33.0404 41.5612 31.1807 41.5612C29.3209 41.5612 27.8133 40.0301 27.8133 38.1415C27.8133 36.2528 29.3209 34.7218 31.1807 34.7218C33.0404 34.7218 34.548 36.2528 34.548 38.1415Z"
          fill="white"
        />
        <path
          className={color}
          d="M30.6172 37.0971L31.6694 38.2824L20.1095 48.8508L19.0572 47.6655L30.6172 37.0971Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.686 37.2532L30.6753 39.0298L17.2058 31.1306L18.2165 29.354L31.686 37.2532Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.4741 38.9189L29.9454 38.5527L33.7831 21.9999L35.3129 22.3657L31.4741 38.9189Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.3276 38.9735L31.131 37.3902L46.5644 35.4262L46.761 37.0096L31.3276 38.9735Z"
          fill="white"
        />
        <path
          className={color}
          d="M30.2994 38.4626L31.7346 37.8126L38.0597 52.2434L36.6245 52.8935L30.2994 38.4626Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.5731 37.4502L30.7882 38.8328L17.3187 30.9336L18.1036 29.551L31.5731 37.4502Z"
          fill="white"
        />
        <path
          className={color}
          d="M22.1268 26.1728C21.4917 27.3156 22.8357 31.8687 23.3229 32.4387C24.8455 34.2197 17.3771 29.7199 17.3771 29.7199C17.3771 29.7199 22.7619 25.03 22.1268 26.1728Z"
          fill="white"
        />
        <path
          className={color}
          d="M39.5098 25.2484C38.2372 25.0211 34.4577 27.8249 34.0909 28.4814C32.9446 30.5327 34.634 21.8823 34.634 21.8823C34.634 21.8823 40.7824 25.4757 39.5098 25.2484Z"
          fill="white"
        />
        <path
          className={color}
          d="M45.7731 42.6971C45.6059 41.3959 41.2571 38.1234 40.5305 37.9644C38.2601 37.4675 46.8934 36.5161 46.8934 36.5161C46.8934 36.5161 45.9403 43.9983 45.7731 42.6971Z"
          fill="white"
        />
        <path
          className={color}
          d="M31.4158 53.2172C32.5911 52.6717 34.1391 48.186 34.0748 47.434C33.8738 45.0842 37.3114 53.1828 37.3114 53.1828C37.3114 53.1828 30.2406 53.7626 31.4158 53.2172Z"
          fill="white"
        />
        <path
          className={color}
          d="M17.1391 42.7286C18.013 43.6952 22.6923 43.8041 23.3767 43.5097C25.5151 42.5895 18.9932 48.4122 18.9932 48.4122C18.9932 48.4122 16.2651 41.7621 17.1391 42.7286Z"
          fill="white"
        />
        <path
          className={color}
          d="M47.7048 15.8129L47.7034 15.8129C47.0878 15.8088 46.6842 15.1267 47.0119 14.571L47.0242 14.5503L49.4153 11.1575C49.7365 10.6557 50.4729 10.6572 50.7858 11.1735L53.0612 14.5882L53.072 14.6073C53.3865 15.1649 52.9795 15.84 52.3633 15.8364L51.0858 15.8307L51.0834 15.8386L48.6208 15.8175L47.7048 15.8129Z"
          fill="white"
        />
        <path
          className={color}
          d="M50.0359 20.7891C49.3926 20.7891 48.871 20.2595 48.871 19.6062V15.5154C48.871 14.8621 49.3926 14.3325 50.0359 14.3325C50.6792 14.3325 51.2007 14.8621 51.2007 15.5154L51.2007 19.6062C51.2007 20.2595 50.6792 20.7891 50.0359 20.7891Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-power-package': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-power-package"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M37.7368 36.5128C38.2592 36.433 38.6197 35.9546 38.537 35.4411C38.4544 34.9282 37.9617 34.5809 37.4398 34.6607C31.1605 35.6199 19.2007 35.622 12.1929 34.6585C11.6698 34.5866 11.1825 34.9412 11.108 35.4554C11.0334 35.9701 11.4014 36.4429 11.925 36.5149C19.1001 37.5014 31.2514 37.5035 37.7368 36.5128Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.96247 48.2111L5.94721 48.175C5.71562 47.6283 5.58402 47.045 5.55833 46.4545C5.26674 39.7516 5.23874 39.7931 5.59128 34.5454C5.67301 33.3288 5.99016 32.2458 6.60275 31.3459C7.1459 30.548 7.89068 29.9396 8.81011 29.5134L11.7662 22.4035C12.3395 21.0247 13.6776 20.0872 15.2032 20.0021C22.6651 19.5856 26.5758 19.5926 34.0291 20.0024C35.5716 20.0873 36.9223 21.0427 37.4865 22.4432L40.3238 29.4852C41.3976 29.9095 42.1814 30.5326 42.7058 31.38C43.2782 32.3049 43.4793 33.4 43.5497 34.5509C43.9075 40.3976 43.8535 40.484 43.6162 45.7255L43.5925 46.2479C43.5585 47.0009 43.3529 47.7418 42.9891 48.4093L42.736 48.8736C42.3084 49.6581 41.4717 50.1475 40.5617 50.1475H37.0717C36.3971 50.1475 35.7843 49.7608 35.5088 49.1585L34.8005 47.6099C34.5934 47.1571 34.1313 46.864 33.6198 46.864H14.9701C14.767 46.864 14.582 46.9741 14.4894 47.1476L13.3675 49.2493C13.0725 49.8019 12.4869 50.1475 11.8496 50.1475H8.93239C7.63238 50.1475 6.45922 49.3838 5.96247 48.2111ZM15.2984 21.6254C22.6956 21.2125 26.5431 21.2193 33.9351 21.6258C34.8257 21.6748 35.6077 22.2272 35.9342 23.0377L39.0499 30.7707L39.3638 30.8726C40.3634 31.1971 40.9286 31.6557 41.2778 32.22C41.6423 32.809 41.8202 33.5902 41.8849 34.6476C42.2377 40.4129 42.1858 40.4461 41.951 45.6319L41.9264 46.1763C41.9032 46.6893 41.7628 47.1937 41.5164 47.6459L41.2633 48.1102C41.1255 48.3631 40.8555 48.5212 40.5616 48.5212H37.0716C37.0543 48.5212 37.0387 48.5113 37.0317 48.496L36.3235 46.9474C35.8479 45.9076 34.7885 45.2377 33.6197 45.2377H14.97C14.1458 45.2377 13.3901 45.6845 13.01 46.3967L11.8881 48.4983C11.8806 48.5123 11.8657 48.5212 11.8494 48.5212H8.93226C8.30641 48.5212 7.74236 48.1535 7.50371 47.5901L7.48844 47.5541C7.33133 47.1832 7.24182 46.7867 7.22437 46.3855C6.93415 39.7142 6.90808 39.8192 7.25525 34.6516C7.32304 33.6425 7.57853 32.8525 7.99203 32.2451C8.40164 31.6434 8.99488 31.1784 9.81561 30.8587L10.0954 30.7497L13.3116 23.0143C13.6434 22.2162 14.418 21.6745 15.2984 21.6254Z"
          fill="white"
        />
        <path
          className={color}
          d="M43.2402 37.2485C45.8399 37.2485 47.8941 39.4149 47.709 41.9612L47.6339 42.991C47.554 44.0912 48.4411 45.0265 49.5643 45.0267C50.6333 45.0267 51.5001 44.1763 51.5004 43.1266V30.092H53.085V43.1266C53.0847 45.0355 51.5083 46.5828 49.5643 46.5828C47.5218 46.5826 45.9084 44.881 46.0537 42.8803L46.1288 41.8505C46.2485 40.2046 44.9206 38.8046 43.2402 38.8046V37.2485Z"
          fill="white"
        />
        <path
          className={color}
          d="M44.7998 24.7014L44.646 24.7445C44.3031 24.8774 44.0907 25.2325 44.1572 25.6028C44.2237 25.9731 44.5471 26.2352 44.9155 26.2449L45.0751 26.2338L46.3984 26.0045C46.8292 25.9299 47.117 25.5262 47.041 25.1031C46.965 24.6801 46.5539 24.3975 46.1231 24.4721L44.7998 24.7014Z"
          fill="white"
        />
        <path
          className={color}
          d="M45.2 20.0565L45.0444 20.0201C44.6792 19.9709 44.3169 20.1781 44.19 20.5329C44.0632 20.8877 44.2142 21.2718 44.5305 21.4576L44.6752 21.5247L45.943 21.9618C46.3558 22.1041 46.8082 21.8907 46.9531 21.4854C47.098 21.08 46.8807 20.6358 46.4679 20.4935L45.2 20.0565Z"
          fill="white"
        />
        <path
          className={color}
          d="M47.7134 16.8637L47.5813 16.775C47.2583 16.6007 46.8444 16.6666 46.5966 16.9533C46.3488 17.2399 46.3496 17.6517 46.5772 17.9364L46.6878 18.05L47.7121 18.9039C48.0456 19.182 48.5458 19.1419 48.8289 18.8144C49.112 18.4869 49.0712 17.9957 48.7377 17.7177L47.7134 16.8637Z"
          fill="white"
        />
        <path
          className={color}
          d="M59.6785 24.7203L59.8323 24.7634C60.1752 24.8963 60.3876 25.2514 60.3211 25.6217C60.2546 25.992 59.9312 26.2541 59.5628 26.2638L59.4032 26.2527L58.0799 26.0234C57.6491 25.9488 57.3613 25.5451 57.4373 25.122C57.5133 24.699 57.9244 24.4164 58.3552 24.491L59.6785 24.7203Z"
          fill="white"
        />
        <path
          className={color}
          d="M59.2782 20.0754L59.4339 20.039C59.799 19.9898 60.1614 20.197 60.2882 20.5518C60.4151 20.9066 60.2641 21.2907 59.9478 21.4765L59.8031 21.5436L58.5352 21.9807C58.1225 22.123 57.6701 21.9096 57.5252 21.5043C57.3803 21.0989 57.5976 20.6547 58.0104 20.5124L59.2782 20.0754Z"
          fill="white"
        />
        <path
          className={color}
          d="M56.7649 16.8826L56.8969 16.7939C57.2199 16.6196 57.6338 16.6856 57.8817 16.9722C58.1295 17.2588 58.1286 17.6706 57.901 17.9553L57.7905 18.0689L56.7661 18.9229C56.4326 19.2009 55.9325 19.1608 55.6493 18.8333C55.3662 18.5058 55.4071 18.0147 55.7406 17.7366L56.7649 16.8826Z"
          fill="white"
        />
        <path
          className={color}
          d="M52.9413 15.908L52.9211 15.7521C52.8393 15.3992 52.5142 15.1392 52.1313 15.1477C51.7485 15.1561 51.4356 15.4302 51.3701 15.7864L51.3571 15.943L51.3873 17.2622C51.3971 17.6917 51.7599 18.0322 52.1972 18.0225C52.6346 18.0129 52.9813 17.6567 52.9715 17.2272L52.9413 15.908Z"
          fill="white"
        />
        <path
          className={color}
          d="M54.6685 23.5819C54.6685 22.2931 53.605 21.2488 52.2927 21.2488C50.9803 21.2488 49.9168 22.2931 49.9168 23.5819C49.9168 24.3091 50.2438 25.4154 50.834 26.3381C51.4692 27.3311 52.0454 27.5817 52.2927 27.5817V29.1377C50.1054 29.1377 48.3322 25.7298 48.3322 23.5819C48.3322 21.434 50.1054 19.6928 52.2927 19.6928C54.4799 19.6928 56.2531 21.434 56.2531 23.5819C56.2531 25.7298 54.4799 29.1377 52.2927 29.1377V27.5817C52.54 27.5817 53.1161 27.3311 53.7513 26.3381C54.3415 25.4154 54.6685 24.3091 54.6685 23.5819Z"
          fill="white"
        />
        <path
          className={color}
          d="M50.9346 27.8043H53.6503V29.36C53.6503 29.9737 53.1437 30.4712 52.5188 30.4712H52.0661C51.4412 30.4712 50.9346 29.9737 50.9346 29.36V27.8043Z"
          fill="white"
        />
      </svg>
    ),
    'gravity-trailer-towing-package': (color, size, testId) => (
      <svg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="gravity-trailer-towing-package"
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 65 65"
        fill="none"
      >
        <path
          className={color}
          d="M40.4296 13.8054C42.2912 13.8054 44.0112 14.769 44.942 16.3336L53.6439 29.8595L53.77 30.0882C54.046 30.6314 54.1903 31.2302 54.1904 31.8381V42.9378H58.3388L58.476 42.9507C58.7857 43.0122 59.0181 43.2783 59.0181 43.5969C59.0181 43.9156 58.7857 44.1817 58.476 44.2432L58.3388 44.2561H45.8757C45.8764 44.2197 45.8779 44.1832 45.8779 44.1466C45.8779 43.7327 45.8357 43.3283 45.754 42.9378H52.8308V31.8381C52.8307 31.4331 52.7346 31.0342 52.5509 30.6722L52.4668 30.5187L43.765 16.9928C43.0769 15.8365 41.8055 15.1237 40.4296 15.1237H16.9912C14.2384 15.1237 12.0064 17.2898 12.0064 19.9612V38.1003C12.0064 40.7717 14.2384 42.9378 16.9912 42.9378H33.5409C33.4592 43.3283 33.417 43.7327 33.417 44.1466C33.417 44.1832 33.4185 44.2197 33.4192 44.2561H16.9912C13.4877 44.2561 10.6479 41.5003 10.6479 38.1003V19.9612C10.6479 16.5612 13.4877 13.8054 16.9912 13.8054H40.4296Z"
          fill="white"
        />
        <path
          className={color}
          d="M44.7451 44.1488C44.7451 41.4166 42.4628 39.2017 39.6475 39.2017C36.8321 39.2017 34.5498 41.4166 34.5498 44.1488C34.5498 46.8809 36.8321 49.0958 39.6475 49.0958V50.1951C36.2065 50.1951 33.417 47.4881 33.417 44.1488C33.417 40.8095 36.2065 38.1024 39.6475 38.1024C43.0884 38.1024 45.8779 40.8095 45.8779 44.1488C45.8779 47.4881 43.0884 50.1951 39.6475 50.1951V49.0958C42.4628 49.0958 44.7451 46.8809 44.7451 44.1488Z"
          fill="white"
        />
        <path
          className={color}
          d="M39.6475 24.3586C39.6475 22.78 40.9657 21.5007 42.5923 21.5007H48.2564V22.8191H42.5923C41.7164 22.8191 41.0059 23.5086 41.0059 24.3586C41.0059 25.2086 41.7164 25.8981 42.5923 25.8981H50.522V27.2164H42.5923C40.9657 27.2164 39.6475 25.9371 39.6475 24.3586Z"
          fill="white"
        />
        <path
          className={color}
          d="M29.3393 28.2084C29.3393 26.7512 28.1216 25.5696 26.6201 25.5696H22.6553C21.1538 25.5696 19.9361 26.7512 19.9361 28.2084V43.5991H18.5776V28.2084C18.5776 26.0227 20.403 24.2512 22.6553 24.2512H26.6201C28.8724 24.2512 30.6978 26.0227 30.6978 28.2084V43.5991H29.3393V28.2084Z"
          fill="white"
        />
        <path
          className={color}
          d="M53.8695 31.6278C53.8407 31.1428 53.7122 30.6683 53.4922 30.2322L53.3766 30.0211L50.8372 26.0727V27.4087L52.7338 30.3574L52.7399 30.3658L52.7449 30.3753L52.8284 30.5292L52.8334 30.5376L52.9059 30.6902C53.0638 31.0521 53.1455 31.4424 53.1456 31.8378V43.2427H46.1269C46.161 43.4752 46.1798 43.7117 46.1872 43.9512H58.3204L58.42 43.9417C58.5821 43.906 58.7039 43.7656 58.7039 43.5969C58.7039 43.4282 58.5822 43.2866 58.42 43.251L58.3204 43.2427H53.8757V31.8378L53.8695 31.6278ZM44.4307 44.1492C44.4307 41.5859 42.2893 39.5069 39.6479 39.5066C37.0064 39.5066 34.864 41.5857 34.864 44.1492C34.8642 46.7125 37.0065 48.7906 39.6479 48.7906C42.2891 48.7904 44.4304 46.7124 44.4307 44.1492ZM29.6535 43.294H30.3836V43.2427H29.6535V43.294ZM18.892 43.294H19.6209V43.2427H18.892V43.294ZM50.2078 26.4306V26.2039H50.0616L50.2078 26.4306ZM48.5706 23.124H48.0801L49.6694 25.5932H50.5286L48.5706 22.5502V23.124ZM47.688 22.5132H47.9412V21.8059H47.232L47.688 22.5132ZM45.06 44.1492C45.0598 46.9471 42.8049 49.2322 39.9626 49.3906V49.8809C42.9826 49.727 45.4024 47.376 45.5554 44.4439L45.5628 44.1492L45.5554 43.8534C45.397 40.8202 42.8129 38.4083 39.6479 38.408C36.3807 38.408 33.7319 40.9786 33.7319 44.1492L33.7393 44.4439C33.8923 47.3764 36.3128 49.7275 39.3333 49.8809V49.3906C36.4906 49.2327 34.2349 46.9475 34.2346 44.1492C34.2346 41.2484 36.6588 38.8959 39.6479 38.8959C42.6369 38.8962 45.06 41.2486 45.06 44.1492ZM29.0119 27.9693C28.8884 26.7931 27.8644 25.8747 26.6199 25.8747H22.6558C21.3282 25.8747 20.2505 26.9196 20.2503 28.2079V42.6319H29.0242V28.2079L29.0119 27.9693ZM29.6535 42.6319H30.3836V28.2079C30.3834 26.1911 28.6982 24.5566 26.6199 24.5566H22.6558C20.5774 24.5566 18.8923 26.1911 18.892 28.2079V42.6319H19.6209V28.2079C19.6212 26.5823 20.9806 25.2639 22.6558 25.2639H26.6199C28.295 25.2639 29.6532 26.5823 29.6535 28.2079V42.6319ZM10.3419 19.6289C10.5201 16.2147 13.4292 13.5 16.9917 13.5H40.4297C42.4036 13.5 44.2278 14.5215 45.2149 16.1803L48.4403 21.1951H48.5706V21.3967L53.9113 29.6978L53.9163 29.7061L53.9212 29.7157L54.0478 29.9447L54.0527 29.9531L54.1572 30.1749C54.3861 30.6993 54.505 31.2648 54.505 31.8378V42.6319H58.3536L58.3696 42.6343L58.506 42.6462L58.5232 42.6486L58.5392 42.651C58.9927 42.7412 59.3333 43.1307 59.3333 43.5969C59.3333 44.0632 58.9927 44.4527 58.5392 44.5429L58.5232 44.5453L58.506 44.5476L58.3696 44.5596L58.3536 44.562H46.1773C45.9579 47.8771 43.1194 50.4998 39.6479 50.5C36.1762 50.5 33.3367 47.8773 33.1173 44.562H16.9917C13.4294 44.562 10.5203 41.8471 10.3419 38.4331L10.3333 38.1003V19.9617L10.3419 19.6289ZM39.9626 24.3586C39.9626 25.7683 41.1392 26.911 42.5918 26.9113H49.7752L49.3204 26.2039H42.5918C41.5424 26.2037 40.6915 25.3771 40.6915 24.3586C40.6915 23.3401 41.5424 22.5135 42.5918 22.5132H46.9456L46.4908 21.8059H42.5918C41.1392 21.8061 39.9626 22.9488 39.9626 24.3586ZM41.3209 24.3586C41.3209 25.0398 41.89 25.5929 42.5918 25.5932H48.927L47.3377 23.124H42.5918C41.89 23.1242 41.3209 23.6774 41.3209 24.3586ZM10.9626 38.1003L10.97 38.4009C11.1312 41.4925 13.7658 43.9512 16.9917 43.9512H33.1075C33.1094 43.8898 33.1112 43.8285 33.1149 43.7675C33.1254 43.5946 33.1432 43.4236 33.1677 43.2546C33.1683 43.2506 33.1684 43.2466 33.1689 43.2427H31.013V43.9047H29.0242V43.2427H20.2503V43.9047H18.2627V43.2427H16.9917C14.1567 43.2427 11.8409 41.0821 11.6989 38.3651L11.6915 38.1003V19.9617C11.6915 17.1216 14.0651 14.8181 16.9917 14.8181H40.4297C41.9147 14.8181 43.2871 15.586 44.0324 16.8316L46.8399 21.1951H47.6991L44.6753 16.4953L44.6691 16.4869C43.7945 15.0168 42.1789 14.1108 40.4297 14.1107H16.9917C13.6619 14.1107 10.9626 16.7303 10.9626 19.9617V38.1003ZM12.3208 38.1003L12.327 38.3329C12.4518 40.7276 14.4931 42.6319 16.9917 42.6319H18.2627V28.2079C18.263 25.8538 20.2299 23.9458 22.6558 23.9458H26.6199C29.0458 23.9458 31.0127 25.8538 31.013 28.2079V42.6319H33.2906C33.9915 39.8564 36.5719 37.7973 39.6479 37.7973C42.7238 37.7975 45.3032 39.8566 46.004 42.6319H52.5162V31.8378C52.5161 31.4828 52.4325 31.1332 52.2728 30.8155L52.1954 30.6724L50.1685 27.522H42.5918C40.7916 27.5218 39.3333 26.1056 39.3333 24.3586C39.3333 22.6115 40.7916 21.1954 42.5918 21.1951H46.0975L43.4977 17.1549L43.4928 17.1454C42.861 16.0835 41.6931 15.4289 40.4297 15.4288H16.9917C14.4127 15.4288 12.3208 17.4589 12.3208 19.9617V38.1003Z"
          fill="white"
        />
      </svg>
    ),
  },
  social: {
    instagram: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="instagram"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0025 3.69423C14.7094 3.69423 15.0299 3.7061 16.0945 3.75359C17.0838 3.79712 17.6181 3.96333 17.9742 4.10184C18.4452 4.28388 18.7855 4.5055 19.1377 4.8577C19.4939 5.21387 19.7115 5.55025 19.8936 6.02118C20.0321 6.37734 20.1983 6.91555 20.2418 7.90094C20.2893 8.96943 20.3012 9.28998 20.3012 11.9929C20.3012 14.6997 20.2893 15.0203 20.2418 16.0848C20.1983 17.0742 20.0321 17.6084 19.8936 17.9646C19.7115 18.4355 19.4899 18.7758 19.1377 19.1281C18.7815 19.4842 18.4452 19.7019 17.9742 19.8839C17.6181 20.0224 17.0799 20.1886 16.0945 20.2322C15.026 20.2797 14.7054 20.2915 12.0025 20.2915C9.29566 20.2915 8.97511 20.2797 7.91057 20.2322C6.92122 20.1886 6.38697 20.0224 6.03081 19.8839C5.55988 19.7019 5.21954 19.4803 4.86733 19.1281C4.51117 18.7719 4.29351 18.4355 4.11147 17.9646C3.97296 17.6084 3.80675 17.0702 3.76322 16.0848C3.71573 15.0163 3.70386 14.6958 3.70386 11.9929C3.70386 9.28602 3.71573 8.96548 3.76322 7.90094C3.80675 6.91159 3.97296 6.37734 4.11147 6.02118C4.29351 5.55025 4.51512 5.20991 4.86733 4.8577C5.2235 4.50154 5.55988 4.28388 6.03081 4.10184C6.38697 3.96333 6.92518 3.79712 7.91057 3.75359C8.97511 3.7061 9.29566 3.69423 12.0025 3.69423ZM12.0025 1.86987C9.25213 1.86987 8.90783 1.88175 7.82746 1.92923C6.75105 1.97672 6.01102 2.15085 5.36992 2.40016C4.70112 2.66135 4.13521 3.00564 3.57326 3.57155C3.00735 4.1335 2.66306 4.69941 2.40187 5.36425C2.15256 6.0093 1.97843 6.74538 1.93094 7.82179C1.88345 8.90611 1.87158 9.25041 1.87158 12.0008C1.87158 14.7512 1.88345 15.0955 1.93094 16.1758C1.97843 17.2523 2.15256 17.9923 2.40187 18.6334C2.66306 19.3022 3.00735 19.8681 3.57326 20.43C4.13521 20.992 4.70112 21.3402 5.36596 21.5975C6.01102 21.8468 6.74709 22.0209 7.82351 22.0684C8.90388 22.1159 9.24817 22.1278 11.9986 22.1278C14.749 22.1278 15.0932 22.1159 16.1736 22.0684C17.25 22.0209 17.9901 21.8468 18.6312 21.5975C19.296 21.3402 19.8619 20.992 20.4239 20.43C20.9858 19.8681 21.3341 19.3022 21.5913 18.6373C21.8406 17.9923 22.0147 17.2562 22.0622 16.1798C22.1097 15.0994 22.1216 14.7551 22.1216 12.0048C22.1216 9.25437 22.1097 8.91007 22.0622 7.8297C22.0147 6.75329 21.8406 6.01326 21.5913 5.37216C21.342 4.69941 20.9977 4.1335 20.4318 3.57155C19.8698 3.0096 19.3039 2.66135 18.6391 2.40412C17.994 2.15481 17.2579 1.98068 16.1815 1.93319C15.0972 1.88175 14.7529 1.86987 12.0025 1.86987ZM12.0025 6.79676C9.12939 6.79676 6.79848 9.12767 6.79848 12.0007C6.79848 14.8738 9.12939 17.2047 12.0025 17.2047C14.8755 17.2047 17.2064 14.8738 17.2064 12.0007C17.2064 9.12767 14.8755 6.79676 12.0025 6.79676ZM12.0025 15.3764C10.1385 15.3764 8.6268 13.8647 8.6268 12.0007C8.6268 10.1368 10.1385 8.62508 12.0025 8.62508C13.8664 8.62508 15.3781 10.1368 15.3781 12.0007C15.3781 13.8647 13.8664 15.3764 12.0025 15.3764ZM17.4122 7.80581C18.081 7.80581 18.6271 7.26364 18.6271 6.59089C18.6271 5.92209 18.081 5.37596 17.4122 5.37596C16.7434 5.37596 16.1973 5.91813 16.1973 6.59089C16.1973 7.25968 16.7395 7.80581 17.4122 7.80581Z"
          fill="black"
        />
      </svg>
    ),
    threads: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="threads"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          className={color}
          d="M12.1538 22.2297H12.1476C9.07032 22.2091 6.70464 21.1944 5.11446 19.2144C3.70165 17.4509 2.97153 14.9986 2.94678 11.9255V11.911C2.97153 8.83586 3.70165 6.38561 5.11652 4.62217C6.70464 2.64011 9.07239 1.62536 12.1476 1.60474H12.1538H12.1599C14.5194 1.62124 16.4932 2.22761 18.0257 3.40736C19.4674 4.51699 20.4821 6.09686 21.041 8.10574L19.2879 8.59455C18.3392 5.19142 15.9384 3.45274 12.1517 3.42592C9.65195 3.44449 7.76064 4.2303 6.53139 5.76067C5.38258 7.19411 4.78859 9.26486 4.7659 11.9172C4.78859 14.5696 5.38258 16.6404 6.53346 18.0738C7.7627 19.6062 9.65401 20.392 12.1538 20.4086C14.4081 20.392 15.8992 19.8661 17.1388 18.6513C18.5537 17.2653 18.5289 15.5637 18.0752 14.5284C17.8091 13.9179 17.3244 13.4105 16.6706 13.0248C16.5056 14.186 16.1364 15.1265 15.5672 15.836C14.8061 16.7827 13.7274 17.3004 12.3621 17.3746C11.3288 17.4303 10.3326 17.1869 9.5612 16.6857C8.64751 16.0938 8.11333 15.1904 8.05558 14.1385C7.99989 13.1156 8.4062 12.175 9.1982 11.4903C9.95513 10.8365 11.0194 10.4529 12.2775 10.3807C13.2036 10.3291 14.0719 10.3704 14.8721 10.5024C14.7649 9.86505 14.5504 9.35767 14.2286 8.99261C13.7872 8.48936 13.1046 8.23361 12.2012 8.22742C12.1929 8.22742 12.1847 8.22742 12.1764 8.22742C11.4504 8.22742 10.4646 8.42749 9.83757 9.3618L8.32783 8.34911C9.16932 7.09924 10.5347 6.41036 12.1764 6.41036C12.1888 6.41036 12.2012 6.41036 12.2136 6.41036C14.9587 6.42686 16.5943 8.1078 16.7572 11.0407C16.8501 11.0799 16.9429 11.1211 17.0336 11.1624C18.3144 11.7646 19.2508 12.6762 19.7437 13.8003C20.4285 15.3657 20.4924 17.917 18.4134 19.9527C16.8232 21.5079 14.8948 22.2112 12.1599 22.2297H12.1538ZM13.0159 12.1833C12.8076 12.1833 12.5972 12.1895 12.3806 12.2019C10.8028 12.2905 9.81901 13.0145 9.8747 14.0437C9.93245 15.1224 11.1225 15.6235 12.2672 15.5617C13.3191 15.506 14.6886 15.0955 14.9196 12.373C14.3379 12.2472 13.7006 12.1833 13.0159 12.1833Z"
          fill="#0F0F0F"
        />
      </svg>
    ),
    linkedin: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="linkedin"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          className={color}
          d="M20.626 1.875H3.37002C2.54341 1.875 1.875 2.52759 1.875 3.33442V20.6616C1.875 21.4685 2.54341 22.125 3.37002 22.125H20.626C21.4526 22.125 22.125 21.4685 22.125 20.6656V3.33442C22.125 2.52759 21.4526 1.875 20.626 1.875ZM7.88276 19.131H4.8769V9.46479H7.88276V19.131ZM6.37983 8.14775C5.4148 8.14775 4.63564 7.3686 4.63564 6.40752C4.63564 5.44644 5.4148 4.66728 6.37983 4.66728C7.34092 4.66728 8.12007 5.44644 8.12007 6.40752C8.12007 7.36465 7.34092 8.14775 6.37983 8.14775ZM19.131 19.131H16.1291V14.4324C16.1291 13.3131 16.1093 11.8695 14.5668 11.8695C13.0046 11.8695 12.7673 13.0916 12.7673 14.3533V19.131H9.76934V9.46479H12.6486V10.7858H12.6882C13.0876 10.0264 14.0685 9.22354 15.5279 9.22354C18.5694 9.22354 19.131 11.2248 19.131 13.8272V19.131Z"
          fill="#0F0F0F"
        />
      </svg>
    ),
    x: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="x"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          className={color}
          d="M17.8231 2.77148H20.9282L14.1444 10.525L22.125 21.0757H15.8763L10.982 14.6767L5.38188 21.0757H2.27487L9.53082 12.7825L1.875 2.77148H8.28238L12.7064 8.62038L17.8231 2.77148ZM16.7333 19.2171H18.4538L7.34747 4.53244H5.5011L16.7333 19.2171Z"
          fill="#0F0F0F"
        />
      </svg>
    ),
    youtube: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="youtube"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          className={color}
          d="M23.0259 7.50099C23.0259 7.50099 22.8062 5.94972 22.1294 5.26856C21.2725 4.37207 20.3145 4.36768 19.875 4.31494C16.7285 4.08643 12.0044 4.08643 12.0044 4.08643H11.9956C11.9956 4.08643 7.27148 4.08643 4.125 4.31494C3.68555 4.36768 2.72754 4.37207 1.87061 5.26856C1.19385 5.94972 0.978516 7.50099 0.978516 7.50099C0.978516 7.50099 0.75 9.32473 0.75 11.1441V12.8492C0.75 14.6685 0.974121 16.4922 0.974121 16.4922C0.974121 16.4922 1.19385 18.0435 1.86621 18.7247C2.72314 19.6212 3.84814 19.5904 4.34912 19.6871C6.15088 19.8585 12 19.9112 12 19.9112C12 19.9112 16.7285 19.9024 19.875 19.6783C20.3145 19.6256 21.2725 19.6212 22.1294 18.7247C22.8062 18.0435 23.0259 16.4922 23.0259 16.4922C23.0259 16.4922 23.25 14.6729 23.25 12.8492V11.1441C23.25 9.32473 23.0259 7.50099 23.0259 7.50099ZM9.67529 14.919V8.59523L15.7529 11.7681L9.67529 14.919Z"
          fill="#0F0F0F"
        />
      </svg>
    ),
    facebook: (color, size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="facebook"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          className={color}
          d="M11.9998 1.89038C6.40807 1.89038 1.875 6.42345 1.875 12.0152C1.875 16.7633 5.14409 20.7476 9.55405 21.8419V15.1093H7.46632V12.0152H9.55405V10.6819C9.55405 7.23586 11.1137 5.63858 14.497 5.63858C15.1385 5.63858 16.2453 5.76453 16.6981 5.89008V8.69464C16.4592 8.66953 16.044 8.65698 15.5285 8.65698C13.8684 8.65698 13.2269 9.28593 13.2269 10.9209V12.0152H16.5341L15.9659 15.1093H13.2269V22.0658C18.2403 21.4604 22.125 17.1918 22.125 12.0152C22.1246 6.42345 17.5915 1.89038 11.9998 1.89038Z"
          fill="#0F0F0F"
        />
      </svg>
    ),
  },
  brand: {
    logo: (color, _size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="brand-lucid"
        width={140}
        height={8}
        viewBox="0 0 400 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M71.2574 22.0428C69.5663 22.1166 13.2359 22.0537 11.536 22.0537C4.93578 22.0537 0 17.3682 0 12.3484V0.873549H8.70798V12.0618C8.70798 15.5618 11.3432 18.1759 15.04 18.1759H71.2574V22.0428Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M170.097 22.0498C168.406 22.1236 108.239 22.0498 106.539 22.0498C99.9387 22.0498 95.0029 17.3643 95.0029 12.3445V0.869629H103.713V12.0579C103.713 15.5557 106.344 18.172 110.041 18.172H161.387V0.869629H170.097V22.0498Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M268.332 22.0563C266.641 22.1302 207.104 22.0672 205.401 22.0672C189.991 22.0672 189.991 0.884889 205.401 0.884889C207.104 0.884889 266.641 0.821924 268.332 0.895745V4.76267H209.047C200.563 4.76267 200.563 18.1894 209.047 18.1894H268.332V22.0563Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M292.079 22.3322H300.221V0.620117H292.079V22.3322Z"
          fill="white"
        />
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M323.967 22.0633V0.883211C325.658 0.80939 386.742 0.909266 388.442 0.909266C403.853 0.909266 403.853 22.0633 388.442 22.0633C386.742 22.0633 325.658 22.1372 323.967 22.0633ZM332.737 4.78704V18.1856H384.941C393.425 18.1856 393.425 4.78704 384.941 4.78704H332.737Z"
          fill="white"
        />
      </svg>
    ),
    bear: (color, size, testId) => {
      const numSize = typeof size === 'number' ? size : 32;
      // Maintain aspect ratio: viewBox is 400x185, so height = width * 0.4625
      const height = Math.round(numSize * 0.4625);
      return (
        <svg
          role="img"
          data-testid={testId}
          aria-label="brand-bear"
          width={numSize}
          height={height}
          viewBox="0 0 400 185"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={color}
            d="M55.769 16.7093C55.6949 16.4529 55.6152 16.1903 55.534 15.9228C55.3451 15.3002 55.1482 14.6513 54.9957 13.9941C53.873 9.22071 56.7725 5.85205 61.6664 6.26226C66.3934 6.66107 70.1855 8.84376 73.3452 12.3287C73.9202 12.9623 74.978 13.5043 75.8166 13.5056C85.3437 13.5136 94.8417 13.1283 104.208 11.1346C110.452 9.80716 116.361 7.52752 122.088 4.77213C129.644 1.13711 137.586 0.306902 145.859 0.92399C157.532 1.78789 167.913 6.29747 178.192 11.4407C184.517 14.607 191.018 17.5168 197.659 19.9334C204.204 22.3118 211.159 22.7565 218.139 22.4985C221.082 22.3881 224.025 22.2679 226.967 22.1476L226.969 22.1476C236.472 21.7592 245.977 21.3708 255.483 21.3152C270.837 21.2275 286.124 22.1819 301.14 25.9356C313.886 29.1242 325.733 34.1362 336.159 42.2311C345.105 49.1723 352.032 57.7752 357.029 67.9318C357.538 68.9672 358.017 70.018 358.497 71.0692L358.497 71.0702L358.498 71.072C358.904 71.9626 359.31 72.8534 359.735 73.7353C360.81 75.9488 361.155 78.2343 360.481 80.6235C359.681 83.4701 359.883 85.9003 361.905 88.4511C370.441 99.1848 377.329 111.006 383.873 123.022C389.753 133.821 395.368 144.751 398.853 156.619C398.87 156.674 398.891 156.729 398.912 156.784C400.756 161.713 400.463 166.19 396.423 170.069C394.908 171.525 393.447 173.037 391.985 174.55L391.983 174.552C390.163 176.436 388.343 178.319 386.419 180.094C383.722 182.579 380.391 183.82 376.627 183.809C368.3 183.785 359.973 183.776 351.647 183.768H351.646C346.077 183.762 340.509 183.757 334.942 183.746C332.416 183.743 331.819 182.786 332.889 180.499C334.884 176.232 337.788 173.04 342.622 171.911C344.142 171.555 345.615 171.011 347.09 170.467C347.838 170.191 348.586 169.915 349.34 169.663C351.481 168.948 351.811 167.931 350.22 166.365C349.773 165.925 349.326 165.483 348.88 165.041L348.858 165.02C346.357 162.547 343.855 160.072 341.188 157.79C329.758 147.995 316.714 140.964 302.751 135.53C291.265 131.06 279.41 127.958 267.271 125.907C253.702 123.616 240.027 122.696 226.279 123.222C223.181 123.342 220.089 123.658 216.996 123.973C215.097 124.167 213.197 124.361 211.296 124.509C209.748 124.63 209.879 125.556 210.064 126.567C210.412 128.484 210.781 130.397 211.15 132.311C211.906 136.233 212.662 140.155 213.237 144.104C214.409 152.2 215.4 160.33 216.229 168.469C216.547 171.604 216.352 174.816 214.842 177.775C213.71 179.997 212.079 181.822 209.66 182.281C205.892 182.992 202.042 183.603 198.219 183.659C188.375 183.799 178.527 183.789 168.68 183.78C165.727 183.777 162.774 183.774 159.821 183.775C156.124 183.777 155.405 182.571 157.313 179.381C159.674 175.419 162.981 172.647 167.55 171.443C169.032 171.054 170.472 170.506 171.912 169.958L171.912 169.958C172.517 169.727 173.122 169.497 173.73 169.279C174.747 168.912 175.182 168.261 174.879 167.131C171.402 154.248 166.035 142.236 158.154 131.447C149.185 119.162 137.908 109.39 124.838 101.687C111.661 93.9221 97.6856 88.1498 82.4988 85.7991C79.1103 85.2743 75.6678 85.1139 72.2256 84.9535C70.6628 84.8806 69.0999 84.8078 67.5422 84.7009C66.1104 84.6018 65.3031 85.0897 65.1826 86.6936C65.0732 88.1205 64.7623 89.5671 64.2875 90.9163C63.9931 91.7513 63.361 92.8465 62.6534 93.0543C61.966 93.2567 60.7913 92.687 60.1669 92.1C54.661 86.9403 48.6467 82.5295 41.1607 80.9653C38.8032 80.4728 36.3076 80.6025 33.8236 80.7316C32.9493 80.777 32.0766 80.8224 31.2117 80.8405C29.5295 80.874 27.8472 80.9477 26.1648 81.0213L26.1641 81.0213C23.9333 81.119 21.7023 81.2166 19.4708 81.2207C17.2028 81.2263 15.9446 80.0827 15.441 78.1291C14.9758 76.3111 15.602 74.9585 17.6966 73.7597C18.9428 73.046 20.2179 72.3813 21.4935 71.7164L21.4938 71.7163C22.5204 71.1811 23.5474 70.6458 24.5597 70.0847C25.5574 69.5268 26.5331 68.8886 27.3952 68.1419C27.6708 67.9033 27.807 67.5012 27.9431 67.0992C28.0052 66.9157 28.0674 66.7322 28.1427 66.5643C27.9585 66.527 27.7688 66.4681 27.579 66.4093C27.1675 66.2817 26.7553 66.1539 26.3979 66.2449C25.4075 66.4999 24.436 66.8307 23.4641 67.1617L23.4635 67.1618C22.8535 67.3696 22.2433 67.5773 21.6282 67.7665C20.9808 67.9653 20.334 68.1681 19.687 68.371L19.6866 68.3711C17.5312 69.0471 15.3735 69.7237 13.1827 70.2547C11.8112 70.5886 10.2825 70.6735 8.89818 70.4369C7.59496 70.2136 6.12841 69.691 5.20939 68.8075C3.45912 67.1244 1.96986 65.1425 0.516389 63.18C-0.509907 61.7938 0.0542847 59.9273 1.67154 58.8403C2.92455 58.001 4.17733 57.1613 5.4301 56.3217L5.44567 56.3112C12.5116 51.5753 19.5775 46.8395 26.6848 42.1646C28.5663 40.9252 29.7558 39.4588 29.8404 37.1587C29.9396 34.3783 31.7788 32.6044 33.7557 31.1153C38.4996 27.5486 43.3107 24.051 48.2267 20.7279C49.8145 19.6523 51.5524 18.8017 53.3256 17.9338C54.1364 17.537 54.9545 17.1365 55.769 16.7093Z"
            fill="white"
          />
          <path
            className={color}
            d="M105.344 101.858C105.857 102.059 106.346 102.24 106.816 102.414C107.799 102.777 108.699 103.11 109.559 103.531C124.907 111.041 138.011 121.404 148.875 134.596C150.08 136.064 151.226 137.594 152.242 139.197C152.619 139.795 152.874 140.805 152.635 141.411C148.439 152.032 144.197 162.634 138.331 172.489C135.557 177.148 132.175 181.063 126.927 183.106C124.511 184.047 122.054 184.013 119.598 183.979C118.964 183.971 118.33 183.962 117.697 183.97C110.16 184.06 102.624 184.098 95.0892 184.137C92.0777 184.152 89.0664 184.168 86.055 184.186C85.5019 184.189 84.9488 184.194 84.3957 184.198H84.3949C82.8728 184.211 81.3515 184.223 79.8322 184.205C77.6544 184.178 76.9564 183.239 77.7547 181.226C79.208 177.567 81.4484 174.536 85.317 173.156C88.454 172.035 91.6283 171.004 94.8252 170.078C97.8565 169.202 99.9789 167.215 100.88 164.386C102.362 159.736 103.766 155.007 104.552 150.205C106.608 137.647 107.273 124.984 106.356 112.266C106.227 110.482 105.997 108.705 105.767 106.927L105.767 106.927C105.642 105.96 105.516 104.993 105.407 104.024C105.358 103.617 105.356 103.206 105.353 102.692V102.691C105.352 102.442 105.351 102.168 105.344 101.858Z"
            fill="white"
          />
          <path
            className={color}
            d="M310.552 153.065C311.384 152.057 312.219 151.044 313.064 150.027C313 149.944 312.949 149.869 312.904 149.804C312.813 149.671 312.748 149.577 312.658 149.521C312.279 149.262 311.889 149.013 311.485 148.79C302.934 144.097 293.833 140.797 284.414 138.442C279.887 137.309 275.308 136.385 270.729 135.462C268.362 134.984 265.994 134.507 263.634 134C261.594 133.561 261.469 133.619 261.256 135.624C261.132 136.795 261.01 137.966 260.888 139.137C260.49 142.954 260.092 146.771 259.617 150.577C258.974 155.683 258.084 160.78 255.473 165.299C254.632 166.752 253.213 168.133 251.725 168.883C249.547 169.983 247.109 170.73 244.7 171.203C239.354 172.248 235.989 175.582 233.546 180.157C232.6 181.921 233.335 183.385 235.341 183.622C236.217 183.723 237.106 183.717 237.99 183.712C238.144 183.711 238.297 183.71 238.45 183.709C241.906 183.705 245.362 183.697 248.818 183.689C250.55 183.685 252.281 183.681 254.012 183.677C256.062 183.674 258.111 183.673 260.16 183.671C266.292 183.667 272.423 183.662 278.555 183.615C279.38 183.61 280.214 183.349 281.027 183.095C281.15 183.056 281.273 183.018 281.395 182.981C285.637 181.691 288.493 178.551 291.31 175.452C291.508 175.234 291.707 175.016 291.905 174.799C295.603 170.751 299.164 166.574 302.722 162.4C303.353 161.661 303.983 160.921 304.614 160.183C306.611 157.843 308.57 155.468 310.552 153.065Z"
            fill="white"
          />
        </svg>
      );
    },
    'lucid-logo': (color, _size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="brand-bear"
        width="21"
        height="8"
        viewBox="0 0 21 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1563 5.70056C19.7009 5.72043 4.532 5.70349 4.07424 5.70349C2.2969 5.70349 0.967773 4.44176 0.967773 3.09V0H3.3127V3.01283C3.3127 3.95532 4.02232 4.65926 5.01782 4.65926H20.1563V5.70056Z"
          fill="white"
        />
      </svg>
    ),
  },
  privacy: {
    ccpa: (_color, _size, testId) => (
      <svg
        role="img"
        data-testid={testId}
        aria-label="privacy-ccpa"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="15"
        viewBox="0 0 30 15"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.39985 13.3002H14.1999L17.2999 1.7002H7.39985C4.19985 1.7002 1.59985 4.3002 1.59985 7.5002C1.59985 10.7002 4.19985 13.3002 7.39985 13.3002Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5999 0.5H7.3999C3.4999 0.5 0.399902 3.6 0.399902 7.5C0.399902 11.4 3.4999 14.5 7.3999 14.5H22.5999C26.4999 14.5 29.5999 11.4 29.5999 7.5C29.5999 3.6 26.3999 0.5 22.5999 0.5ZM1.5999 7.5C1.5999 4.3 4.1999 1.7 7.3999 1.7H17.2999L14.1999 13.3H7.3999C4.1999 13.3 1.5999 10.7 1.5999 7.5Z"
          fill="#0066FF"
        />
        <path
          d="M24.6 4.5001C24.8 4.7001 24.8 5.1001 24.6 5.3001L22.5 7.5001L24.7 9.7001C24.9 9.9001 24.9 10.3001 24.7 10.5001C24.5 10.7001 24.1 10.7001 23.9 10.5001L21.7 8.3001L19.5 10.5001C19.3 10.7001 18.9 10.7001 18.7 10.5001C18.5 10.3001 18.5 9.9001 18.7 9.7001L20.8 7.5001L18.6 5.3001C18.4 5.1001 18.4 4.7001 18.6 4.5001C18.8 4.3001 19.2 4.3001 19.4 4.5001L21.6 6.7001L23.8 4.5001C23.9999 4.3001 24.4 4.3001 24.6 4.5001Z"
          fill="white"
        />
        <path
          d="M12.7 4.6002C12.9 4.8002 13 5.2002 12.8 5.4002L8.6 10.3002C8.5 10.4002 8.4 10.5002 8.3 10.5002C8.1 10.6002 7.8 10.6002 7.6 10.4002L5.4 8.2002C5.2 8.0002 5.2 7.6002 5.4 7.4002C5.6 7.2002 6 7.2002 6.2 7.4002L8 9.1002L11.8 4.6002C12 4.4002 12.4 4.4002 12.7 4.6002Z"
          fill="#0066FF"
        />
      </svg>
    ),
  },
};
